/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Cursor for paging through collections */
  ConnectionCursor: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AddAssessmentsToAssessmentOriginInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type AddAssetPropertyInput = {
  address: Scalars['JSON']['input'];
  assetId: Scalars['ID']['input'];
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  constructionDate?: InputMaybe<Scalars['DateTime']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  nationalPropertyType: Scalars['String']['input'];
  parentPropertyId?: InputMaybe<Scalars['ID']['input']>;
  propertyName: Scalars['String']['input'];
  propertyObjectType: PropertyObjectType;
  propertyOwnershipType: PropertyOwnershipType;
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  saleDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum AllocationObjectType {
  ASSET = 'ASSET',
  BUILDING = 'BUILDING',
  PLOT = 'PLOT',
  TECHNICAL_FACILITY = 'TECHNICAL_FACILITY',
  UNIT = 'UNIT'
}

export type Assessment = {
  __typename?: 'Assessment';
  aggregation?: Maybe<AssessmentAggregation>;
  areaData?: Maybe<AssessmentArea>;
  assessmentMetadata: AssessmentMetadata;
  bestEffortPriority?: Maybe<Scalars['Float']['output']>;
  calculatedEmission?: Maybe<Scalars['Float']['output']>;
  calculatedEmissionGrams?: Maybe<Scalars['Float']['output']>;
  category: AssessmentCategory;
  consumption: Scalars['Float']['output'];
  consumptionData: AssessmentConsumption;
  consumptionType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  data?: Maybe<AssessmentData>;
  emissionBreakdown?: Maybe<AssessmentEmissionBreakdown>;
  emissionData?: Maybe<AssessmentEmission>;
  emissionDataGrams?: Maybe<AssessmentEmission>;
  energyBreakdown?: Maybe<AssessmentEmissionBreakdown>;
  entityId: Scalars['ID']['output'];
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  integration?: Maybe<LocationIntegration>;
  integrationId?: Maybe<Scalars['String']['output']>;
  isEditable: Scalars['Boolean']['output'];
  isProjected?: Maybe<Scalars['Boolean']['output']>;
  locationId: Scalars['String']['output'];
  origin?: Maybe<AssessmentOrigin>;
  originalFrom?: Maybe<Scalars['DateTime']['output']>;
  originalTo?: Maybe<Scalars['DateTime']['output']>;
  ownedBuildingConsumptionPercentage?: Maybe<Scalars['Float']['output']>;
  ownershipType?: Maybe<PropertyOwnershipType>;
  parent?: Maybe<Assessment>;
  parentId?: Maybe<Scalars['ID']['output']>;
  property?: Maybe<Property>;
  source?: Maybe<Scalars['String']['output']>;
  to: Scalars['DateTime']['output'];
  totalBuildingSqm?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EmissionUnit>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  vertical?: Maybe<AssessmentVertical>;
};

export enum AssessmentAggregation {
  DAY = 'Day',
  MONTH = 'Month',
  YEAR = 'Year'
}

export type AssessmentArea = {
  __typename?: 'AssessmentArea';
  assetArea?: Maybe<Scalars['Float']['output']>;
  buildingArea?: Maybe<Scalars['Float']['output']>;
  ownedArea?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
};

export enum AssessmentCategory {
  CAPITAL_GOODS = 'CAPITAL_GOODS',
  COOLING_REMOTE = 'COOLING_REMOTE',
  ELECTRICITY_GENERATED = 'ELECTRICITY_GENERATED',
  ELECTRICITY_REMOTE = 'ELECTRICITY_REMOTE',
  ENERGY_COMBINED = 'ENERGY_COMBINED',
  HEATING_GENERATED = 'HEATING_GENERATED',
  HEATING_REMOTE = 'HEATING_REMOTE',
  PURCHASED_GOODS_OTHER = 'PURCHASED_GOODS_OTHER',
  TRANSPORT_BUSINESS_TRAVEL = 'TRANSPORT_BUSINESS_TRAVEL',
  TRANSPORT_EMPLOYEE_COMMUTING = 'TRANSPORT_EMPLOYEE_COMMUTING',
  TRANSPORT_INTERNAL = 'TRANSPORT_INTERNAL',
  UNCATEGORIZED = 'UNCATEGORIZED',
  WASTE = 'WASTE',
  WATER = 'WATER'
}

export type AssessmentCategoryFilterComparison = {
  eq?: InputMaybe<AssessmentCategory>;
  gt?: InputMaybe<AssessmentCategory>;
  gte?: InputMaybe<AssessmentCategory>;
  iLike?: InputMaybe<AssessmentCategory>;
  in?: InputMaybe<Array<AssessmentCategory>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<AssessmentCategory>;
  lt?: InputMaybe<AssessmentCategory>;
  lte?: InputMaybe<AssessmentCategory>;
  neq?: InputMaybe<AssessmentCategory>;
  notILike?: InputMaybe<AssessmentCategory>;
  notIn?: InputMaybe<Array<AssessmentCategory>>;
  notLike?: InputMaybe<AssessmentCategory>;
};

export type AssessmentConnection = {
  __typename?: 'AssessmentConnection';
  /** Array of edges. */
  edges: Array<AssessmentEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AssessmentConsumption = {
  __typename?: 'AssessmentConsumption';
  assetConsumption: Scalars['Float']['output'];
  assetConsumptionPercentage?: Maybe<Scalars['Float']['output']>;
  buildingConsumption: Scalars['Float']['output'];
  buildingConsumptionPercentage?: Maybe<Scalars['Float']['output']>;
  ownedConsumption: Scalars['Float']['output'];
  ownedConsumptionPercentage?: Maybe<Scalars['Float']['output']>;
  totalConsumption: Scalars['Float']['output'];
};

export type AssessmentData = IntegrationDexmaAssessmentData | IntegrationElectralinkAssessmentData | IntegrationEpcAssessmentData | IntegrationEpcUkAssessmentData | IntegrationHoforAssessmentData | IntegrationOisAssessmentData | IntegrationTechemAssessmentData | IntegrationVitaniAssessmentData | ManualAssessmentData;

export enum AssessmentDataType {
  ACTUAL = 'ACTUAL',
  COMBINED = 'COMBINED',
  ESTIMATE = 'ESTIMATE'
}

export type AssessmentDataTypeFilterComparison = {
  eq?: InputMaybe<AssessmentDataType>;
  gt?: InputMaybe<AssessmentDataType>;
  gte?: InputMaybe<AssessmentDataType>;
  iLike?: InputMaybe<AssessmentDataType>;
  in?: InputMaybe<Array<AssessmentDataType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<AssessmentDataType>;
  lt?: InputMaybe<AssessmentDataType>;
  lte?: InputMaybe<AssessmentDataType>;
  neq?: InputMaybe<AssessmentDataType>;
  notILike?: InputMaybe<AssessmentDataType>;
  notIn?: InputMaybe<Array<AssessmentDataType>>;
  notLike?: InputMaybe<AssessmentDataType>;
};

export type AssessmentDeleteFilter = {
  and?: InputMaybe<Array<AssessmentDeleteFilter>>;
  bestEffortPriority?: InputMaybe<NumberFieldComparison>;
  category?: InputMaybe<AssessmentCategoryFilterComparison>;
  consumption?: InputMaybe<NumberFieldComparison>;
  consumptionType?: InputMaybe<StringFieldComparison>;
  entityId?: InputMaybe<IdFilterComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  integrationId?: InputMaybe<StringFieldComparison>;
  locationId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssessmentDeleteFilter>>;
  ownedBuildingConsumptionPercentage?: InputMaybe<NumberFieldComparison>;
  parentId?: InputMaybe<IdFilterComparison>;
  source?: InputMaybe<StringFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  totalBuildingSqm?: InputMaybe<NumberFieldComparison>;
};

export type AssessmentDeleteResponse = {
  __typename?: 'AssessmentDeleteResponse';
  aggregation?: Maybe<AssessmentAggregation>;
  bestEffortPriority?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<AssessmentCategory>;
  consumption?: Maybe<Scalars['Float']['output']>;
  consumptionType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  integrationId?: Maybe<Scalars['String']['output']>;
  isProjected?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  originalFrom?: Maybe<Scalars['DateTime']['output']>;
  originalTo?: Maybe<Scalars['DateTime']['output']>;
  ownedBuildingConsumptionPercentage?: Maybe<Scalars['Float']['output']>;
  ownershipType?: Maybe<PropertyOwnershipType>;
  parentId?: Maybe<Scalars['ID']['output']>;
  property?: Maybe<Property>;
  source?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  totalBuildingSqm?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<EmissionUnit>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AssessmentEdge = {
  __typename?: 'AssessmentEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Assessment */
  node: Assessment;
};

export type AssessmentEmission = {
  __typename?: 'AssessmentEmission';
  assetEmission?: Maybe<Scalars['Float']['output']>;
  buildingEmission?: Maybe<Scalars['Float']['output']>;
  ownedEmission?: Maybe<Scalars['Float']['output']>;
  totalEmission?: Maybe<Scalars['Float']['output']>;
};

export type AssessmentEmissionBreakdown = {
  __typename?: 'AssessmentEmissionBreakdown';
  breakdown: Array<AssessmentEmissionBreakdownItem>;
  consumption: AssessmentConsumption;
  emission: AssessmentEmission;
};

export type AssessmentEmissionBreakdownItem = {
  __typename?: 'AssessmentEmissionBreakdownItem';
  consumption: AssessmentConsumption;
  emission: AssessmentEmission;
  emissionFactor: EmissionFactor;
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
};

export type AssessmentEnergy = {
  __typename?: 'AssessmentEnergy';
  assetEnergy?: Maybe<Scalars['Float']['output']>;
  buildingEnergy?: Maybe<Scalars['Float']['output']>;
  ownedEnergy?: Maybe<Scalars['Float']['output']>;
  totalEnergy?: Maybe<Scalars['Float']['output']>;
};

export type AssessmentFilter = {
  and?: InputMaybe<Array<AssessmentFilter>>;
  bestEffortPriority?: InputMaybe<NumberFieldComparison>;
  category?: InputMaybe<AssessmentCategoryFilterComparison>;
  consumption?: InputMaybe<NumberFieldComparison>;
  consumptionType?: InputMaybe<StringFieldComparison>;
  createdBy?: InputMaybe<AssessmentFilterUserFilter>;
  entityId?: InputMaybe<IdFilterComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  integrationId?: InputMaybe<StringFieldComparison>;
  locationId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssessmentFilter>>;
  ownedBuildingConsumptionPercentage?: InputMaybe<NumberFieldComparison>;
  parentId?: InputMaybe<IdFilterComparison>;
  source?: InputMaybe<StringFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  totalBuildingSqm?: InputMaybe<NumberFieldComparison>;
  updatedBy?: InputMaybe<AssessmentFilterUserFilter>;
};

export type AssessmentFilterUserFilter = {
  and?: InputMaybe<Array<AssessmentFilterUserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssessmentFilterUserFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type AssessmentMetadata = {
  __typename?: 'AssessmentMetadata';
  addresses?: Maybe<Array<Scalars['String']['output']>>;
  nationalBuildingIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type AssessmentOrigin = {
  __typename?: 'AssessmentOrigin';
  assessmentType?: Maybe<AssessmentDataType>;
  assessments: Array<Assessment>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  entityId: Scalars['ID']['output'];
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};


export type AssessmentOriginAssessmentsArgs = {
  filter?: AssessmentFilter;
  sorting?: Array<AssessmentSort>;
};

export type AssessmentOriginConnection = {
  __typename?: 'AssessmentOriginConnection';
  /** Array of edges. */
  edges: Array<AssessmentOriginEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AssessmentOriginDeleteFilter = {
  and?: InputMaybe<Array<AssessmentOriginDeleteFilter>>;
  entityId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AssessmentOriginDeleteFilter>>;
};

export type AssessmentOriginDeleteResponse = {
  __typename?: 'AssessmentOriginDeleteResponse';
  assessmentType?: Maybe<AssessmentDataType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AssessmentOriginEdge = {
  __typename?: 'AssessmentOriginEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AssessmentOrigin */
  node: AssessmentOrigin;
};

export type AssessmentOriginFilter = {
  and?: InputMaybe<Array<AssessmentOriginFilter>>;
  assessments?: InputMaybe<AssessmentOriginFilterAssessmentFilter>;
  createdBy?: InputMaybe<AssessmentOriginFilterUserFilter>;
  entityId?: InputMaybe<IdFilterComparison>;
  file?: InputMaybe<AssessmentOriginFilterFileFilter>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AssessmentOriginFilter>>;
  updatedBy?: InputMaybe<AssessmentOriginFilterUserFilter>;
};

export type AssessmentOriginFilterAssessmentFilter = {
  and?: InputMaybe<Array<AssessmentOriginFilterAssessmentFilter>>;
  bestEffortPriority?: InputMaybe<NumberFieldComparison>;
  category?: InputMaybe<AssessmentCategoryFilterComparison>;
  consumption?: InputMaybe<NumberFieldComparison>;
  consumptionType?: InputMaybe<StringFieldComparison>;
  entityId?: InputMaybe<IdFilterComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  integrationId?: InputMaybe<StringFieldComparison>;
  locationId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssessmentOriginFilterAssessmentFilter>>;
  ownedBuildingConsumptionPercentage?: InputMaybe<NumberFieldComparison>;
  parentId?: InputMaybe<IdFilterComparison>;
  source?: InputMaybe<StringFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  totalBuildingSqm?: InputMaybe<NumberFieldComparison>;
};

export type AssessmentOriginFilterFileFilter = {
  and?: InputMaybe<Array<AssessmentOriginFilterFileFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  mime?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssessmentOriginFilterFileFilter>>;
};

export type AssessmentOriginFilterUserFilter = {
  and?: InputMaybe<Array<AssessmentOriginFilterUserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssessmentOriginFilterUserFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type AssessmentOriginSort = {
  direction: SortDirection;
  field: AssessmentOriginSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AssessmentOriginSortFields {
  ENTITYID = 'entityId',
  ID = 'id'
}

export type AssessmentOriginUpdateFilter = {
  and?: InputMaybe<Array<AssessmentOriginUpdateFilter>>;
  entityId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AssessmentOriginUpdateFilter>>;
};

export type AssessmentQueryFilter = {
  dataType: AssessmentDataType;
  ignoreManual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssessmentSort = {
  direction: SortDirection;
  field: AssessmentSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AssessmentSortFields {
  BESTEFFORTPRIORITY = 'bestEffortPriority',
  CATEGORY = 'category',
  CONSUMPTION = 'consumption',
  CONSUMPTIONTYPE = 'consumptionType',
  ENTITYID = 'entityId',
  FROM = 'from',
  ID = 'id',
  INTEGRATIONID = 'integrationId',
  LOCATIONID = 'locationId',
  OWNEDBUILDINGCONSUMPTIONPERCENTAGE = 'ownedBuildingConsumptionPercentage',
  PARENTID = 'parentId',
  SOURCE = 'source',
  TO = 'to',
  TOTALBUILDINGSQM = 'totalBuildingSqm'
}

export type AssessmentSummary = {
  __typename?: 'AssessmentSummary';
  emissionData: EmissionData;
  emissionDataGrams: EmissionData;
  epcData: Array<EpcData>;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sources: Array<Scalars['String']['output']>;
  to: Scalars['DateTime']['output'];
  vertical: AssessmentVertical;
};

export type AssessmentSummaryFilter = {
  and?: InputMaybe<Array<AssessmentSummaryFilter>>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AssessmentSummaryFilter>>;
  to?: InputMaybe<DateFieldComparison>;
};

export type AssessmentSummarySort = {
  direction: SortDirection;
  field: AssessmentSummarySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AssessmentSummarySortFields {
  FROM = 'from',
  ID = 'id',
  TO = 'to'
}

export type AssessmentUpdateFilter = {
  and?: InputMaybe<Array<AssessmentUpdateFilter>>;
  bestEffortPriority?: InputMaybe<NumberFieldComparison>;
  category?: InputMaybe<AssessmentCategoryFilterComparison>;
  consumption?: InputMaybe<NumberFieldComparison>;
  consumptionType?: InputMaybe<StringFieldComparison>;
  entityId?: InputMaybe<IdFilterComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  integrationId?: InputMaybe<StringFieldComparison>;
  locationId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssessmentUpdateFilter>>;
  ownedBuildingConsumptionPercentage?: InputMaybe<NumberFieldComparison>;
  parentId?: InputMaybe<IdFilterComparison>;
  source?: InputMaybe<StringFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  totalBuildingSqm?: InputMaybe<NumberFieldComparison>;
};

export enum AssessmentVertical {
  COOLING = 'COOLING',
  ELECTRICITY = 'ELECTRICITY',
  ENERGY = 'ENERGY',
  HEATING = 'HEATING',
  MATERIALS = 'MATERIALS',
  TRANSPORT = 'TRANSPORT',
  UN_CATEGORIZED = 'UN_CATEGORIZED',
  WASTE = 'WASTE',
  WATER = 'WATER'
}

export type AssessmentsCoverage = {
  __typename?: 'AssessmentsCoverage';
  assessments: Array<Assessment>;
  maxHighPriority: Scalars['Float']['output'];
  maxMediumPriority: Scalars['Float']['output'];
  vertical: AssessmentVertical;
};

export type AssetAlertData = EpcExpiresSoonAlertData | MissingMeterDataAlertData;

export enum AssetAlertFlag {
  DATA_GAPS_IN_YEAR = 'DATA_GAPS_IN_YEAR',
  DUPLICATED_EPC = 'DUPLICATED_EPC',
  EPC_EXPIRED_IN_CURRENT_YEAR = 'EPC_EXPIRED_IN_CURRENT_YEAR',
  EPC_EXPIRES_SOON = 'EPC_EXPIRES_SOON',
  MISSING_METER_DATA = 'MISSING_METER_DATA'
}

export type AssetAlertFlagFilterComparison = {
  eq?: InputMaybe<AssetAlertFlag>;
  gt?: InputMaybe<AssetAlertFlag>;
  gte?: InputMaybe<AssetAlertFlag>;
  iLike?: InputMaybe<AssetAlertFlag>;
  in?: InputMaybe<Array<AssetAlertFlag>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<AssetAlertFlag>;
  lt?: InputMaybe<AssetAlertFlag>;
  lte?: InputMaybe<AssetAlertFlag>;
  neq?: InputMaybe<AssetAlertFlag>;
  notILike?: InputMaybe<AssetAlertFlag>;
  notIn?: InputMaybe<Array<AssetAlertFlag>>;
  notLike?: InputMaybe<AssetAlertFlag>;
};

export type AssetGroup = {
  __typename?: 'AssetGroup';
  assets: Array<Location>;
  assetsAggregate: Array<AssetGroupAssetsAggregateResponse>;
  filters: Array<AssetGroupFilterQuery>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type AssetGroupAssetsArgs = {
  filter?: LocationFilter;
  sorting?: Array<LocationSort>;
};


export type AssetGroupAssetsAggregateArgs = {
  filter?: InputMaybe<LocationAggregateFilter>;
};

export type AssetGroupAssetsAggregateGroupBy = {
  __typename?: 'AssetGroupAssetsAggregateGroupBy';
  assetGroupId?: Maybe<Scalars['String']['output']>;
  benchmarkId?: Maybe<Scalars['ID']['output']>;
  constructionDate?: Maybe<Scalars['DateTime']['output']>;
  dataType?: Maybe<AssessmentDataType>;
  displayName?: Maybe<Scalars['String']['output']>;
  emissionIntensitySort?: Maybe<Scalars['Boolean']['output']>;
  emissionSort?: Maybe<Scalars['Boolean']['output']>;
  energyIntensitySort?: Maybe<Scalars['Boolean']['output']>;
  energySort?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalDescriptor?: Maybe<Scalars['String']['output']>;
  legalOwner?: Maybe<Scalars['String']['output']>;
  management?: Maybe<LocationManagementType>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<Scalars['Float']['output']>;
  ownershipType?: Maybe<Scalars['String']['output']>;
  performance?: Maybe<Scalars['Float']['output']>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  saleDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AssetGroupAssetsAggregateResponse = {
  __typename?: 'AssetGroupAssetsAggregateResponse';
  avg?: Maybe<AssetGroupAssetsAvgAggregate>;
  count?: Maybe<AssetGroupAssetsCountAggregate>;
  groupBy?: Maybe<AssetGroupAssetsAggregateGroupBy>;
  max?: Maybe<AssetGroupAssetsMaxAggregate>;
  min?: Maybe<AssetGroupAssetsMinAggregate>;
  sum?: Maybe<AssetGroupAssetsSumAggregate>;
};

export type AssetGroupAssetsAvgAggregate = {
  __typename?: 'AssetGroupAssetsAvgAggregate';
  ownership?: Maybe<Scalars['Float']['output']>;
};

export type AssetGroupAssetsCountAggregate = {
  __typename?: 'AssetGroupAssetsCountAggregate';
  assetGroupId?: Maybe<Scalars['Int']['output']>;
  benchmarkId?: Maybe<Scalars['Int']['output']>;
  constructionDate?: Maybe<Scalars['Int']['output']>;
  dataType?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['Int']['output']>;
  emissionIntensitySort?: Maybe<Scalars['Int']['output']>;
  emissionSort?: Maybe<Scalars['Int']['output']>;
  energyIntensitySort?: Maybe<Scalars['Int']['output']>;
  energySort?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  internalDescriptor?: Maybe<Scalars['Int']['output']>;
  legalOwner?: Maybe<Scalars['Int']['output']>;
  management?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  ownership?: Maybe<Scalars['Int']['output']>;
  ownershipType?: Maybe<Scalars['Int']['output']>;
  performance?: Maybe<Scalars['Int']['output']>;
  purchaseDate?: Maybe<Scalars['Int']['output']>;
  saleDate?: Maybe<Scalars['Int']['output']>;
};

export type AssetGroupAssetsMaxAggregate = {
  __typename?: 'AssetGroupAssetsMaxAggregate';
  assetGroupId?: Maybe<Scalars['String']['output']>;
  benchmarkId?: Maybe<Scalars['ID']['output']>;
  constructionDate?: Maybe<Scalars['DateTime']['output']>;
  dataType?: Maybe<AssessmentDataType>;
  displayName?: Maybe<Scalars['String']['output']>;
  emissionIntensitySort?: Maybe<Scalars['Boolean']['output']>;
  emissionSort?: Maybe<Scalars['Boolean']['output']>;
  energyIntensitySort?: Maybe<Scalars['Boolean']['output']>;
  energySort?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalDescriptor?: Maybe<Scalars['String']['output']>;
  legalOwner?: Maybe<Scalars['String']['output']>;
  management?: Maybe<LocationManagementType>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<Scalars['Float']['output']>;
  ownershipType?: Maybe<Scalars['String']['output']>;
  performance?: Maybe<Scalars['Float']['output']>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  saleDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AssetGroupAssetsMinAggregate = {
  __typename?: 'AssetGroupAssetsMinAggregate';
  assetGroupId?: Maybe<Scalars['String']['output']>;
  benchmarkId?: Maybe<Scalars['ID']['output']>;
  constructionDate?: Maybe<Scalars['DateTime']['output']>;
  dataType?: Maybe<AssessmentDataType>;
  displayName?: Maybe<Scalars['String']['output']>;
  emissionIntensitySort?: Maybe<Scalars['Boolean']['output']>;
  emissionSort?: Maybe<Scalars['Boolean']['output']>;
  energyIntensitySort?: Maybe<Scalars['Boolean']['output']>;
  energySort?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalDescriptor?: Maybe<Scalars['String']['output']>;
  legalOwner?: Maybe<Scalars['String']['output']>;
  management?: Maybe<LocationManagementType>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<Scalars['Float']['output']>;
  ownershipType?: Maybe<Scalars['String']['output']>;
  performance?: Maybe<Scalars['Float']['output']>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  saleDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AssetGroupAssetsSumAggregate = {
  __typename?: 'AssetGroupAssetsSumAggregate';
  ownership?: Maybe<Scalars['Float']['output']>;
};

export type AssetGroupConnection = {
  __typename?: 'AssetGroupConnection';
  /** Array of edges. */
  edges: Array<AssetGroupEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AssetGroupDeleteFilter = {
  and?: InputMaybe<Array<AssetGroupDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssetGroupDeleteFilter>>;
};

export type AssetGroupDeleteResponse = {
  __typename?: 'AssetGroupDeleteResponse';
  filters?: Maybe<Array<AssetGroupFilterQuery>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AssetGroupEdge = {
  __typename?: 'AssetGroupEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AssetGroup */
  node: AssetGroup;
};

export type AssetGroupFilter = {
  and?: InputMaybe<Array<AssetGroupFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssetGroupFilter>>;
};

export enum AssetGroupFilterCategory {
  CRREMPROPERTYTYPES = 'CRREMPropertyTypes',
  CITY = 'City',
  CONSTRUCTIONYEAR = 'ConstructionYear',
  COUNTRY = 'Country',
  GENERALPROPERTYTYPES = 'GeneralPropertyTypes',
  ID = 'ID',
  LEGALOWNER = 'LegalOwner',
  NATIONALPROPERTYTYPES = 'NationalPropertyTypes',
  PROPERTYSIZE = 'PropertySize'
}

export type AssetGroupFilterInput = {
  category: AssetGroupFilterCategory;
  values: Array<Scalars['String']['input']>;
};

export type AssetGroupFilterQuery = {
  __typename?: 'AssetGroupFilterQuery';
  category: AssetGroupFilterCategory;
  values: Array<Scalars['String']['output']>;
};

export type AssetGroupSort = {
  direction: SortDirection;
  field: AssetGroupSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AssetGroupSortFields {
  ID = 'id',
  NAME = 'name'
}

export type AssetGroupUpdateFilter = {
  and?: InputMaybe<Array<AssetGroupUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AssetGroupUpdateFilter>>;
};

export type AssetIntegrationAllocation = {
  __typename?: 'AssetIntegrationAllocation';
  assetId?: Maybe<Scalars['ID']['output']>;
  assetIntegration: LocationIntegration;
  id: Scalars['ID']['output'];
  percentage: Scalars['Float']['output'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']['output']>;
};

export type AssetIntegrationAllocationEdge = {
  __typename?: 'AssetIntegrationAllocationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AssetIntegrationAllocation */
  node: AssetIntegrationAllocation;
};

export type AssetIntegrationAllocationFilter = {
  and?: InputMaybe<Array<AssetIntegrationAllocationFilter>>;
  assetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AssetIntegrationAllocationFilter>>;
  percentage?: InputMaybe<NumberFieldComparison>;
  property?: InputMaybe<AssetIntegrationAllocationFilterPropertyFilter>;
  propertyId?: InputMaybe<IdFilterComparison>;
};

export type AssetIntegrationAllocationFilterPropertyFilter = {
  and?: InputMaybe<Array<AssetIntegrationAllocationFilterPropertyFilter>>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AssetIntegrationAllocationFilterPropertyFilter>>;
  purchaseDate?: InputMaybe<DateFieldComparison>;
  saleDate?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type AssetIntegrationAllocationInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  percentage: Scalars['Float']['input'];
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type AssetIntegrationAllocationSort = {
  direction: SortDirection;
  field: AssetIntegrationAllocationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AssetIntegrationAllocationSortFields {
  ASSETID = 'assetId',
  ID = 'id',
  PERCENTAGE = 'percentage',
  PROPERTYID = 'propertyId'
}

export type AssetIntegrationInput = {
  data: Scalars['JSON']['input'];
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  originId: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: IntegrationType;
};

export type AssetRiskChartData = {
  __typename?: 'AssetRiskChartData';
  propertyId: Scalars['String']['output'];
  summary: Array<InsightIntensityChartData>;
};

export type AssetSimpleInventoryHeader = {
  __typename?: 'AssetSimpleInventoryHeader';
  columnStyle?: Maybe<ReportStyle>;
  header: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export enum BbrMappingType {
  BYGNING = 'Bygning',
  ENHED = 'Enhed',
  GRUND = 'Grund',
  TEKNISKANLAEG = 'TekniskAnlaeg'
}

export type Benchmark = {
  __typename?: 'Benchmark';
  countryCode?: Maybe<Scalars['String']['output']>;
  emissionPerArea: BenchmarkDetails;
  id: Scalars['ID']['output'];
  type: BenchmarkType;
};

export type BenchmarkConnection = {
  __typename?: 'BenchmarkConnection';
  /** Array of edges. */
  edges: Array<BenchmarkEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type BenchmarkDataDetails = {
  __typename?: 'BenchmarkDataDetails';
  benchmark?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkDataDetailsInput = {
  benchmark?: InputMaybe<Scalars['Float']['input']>;
};

export type BenchmarkDetails = {
  __typename?: 'BenchmarkDetails';
  bestEffort: BenchmarkDataDetails;
  epc: BenchmarkDataDetails;
  meter: BenchmarkDataDetails;
};

export type BenchmarkDetailsInput = {
  bestEffort: BenchmarkDataDetailsInput;
  epc: BenchmarkDataDetailsInput;
  meter: BenchmarkDataDetailsInput;
};

export type BenchmarkEdge = {
  __typename?: 'BenchmarkEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Benchmark */
  node: Benchmark;
};

export type BenchmarkFilter = {
  and?: InputMaybe<Array<BenchmarkFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<BenchmarkFilter>>;
  type?: InputMaybe<BenchmarkTypeFilterComparison>;
};

export type BenchmarkPerformance = {
  __typename?: 'BenchmarkPerformance';
  benchmarkId: Scalars['ID']['output'];
  benchmarkType?: Maybe<Scalars['String']['output']>;
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  ownedEmission: Scalars['Float']['output'];
  performance: Scalars['Float']['output'];
  to: Scalars['DateTime']['output'];
};

export type BenchmarkPerformanceFilter = {
  and?: InputMaybe<Array<BenchmarkPerformanceFilter>>;
  benchmarkId?: InputMaybe<IdFilterComparison>;
  dataType?: InputMaybe<AssessmentDataTypeFilterComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  locationId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<BenchmarkPerformanceFilter>>;
  to?: InputMaybe<DateFieldComparison>;
};

export type BenchmarkPerformanceSort = {
  direction: SortDirection;
  field: BenchmarkPerformanceSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum BenchmarkPerformanceSortFields {
  BENCHMARKID = 'benchmarkId',
  DATATYPE = 'dataType',
  FROM = 'from',
  ID = 'id',
  LOCATIONID = 'locationId',
  TO = 'to'
}

export type BenchmarkSort = {
  direction: SortDirection;
  field: BenchmarkSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum BenchmarkSortFields {
  ID = 'id',
  TYPE = 'type'
}

export enum BenchmarkType {
  BASELINE = 'BASELINE',
  MARKET = 'MARKET'
}

export type BenchmarkTypeFilterComparison = {
  eq?: InputMaybe<BenchmarkType>;
  gt?: InputMaybe<BenchmarkType>;
  gte?: InputMaybe<BenchmarkType>;
  iLike?: InputMaybe<BenchmarkType>;
  in?: InputMaybe<Array<BenchmarkType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<BenchmarkType>;
  lt?: InputMaybe<BenchmarkType>;
  lte?: InputMaybe<BenchmarkType>;
  neq?: InputMaybe<BenchmarkType>;
  notILike?: InputMaybe<BenchmarkType>;
  notIn?: InputMaybe<Array<BenchmarkType>>;
  notLike?: InputMaybe<BenchmarkType>;
};

export enum BenchmarkValueUnit {
  CO2_KG = 'CO2_KG',
  KWH = 'KWH'
}

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrremPathway = {
  __typename?: 'CRREMPathway';
  color: Scalars['String']['output'];
  country: Scalars['String']['output'];
  crremCategory: CrremCategory;
  target: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  version: Scalars['String']['output'];
  year: Scalars['Float']['output'];
};

export type CrremPathwayConnection = {
  __typename?: 'CRREMPathwayConnection';
  /** Array of edges. */
  edges: Array<CrremPathwayEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type CrremPathwayDeleteFilter = {
  and?: InputMaybe<Array<CrremPathwayDeleteFilter>>;
  country?: InputMaybe<StringFieldComparison>;
  crremCategory?: InputMaybe<CrremCategoryFilterComparison>;
  or?: InputMaybe<Array<CrremPathwayDeleteFilter>>;
  year?: InputMaybe<NumberFieldComparison>;
};

export type CrremPathwayDeleteResponse = {
  __typename?: 'CRREMPathwayDeleteResponse';
  color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  crremCategory?: Maybe<CrremCategory>;
  target?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type CrremPathwayEdge = {
  __typename?: 'CRREMPathwayEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CRREMPathway */
  node: CrremPathway;
};

export type CrremPathwayFilter = {
  and?: InputMaybe<Array<CrremPathwayFilter>>;
  country?: InputMaybe<StringFieldComparison>;
  crremCategory?: InputMaybe<CrremCategoryFilterComparison>;
  or?: InputMaybe<Array<CrremPathwayFilter>>;
  year?: InputMaybe<NumberFieldComparison>;
};

export type CrremPathwaySort = {
  direction: SortDirection;
  field: CrremPathwaySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CrremPathwaySortFields {
  COUNTRY = 'country',
  CRREMCATEGORY = 'crremCategory',
  YEAR = 'year'
}

export type CrremPathwayUpdateFilter = {
  and?: InputMaybe<Array<CrremPathwayUpdateFilter>>;
  country?: InputMaybe<StringFieldComparison>;
  crremCategory?: InputMaybe<CrremCategoryFilterComparison>;
  or?: InputMaybe<Array<CrremPathwayUpdateFilter>>;
  year?: InputMaybe<NumberFieldComparison>;
};

export enum CalculationMethod {
  ACTIVITY_BASED = 'ACTIVITY_BASED',
  AR4 = 'AR4',
  AR5 = 'AR5',
  AR6 = 'AR6',
  PERCENTAGE_125 = 'PERCENTAGE_125',
  PERCENTAGE_200 = 'PERCENTAGE_200',
  SPEND_BASED = 'SPEND_BASED'
}

export type CalculationMethodFilterComparison = {
  eq?: InputMaybe<CalculationMethod>;
  gt?: InputMaybe<CalculationMethod>;
  gte?: InputMaybe<CalculationMethod>;
  iLike?: InputMaybe<CalculationMethod>;
  in?: InputMaybe<Array<CalculationMethod>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<CalculationMethod>;
  lt?: InputMaybe<CalculationMethod>;
  lte?: InputMaybe<CalculationMethod>;
  neq?: InputMaybe<CalculationMethod>;
  notILike?: InputMaybe<CalculationMethod>;
  notIn?: InputMaybe<Array<CalculationMethod>>;
  notLike?: InputMaybe<CalculationMethod>;
};

export type ChangeLog = {
  __typename?: 'ChangeLog';
  eventCreatedAt: Scalars['DateTime']['output'];
  eventPayload: ChangeLogEventPayload;
  eventType: ChangeLogEventType;
  id: Scalars['ID']['output'];
  organization: Organization;
  recordId: Scalars['String']['output'];
  recordLabels: Array<ChangeLogLabel>;
  updatedBy?: Maybe<User>;
};

export type ChangeLogConnection = {
  __typename?: 'ChangeLogConnection';
  /** Array of edges. */
  edges: Array<ChangeLogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ChangeLogEdge = {
  __typename?: 'ChangeLogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ChangeLog */
  node: ChangeLog;
};

export type ChangeLogEventPayload = {
  __typename?: 'ChangeLogEventPayload';
  changes: Array<UpdatedFields>;
  eventType: Scalars['String']['output'];
  user: ChangeLogUser;
};

export enum ChangeLogEventType {
  ASSET_CREATED = 'ASSET_CREATED',
  ASSET_UPDATED = 'ASSET_UPDATED',
  PROPERTY_CREATED = 'PROPERTY_CREATED',
  PROPERTY_DELETED = 'PROPERTY_DELETED',
  PROPERTY_UPDATED = 'PROPERTY_UPDATED'
}

export type ChangeLogEventTypeFilterComparison = {
  eq?: InputMaybe<ChangeLogEventType>;
  gt?: InputMaybe<ChangeLogEventType>;
  gte?: InputMaybe<ChangeLogEventType>;
  iLike?: InputMaybe<ChangeLogEventType>;
  in?: InputMaybe<Array<ChangeLogEventType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ChangeLogEventType>;
  lt?: InputMaybe<ChangeLogEventType>;
  lte?: InputMaybe<ChangeLogEventType>;
  neq?: InputMaybe<ChangeLogEventType>;
  notILike?: InputMaybe<ChangeLogEventType>;
  notIn?: InputMaybe<Array<ChangeLogEventType>>;
  notLike?: InputMaybe<ChangeLogEventType>;
};

export type ChangeLogFilter = {
  and?: InputMaybe<Array<ChangeLogFilter>>;
  eventCreatedAt?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<ChangeLogEventTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ChangeLogFilter>>;
  organization?: InputMaybe<ChangeLogFilterOrganizationFilter>;
  recordId?: InputMaybe<StringFieldComparison>;
  updatedBy?: InputMaybe<ChangeLogFilterUserFilter>;
};

export type ChangeLogFilterOrganizationFilter = {
  and?: InputMaybe<Array<ChangeLogFilterOrganizationFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ChangeLogFilterOrganizationFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
};

export type ChangeLogFilterUserFilter = {
  and?: InputMaybe<Array<ChangeLogFilterUserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ChangeLogFilterUserFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type ChangeLogLabel = {
  __typename?: 'ChangeLogLabel';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ChangeLogSort = {
  direction: SortDirection;
  field: ChangeLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ChangeLogSortFields {
  EVENTCREATEDAT = 'eventCreatedAt',
  EVENTTYPE = 'eventType',
  ID = 'id',
  RECORDID = 'recordId'
}

export type ChangeLogUser = {
  __typename?: 'ChangeLogUser';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ConsumptionBreakdownItem = {
  __typename?: 'ConsumptionBreakdownItem';
  consumption: Scalars['Float']['output'];
  consumptionType: ConsumptionType;
  emission: Scalars['Float']['output'];
  from: Scalars['DateTime']['output'];
  ownershipType: PropertyOwnershipType;
  to: Scalars['DateTime']['output'];
  vertical: AssessmentVertical;
};

export enum ConsumptionType {
  EMISSION = 'EMISSION',
  ENERGY = 'ENERGY',
  ENERGY_COOLING = 'ENERGY_COOLING',
  ENERGY_COOLING_REMOTE = 'ENERGY_COOLING_REMOTE',
  ENERGY_ELECTRICITY = 'ENERGY_ELECTRICITY',
  ENERGY_ELECTRICITY_COAL = 'ENERGY_ELECTRICITY_COAL',
  ENERGY_ELECTRICITY_NUCLEAR = 'ENERGY_ELECTRICITY_NUCLEAR',
  ENERGY_ELECTRICITY_SOLAR = 'ENERGY_ELECTRICITY_SOLAR',
  ENERGY_ELECTRICITY_WIND = 'ENERGY_ELECTRICITY_WIND',
  ENERGY_HEATING = 'ENERGY_HEATING',
  ENERGY_HEATING_BIO = 'ENERGY_HEATING_BIO',
  ENERGY_HEATING_BIO_BIOMASS = 'ENERGY_HEATING_BIO_BIOMASS',
  ENERGY_HEATING_BIO_BIOMASS_STRAW_PELLETS = 'ENERGY_HEATING_BIO_BIOMASS_STRAW_PELLETS',
  ENERGY_HEATING_BIO_BIOMASS_WOOD = 'ENERGY_HEATING_BIO_BIOMASS_WOOD',
  ENERGY_HEATING_BIO_BIOMASS_WOOD_CHIPS = 'ENERGY_HEATING_BIO_BIOMASS_WOOD_CHIPS',
  ENERGY_HEATING_BIO_BIOMASS_WOOD_PELLETS = 'ENERGY_HEATING_BIO_BIOMASS_WOOD_PELLETS',
  ENERGY_HEATING_ELECTRICITY = 'ENERGY_HEATING_ELECTRICITY',
  ENERGY_HEATING_FUELS = 'ENERGY_HEATING_FUELS',
  ENERGY_HEATING_FUELS_GAS = 'ENERGY_HEATING_FUELS_GAS',
  ENERGY_HEATING_FUELS_GAS_BIOGAS = 'ENERGY_HEATING_FUELS_GAS_BIOGAS',
  ENERGY_HEATING_FUELS_GAS_LIQUIFIEDNATURALGAS = 'ENERGY_HEATING_FUELS_GAS_LIQUIFIEDNATURALGAS',
  ENERGY_HEATING_FUELS_GAS_NATURALGAS = 'ENERGY_HEATING_FUELS_GAS_NATURALGAS',
  ENERGY_HEATING_FUELS_GAS_NATURALGAS_CITYGAS = 'ENERGY_HEATING_FUELS_GAS_NATURALGAS_CITYGAS',
  ENERGY_HEATING_FUELS_LIQUID = 'ENERGY_HEATING_FUELS_LIQUID',
  ENERGY_HEATING_FUELS_LIQUID_OIL = 'ENERGY_HEATING_FUELS_LIQUID_OIL',
  ENERGY_HEATING_FUELS_LIQUID_OIL_FUELGASOIL = 'ENERGY_HEATING_FUELS_LIQUID_OIL_FUELGASOIL',
  ENERGY_HEATING_FUELS_LIQUID_OIL_FUELOIL = 'ENERGY_HEATING_FUELS_LIQUID_OIL_FUELOIL',
  ENERGY_HEATING_FUELS_LIQUID_OIL_PETROLEUM = 'ENERGY_HEATING_FUELS_LIQUID_OIL_PETROLEUM',
  ENERGY_HEATING_FUELS_LIQUID_OIL_RAPESEED = 'ENERGY_HEATING_FUELS_LIQUID_OIL_RAPESEED',
  ENERGY_HEATING_INCINERATION = 'ENERGY_HEATING_INCINERATION',
  ENERGY_HEATING_REMOTE = 'ENERGY_HEATING_REMOTE',
  ENERGY_HEATING_WASTE = 'ENERGY_HEATING_WASTE',
  PURCHASED = 'PURCHASED',
  TRANSPORTATION = 'TRANSPORTATION',
  TRANSPORTATION_BIKE = 'TRANSPORTATION_BIKE',
  TRANSPORTATION_BUS = 'TRANSPORTATION_BUS',
  TRANSPORTATION_CAR = 'TRANSPORTATION_CAR',
  TRANSPORTATION_PLANE = 'TRANSPORTATION_PLANE',
  TRANSPORTATION_TRAIN = 'TRANSPORTATION_TRAIN',
  UNCATEGORIZED = 'UNCATEGORIZED',
  WASTE = 'WASTE',
  WASTE_BATTERY = 'WASTE_BATTERY',
  WASTE_BULKY = 'WASTE_BULKY',
  WASTE_CARDBOARD = 'WASTE_CARDBOARD',
  WASTE_CONSTRUCTION = 'WASTE_CONSTRUCTION',
  WASTE_ENVIRONMENTALLY_HAZARDOUS_BUSINESS = 'WASTE_ENVIRONMENTALLY_HAZARDOUS_BUSINESS',
  WASTE_FOOD = 'WASTE_FOOD',
  WASTE_FOOD_DRINK_CARTON = 'WASTE_FOOD_DRINK_CARTON',
  WASTE_GARDEN = 'WASTE_GARDEN',
  WASTE_GIFT_PAPER = 'WASTE_GIFT_PAPER',
  WASTE_GLASS = 'WASTE_GLASS',
  WASTE_HAZARDOUS_HOUSEHOLD = 'WASTE_HAZARDOUS_HOUSEHOLD',
  WASTE_METAL = 'WASTE_METAL',
  WASTE_PAPER = 'WASTE_PAPER',
  WASTE_PLASTIC_HARD = 'WASTE_PLASTIC_HARD',
  WASTE_PLASTIC_SOFT = 'WASTE_PLASTIC_SOFT',
  WASTE_RESIDUAL = 'WASTE_RESIDUAL',
  WASTE_SMALL_ELECTRONICS = 'WASTE_SMALL_ELECTRONICS',
  WASTE_TEXTILES = 'WASTE_TEXTILES',
  WASTE_WATER = 'WASTE_WATER',
  WATER = 'WATER'
}

export type ConsumptionTypeFilterComparison = {
  eq?: InputMaybe<ConsumptionType>;
  gt?: InputMaybe<ConsumptionType>;
  gte?: InputMaybe<ConsumptionType>;
  iLike?: InputMaybe<ConsumptionType>;
  in?: InputMaybe<Array<ConsumptionType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ConsumptionType>;
  lt?: InputMaybe<ConsumptionType>;
  lte?: InputMaybe<ConsumptionType>;
  neq?: InputMaybe<ConsumptionType>;
  notILike?: InputMaybe<ConsumptionType>;
  notIn?: InputMaybe<Array<ConsumptionType>>;
  notLike?: InputMaybe<ConsumptionType>;
};

export type ConversionFactorData = {
  __typename?: 'ConversionFactorData';
  consumptionType?: Maybe<ConsumptionType>;
  dateOfPublication?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  factor: Scalars['Float']['output'];
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  publicationName?: Maybe<Scalars['String']['output']>;
  publishingCompany?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type CountryBenchmark = {
  __typename?: 'CountryBenchmark';
  category: AssessmentCategory;
  countryCode?: Maybe<Scalars['String']['output']>;
  emission: Scalars['Float']['output'];
  entityId: Scalars['ID']['output'];
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  originalFrom?: Maybe<Scalars['DateTime']['output']>;
  originalTo?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type CountryBenchmarkFilter = {
  and?: InputMaybe<Array<CountryBenchmarkFilter>>;
  category?: InputMaybe<AssessmentCategoryFilterComparison>;
  createdBy?: InputMaybe<CountryBenchmarkFilterUserFilter>;
  emission?: InputMaybe<NumberFieldComparison>;
  entityId?: InputMaybe<IdFilterComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CountryBenchmarkFilter>>;
  to?: InputMaybe<DateFieldComparison>;
  updatedBy?: InputMaybe<CountryBenchmarkFilterUserFilter>;
};

export type CountryBenchmarkFilterUserFilter = {
  and?: InputMaybe<Array<CountryBenchmarkFilterUserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CountryBenchmarkFilterUserFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type CountryBenchmarkSort = {
  direction: SortDirection;
  field: CountryBenchmarkSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CountryBenchmarkSortFields {
  CATEGORY = 'category',
  EMISSION = 'emission',
  ENTITYID = 'entityId',
  FROM = 'from',
  ID = 'id',
  TO = 'to'
}

export enum CountryCode {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW'
}

export type CountryCodeFilterComparison = {
  eq?: InputMaybe<CountryCode>;
  gt?: InputMaybe<CountryCode>;
  gte?: InputMaybe<CountryCode>;
  iLike?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<CountryCode>;
  lt?: InputMaybe<CountryCode>;
  lte?: InputMaybe<CountryCode>;
  neq?: InputMaybe<CountryCode>;
  notILike?: InputMaybe<CountryCode>;
  notIn?: InputMaybe<Array<CountryCode>>;
  notLike?: InputMaybe<CountryCode>;
};

export type CreateAssessmentInput = {
  category: Scalars['String']['input'];
  consumption: Scalars['Float']['input'];
  consumptionType: ConsumptionType;
  data?: InputMaybe<Scalars['JSON']['input']>;
  from: Scalars['DateTime']['input'];
  integrationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  originId?: InputMaybe<Scalars['String']['input']>;
  ownedBuildingConsumptionPercentage?: InputMaybe<Scalars['Float']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
  totalBuildingSqm?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EmissionUnit>;
};

export type CreateAssessmentOriginInput = {
  assessmentType?: InputMaybe<AssessmentDataType>;
  fileId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssetGroupInput = {
  assets: Array<RelationInput>;
  filters: Array<AssetGroupFilterInput>;
  name: Scalars['String']['input'];
};

export type CreateAssetIntegrationInput = {
  assetId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  originId: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: IntegrationType;
};

export type CreateCrremPathway = {
  color: Scalars['String']['input'];
  country: Scalars['String']['input'];
  crremCategory: CrremCategory;
  target: Scalars['Float']['input'];
  unit: Scalars['String']['input'];
  value: Scalars['Float']['input'];
  version: Scalars['String']['input'];
  year: Scalars['Float']['input'];
};

export type CreateEnergyConversionFactorInput = {
  consumptionType: ConsumptionType;
  consumptionUnit: EmissionUnit;
  countryCode?: InputMaybe<CountryCode>;
  dateOfPublication?: InputMaybe<Scalars['DateTime']['input']>;
  externalSource?: InputMaybe<Scalars['String']['input']>;
  factor: Scalars['Float']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  publicationName?: InputMaybe<Scalars['String']['input']>;
  publishingCompany?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceFile?: InputMaybe<RetoolFile>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateLegacyBenchmark = {
  benchmarkType: LegacyBenchmarkType;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalIdentifier: Scalars['String']['input'];
  numberOfBuildings: Scalars['Float']['input'];
  segment: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export type CreateLocationInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  bfeCodes?: InputMaybe<Array<Scalars['Float']['input']>>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  constructionDate?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode: CountryCode;
  dgnbCertification?: InputMaybe<DgnbCertification>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<Array<AssetIntegrationInput>>;
  internalDescriptor?: InputMaybe<Scalars['String']['input']>;
  legalOwner?: InputMaybe<Scalars['String']['input']>;
  management?: InputMaybe<LocationManagementType>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownership?: InputMaybe<Scalars['Float']['input']>;
  propertyType?: InputMaybe<PropertyType>;
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  saleDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateLocationMetadataInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  buildingUse?: InputMaybe<Scalars['Float']['input']>;
  constructionDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  nationalIdentifier?: InputMaybe<Scalars['String']['input']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateManualConsumptionInput = {
  consumption: Scalars['Float']['input'];
  consumptionType: ConsumptionType;
  emissionUnit: EmissionUnit;
  file?: InputMaybe<Scalars['Upload']['input']>;
  from: Scalars['DateTime']['input'];
  identifier?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  source: AssessmentDataType;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
  updatedBy?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateManyAssessmentOriginsInput = {
  /** Array of records to create */
  assessmentOrigins: Array<CreateAssessmentOriginInput>;
};

export type CreateManyAssessmentsInput = {
  /** Array of records to create */
  assessments: Array<CreateAssessmentInput>;
};

export type CreateManyAssetGroupsInput = {
  /** Array of records to create */
  assetGroups: Array<CreateAssetGroupInput>;
};

export type CreateManyCrremPathwaysInput = {
  /** Array of records to create */
  cRREMPathways: Array<CreateCrremPathway>;
};

export type CreateManyEnergyConversionFactorsInput = {
  /** Array of records to create */
  energyConversionFactors: Array<CreateEnergyConversionFactorInput>;
};

export type CreateManyLegacyBenchmarksInput = {
  /** Array of records to create */
  legacyBenchmarks: Array<CreateLegacyBenchmark>;
};

export type CreateManyLocationIntegrationsInput = {
  /** Array of records to create */
  locationIntegrations: Array<CreateAssetIntegrationInput>;
};

export type CreateManyLocationMetadataInput = {
  /** Array of records to create */
  locationMetadata: Array<CreateLocationMetadataInput>;
};

export type CreateManyLocationsInput = {
  /** Array of records to create */
  locations: Array<CreateLocationInput>;
};

export type CreateManyOrganizationIntegrationsInput = {
  /** Array of records to create */
  organizationIntegrations: Array<CreateOrganizationIntegrationInput>;
};

export type CreateManyOrganizationsInput = {
  /** Array of records to create */
  organizations: Array<CreateOrganization>;
};

export type CreateManyPriorityBasedEmissionFactorsInput = {
  /** Array of records to create */
  priorityBasedEmissionFactors: Array<CreatePriorityBasedEmissionFactorInput>;
};

export type CreateManyReportsInput = {
  /** Array of records to create */
  reports: Array<CreateReportInput>;
};

export type CreateManySupplierLocationsInput = {
  /** Array of records to create */
  supplierLocations: Array<CreateSupplierLocation>;
};

export type CreateManySuppliersInput = {
  /** Array of records to create */
  suppliers: Array<CreateSupplier>;
};

export type CreateManyTargetSettingsInput = {
  /** Array of records to create */
  targetSettings: Array<CreateTargetSettingsInput>;
};

export type CreateManyUsersInput = {
  /** Array of records to create */
  users: Array<CreateUser>;
};

export type CreateOneAssessmentInput = {
  /** The record to create */
  assessment: CreateAssessmentInput;
};

export type CreateOneAssessmentOriginInput = {
  /** The record to create */
  assessmentOrigin: CreateAssessmentOriginInput;
};

export type CreateOneAssetGroupInput = {
  /** The record to create */
  assetGroup: CreateAssetGroupInput;
};

export type CreateOneCrremPathwayInput = {
  /** The record to create */
  cRREMPathway: CreateCrremPathway;
};

export type CreateOneEnergyConversionFactorInput = {
  /** The record to create */
  energyConversionFactor: CreateEnergyConversionFactorInput;
};

export type CreateOneLegacyBenchmarkInput = {
  /** The record to create */
  legacyBenchmark: CreateLegacyBenchmark;
};

export type CreateOneLocationInput = {
  /** The record to create */
  location: CreateLocationInput;
};

export type CreateOneLocationIntegrationInput = {
  /** The record to create */
  locationIntegration: CreateAssetIntegrationInput;
};

export type CreateOneLocationMetadataInput = {
  /** The record to create */
  locationMetadata: CreateLocationMetadataInput;
};

export type CreateOneOrganizationInput = {
  /** The record to create */
  organization: CreateOrganization;
};

export type CreateOneOrganizationIntegrationInput = {
  /** The record to create */
  organizationIntegration: CreateOrganizationIntegrationInput;
};

export type CreateOnePriorityBasedEmissionFactorInput = {
  /** The record to create */
  priorityBasedEmissionFactor: CreatePriorityBasedEmissionFactorInput;
};

export type CreateOneReportInput = {
  /** The record to create */
  report: CreateReportInput;
};

export type CreateOneSupplierInput = {
  /** The record to create */
  supplier: CreateSupplier;
};

export type CreateOneSupplierLocationInput = {
  /** The record to create */
  supplierLocation: CreateSupplierLocation;
};

export type CreateOneTargetSettingInput = {
  /** The record to create */
  targetSetting: CreateTargetSettingsInput;
};

export type CreateOneUserInput = {
  /** The record to create */
  user: CreateUser;
};

export type CreateOrganization = {
  baselineYear?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  reportingYear?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOrganizationIntegrationInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  type: IntegrationType;
};

export type CreatePriorityBasedEmissionFactorInput = {
  calculationMethod?: InputMaybe<CalculationMethod>;
  consumptionType: ConsumptionType;
  consumptionUnit: EmissionUnit;
  countryCode?: InputMaybe<CountryCode>;
  dateOfPublication?: InputMaybe<Scalars['DateTime']['input']>;
  externalSource?: InputMaybe<Scalars['String']['input']>;
  factor: Scalars['Float']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  isProjected?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  publicationName?: InputMaybe<Scalars['String']['input']>;
  publishingCompany?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceFile?: InputMaybe<RetoolFile>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateReportInput = {
  framework: ReportFramework;
  from: Scalars['DateTime']['input'];
  includeAuditInventory?: InputMaybe<Scalars['Boolean']['input']>;
  language?: ReportLanguage;
  note?: InputMaybe<Scalars['String']['input']>;
  numberOfAssets: Scalars['Float']['input'];
  segmentName?: InputMaybe<Scalars['String']['input']>;
  source: AssessmentDataType;
  to: Scalars['DateTime']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplier = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalDescriptor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplierLocation = {
  emissionType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type CreateTargetSettingsInput = {
  pathwayId: Scalars['String']['input'];
  reduction: Scalars['Float']['input'];
  targetYear: Scalars['Float']['input'];
  type: TargetType;
};

export type CreateUser = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum CrremCategory {
  DISTRIBUTION_WAREHOUSE_COLD = 'DISTRIBUTION_WAREHOUSE_COLD',
  DISTRIBUTION_WAREHOUSE_WARM = 'DISTRIBUTION_WAREHOUSE_WARM',
  HEALTHCARE = 'HEALTHCARE',
  HOTEL = 'HOTEL',
  LODGE_LEISURE = 'LODGE_LEISURE',
  MIXED_USE = 'MIXED_USE',
  OFFICE = 'OFFICE',
  RESI_MULTI_FAMILY = 'RESI_MULTI_FAMILY',
  RESI_SINGLE_FAMILY = 'RESI_SINGLE_FAMILY',
  RETAIL_HIGH_STREET = 'RETAIL_HIGH_STREET',
  RETAIL_WAREHOUSE = 'RETAIL_WAREHOUSE',
  SHOPPING_CENTER = 'SHOPPING_CENTER',
  UNCATEGORIZED = 'UNCATEGORIZED'
}

export type CrremCategoryFilterComparison = {
  eq?: InputMaybe<CrremCategory>;
  gt?: InputMaybe<CrremCategory>;
  gte?: InputMaybe<CrremCategory>;
  iLike?: InputMaybe<CrremCategory>;
  in?: InputMaybe<Array<CrremCategory>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<CrremCategory>;
  lt?: InputMaybe<CrremCategory>;
  lte?: InputMaybe<CrremCategory>;
  neq?: InputMaybe<CrremCategory>;
  notILike?: InputMaybe<CrremCategory>;
  notIn?: InputMaybe<Array<CrremCategory>>;
  notLike?: InputMaybe<CrremCategory>;
};

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum DgnbCertification {
  BRONZE = 'BRONZE',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
  SILVER = 'SILVER'
}

export enum DkBuildingUse {
  ALLOTMENT_HOUSE = 'ALLOTMENT_HOUSE',
  AMUSEMENT_PARK = 'AMUSEMENT_PARK',
  ANNEX_FOR_COTTAGE = 'ANNEX_FOR_COTTAGE',
  APARTMENT_BUILDING_AND_MULTIFAMILY_HOUSING = 'APARTMENT_BUILDING_AND_MULTIFAMILY_HOUSING',
  ASSEMBLY_HALL = 'ASSEMBLY_HALL',
  AVIATION_FACILITY = 'AVIATION_FACILITY',
  BARN_FOR_FEED_AND_CROP = 'BARN_FOR_FEED_AND_CROP',
  BARRACKS = 'BARRACKS',
  BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
  CARPORT = 'CARPORT',
  CHURCH_OR_OTHER_BUILD_FOR_EXERCISE_OF_FAITH_FOR_STATE_APPROVED_RELIGIOUS_COMMUNITIES = 'CHURCH_OR_OTHER_BUILD_FOR_EXERCISE_OF_FAITH_FOR_STATE_APPROVED_RELIGIOUS_COMMUNITIES',
  CINEMA_THEATER_CONCERT_HALL = 'CINEMA_THEATER_CONCERT_HALL',
  CLUBHOUSE_RELATED_TO_LEISURE_AND_SPORT = 'CLUBHOUSE_RELATED_TO_LEISURE_AND_SPORT',
  COMMERCIAL_RENTAL_VACATION_HOME = 'COMMERCIAL_RENTAL_VACATION_HOME',
  COTTAGE = 'COTTAGE',
  COWSHED = 'COWSHED',
  DAYCARE_CENTER = 'DAYCARE_CENTER',
  DEPRECATED_BUILDING_FOR_OTHER_INSTITUTION_BARRACKS_PRISON_ECT = 'DEPRECATED_BUILDING_FOR_OTHER_INSTITUTION_BARRACKS_PRISON_ECT',
  DEPRECATED_CINEMA_THEATER_LIBRARY_MUSEUM_CHURCH_ECT = 'DEPRECATED_CINEMA_THEATER_LIBRARY_MUSEUM_CHURCH_ECT',
  DEPRECATED_COMMERCIAL_PRODUCTION_BUILDINGS_RELATED_TO_AGRICULTURE_AND_MINING = 'DEPRECATED_COMMERCIAL_PRODUCTION_BUILDINGS_RELATED_TO_AGRICULTURE_AND_MINING',
  DEPRECATED_DAYCARE_CENTER = 'DEPRECATED_DAYCARE_CENTER',
  DEPRECATED_EDUCATIONAL_BUILDING = 'DEPRECATED_EDUCATIONAL_BUILDING',
  DEPRECATED_FACTORY_WORKSHOP_ECT = 'DEPRECATED_FACTORY_WORKSHOP_ECT',
  DEPRECATED_HOSPITAL_NURSING_HOME_MATERNITY_CLINIC_ECT = 'DEPRECATED_HOSPITAL_NURSING_HOME_MATERNITY_CLINIC_ECT',
  DEPRECATED_HOTEL_RESTAURANT_AND_SERVICE_COMPANY = 'DEPRECATED_HOTEL_RESTAURANT_AND_SERVICE_COMPANY',
  DEPRECATED_OFFICE_TRADE_WAREHOUSE_OR_GOVERNMENTAL_ADMINISTRATION_BUILDING = 'DEPRECATED_OFFICE_TRADE_WAREHOUSE_OR_GOVERNMENTAL_ADMINISTRATION_BUILDING',
  DEPRECATED_OTHER_BUILDING_FOR_TRANSPORT_TRADE_ECT = 'DEPRECATED_OTHER_BUILDING_FOR_TRANSPORT_TRADE_ECT',
  DEPRECATED_OTHER_FARMING_AND_INDUSTRIAL_FACILITY = 'DEPRECATED_OTHER_FARMING_AND_INDUSTRIAL_FACILITY',
  DEPRECATED_POWER_GAS_HEATING_PLANT_WATERWORKS_INCINERATOR_ECT = 'DEPRECATED_POWER_GAS_HEATING_PLANT_WATERWORKS_INCINERATOR_ECT',
  DEPRECATED_ROW_CHAIN_OR_DOUBLE_HOUSE = 'DEPRECATED_ROW_CHAIN_OR_DOUBLE_HOUSE',
  DEPRECATED_SPORTS_FACILITY = 'DEPRECATED_SPORTS_FACILITY',
  DEPRECATED_SUMMERCAMP_HOSTEL_AND_OTHER_VACATION_HOME_EXCEPT_COTTAGE = 'DEPRECATED_SUMMERCAMP_HOSTEL_AND_OTHER_VACATION_HOME_EXCEPT_COTTAGE',
  DEPRECATED_TRANSPORT_AND_GARAGE_FACILITY = 'DEPRECATED_TRANSPORT_AND_GARAGE_FACILITY',
  DEPRECATED_UNKNOWN = 'DEPRECATED_UNKNOWN',
  DETACHED_CONSERVATORY = 'DETACHED_CONSERVATORY',
  DETACHED_COVER = 'DETACHED_COVER',
  DETACHED_SINGLE_FAMILY_HOUSE = 'DETACHED_SINGLE_FAMILY_HOUSE',
  DETACHED_SINGLE_FAMILY_HOUSE_IN_DENSE_LOW_RISE_BUILDINGS = 'DETACHED_SINGLE_FAMILY_HOUSE_IN_DENSE_LOW_RISE_BUILDINGS',
  DORMITORY = 'DORMITORY',
  DOUBLE_HOUSE = 'DOUBLE_HOUSE',
  ENERGY_PRODUCTION_FACILITY = 'ENERGY_PRODUCTION_FACILITY',
  FARMHOUSE = 'FARMHOUSE',
  GARAGE = 'GARAGE',
  GAS_STATION = 'GAS_STATION',
  GREENHOUSE = 'GREENHOUSE',
  GROWTH_HOUSE = 'GROWTH_HOUSE',
  HAY_SHED = 'HAY_SHED',
  HEATH_MEDICAL_CENTER_AND_MATERNITY_CLINIC = 'HEATH_MEDICAL_CENTER_AND_MATERNITY_CLINIC',
  HOSPICE_TREATMENT_HOME = 'HOSPICE_TREATMENT_HOME',
  HOSPITAL = 'HOSPITAL',
  HOTEL_INN_OR_CONFERENCE_CENTER_WITH_OVERNIGHT_STAY = 'HOTEL_INN_OR_CONFERENCE_CENTER_WITH_OVERNIGHT_STAY',
  INDUSTRIAL_BUILDING_WITHOUT_INTEGRATED_PRODUCTION_FACILITY = 'INDUSTRIAL_BUILDING_WITHOUT_INTEGRATED_PRODUCTION_FACILITY',
  INDUSTRIAL_BUILDING_WITH_INTEGRATED_PRODUCTION_FACILITY = 'INDUSTRIAL_BUILDING_WITH_INTEGRATED_PRODUCTION_FACILITY',
  LEFTOVER_FARM_BUILDING = 'LEFTOVER_FARM_BUILDING',
  LIBRARY = 'LIBRARY',
  MINK_FARM = 'MINK_FARM',
  MUSEUM = 'MUSEUM',
  MACHINE_HOUSE_GARAGE = 'Machine_House_Garage',
  OFFICE_BUILDING = 'OFFICE_BUILDING',
  OTHER_BUILDING_FOR_EDUCATION_AND_RESEARCH = 'OTHER_BUILDING_FOR_EDUCATION_AND_RESEARCH',
  OTHER_BUILDING_FOR_INSTITUTIONAL_PURPOSES = 'OTHER_BUILDING_FOR_INSTITUTIONAL_PURPOSES',
  OTHER_BUILDING_FOR_LEISURE_PURPOSES = 'OTHER_BUILDING_FOR_LEISURE_PURPOSES',
  OTHER_BUILDING_FOR_OFFICE_RETAIL_AND_WAREHOUSE = 'OTHER_BUILDING_FOR_OFFICE_RETAIL_AND_WAREHOUSE',
  OTHER_BUILDING_FOR_SERVICE_INDUSTRY = 'OTHER_BUILDING_FOR_SERVICE_INDUSTRY',
  OTHER_BUILDING_FOR_SPORTS_PURPOSES = 'OTHER_BUILDING_FOR_SPORTS_PURPOSES',
  OTHER_BUILDING_FOR_VACATION_PURPOSES = 'OTHER_BUILDING_FOR_VACATION_PURPOSES',
  OTHER_BUILDING_RELATED_TO_FARMING = 'OTHER_BUILDING_RELATED_TO_FARMING',
  OTHER_CULTURAL_BUILDING = 'OTHER_CULTURAL_BUILDING',
  OTHER_ENERGY_FACILITY = 'OTHER_ENERGY_FACILITY',
  OTHER_HEALTH_RELATED_BUILDING = 'OTHER_HEALTH_RELATED_BUILDING',
  OTHER_PRODUCTION_FACILITY = 'OTHER_PRODUCTION_FACILITY',
  OTHER_RESIDENTIAL = 'OTHER_RESIDENTIAL',
  OTHER_TRANSPORT_FACILITY = 'OTHER_TRANSPORT_FACILITY',
  OUTHOUSE = 'OUTHOUSE',
  PARKING_AND_TRANSPORT_FACILITY = 'PARKING_AND_TRANSPORT_FACILITY',
  PIGSTY = 'PIGSTY',
  POULTRY_BARN = 'POULTRY_BARN',
  PRISON_JAIL_ECT = 'PRISON_JAIL_ECT',
  PRIVATE_SERVICE_COMPANY = 'PRIVATE_SERVICE_COMPANY',
  RAIL_AND_BUS_FACILITY = 'RAIL_AND_BUS_FACILITY',
  RESIDENTIAL_ANNEX = 'RESIDENTIAL_ANNEX',
  RESIDENTIAL_GARAGE = 'RESIDENTIAL_GARAGE',
  RESIDENTIAL_INSTITUTION = 'RESIDENTIAL_INSTITUTION',
  RESTAURANT_CAFE_AND_CONFERENCE_CENTER_WITHOUT_OVERNIGHT_STAY = 'RESTAURANT_CAFE_AND_CONFERENCE_CENTER_WITHOUT_OVERNIGHT_STAY',
  RETAIL_BUILDING = 'RETAIL_BUILDING',
  ROW_CHAIN_AND_CLUSTER_HOUSE = 'ROW_CHAIN_AND_CLUSTER_HOUSE',
  RUIN = 'Ruin',
  SCHOOL = 'SCHOOL',
  SEAPORT = 'SEAPORT',
  SERVICE_FUNCTION_FOR_RESIDENTIAL_CARE_INSTITUTIONS = 'SERVICE_FUNCTION_FOR_RESIDENTIAL_CARE_INSTITUTIONS',
  SHOPPING_CENTER = 'SHOPPING_CENTER',
  SINGLE_FAMILY_HOUSE = 'SINGLE_FAMILY_HOUSE',
  SPORTS_HALL = 'SPORTS_HALL',
  STABLES = 'STABLES',
  STADIUM_TRIBUNE = 'STADIUM_TRIBUNE',
  SUMMER_CAMP_CAMPING_CENTER_ECT = 'SUMMER_CAMP_CAMPING_CENTER_ECT',
  SUPPLY_AND_ENERGY_DISTRIBUTION_FACILITY = 'SUPPLY_AND_ENERGY_DISTRIBUTION_FACILITY',
  SWIMMING_POOL = 'SWIMMING_POOL',
  UNIVERSITY = 'UNIVERSITY',
  UNKNOWN = 'UNKNOWN',
  VACATION_HOME = 'VACATION_HOME',
  WAREHOUSE = 'WAREHOUSE',
  WASTE_AND_SEWAGE_FACILITY = 'WASTE_AND_SEWAGE_FACILITY',
  WATER_FACILITY = 'WATER_FACILITY',
  WORKSHOP = 'WORKSHOP'
}

export type DataQuality = {
  __typename?: 'DataQuality';
  from: Scalars['DateTime']['output'];
  highQuality: Array<DataQualityDistribution>;
  lowQuality: Array<DataQualityDistribution>;
  mediumQuality: Array<DataQualityDistribution>;
  to: Scalars['DateTime']['output'];
};

export type DataQualityDistribution = {
  __typename?: 'DataQualityDistribution';
  assessmentDays: Scalars['Float']['output'];
  priorityDistribution: Scalars['Float']['output'];
  sources: Array<Scalars['String']['output']>;
};

export enum DataQualityTypes {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type DeleteAssessmentInput = {
  id: Scalars['String']['input'];
};

export type DeleteAssetPropertyInput = {
  assetId: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
};

export type DeleteLocationIntegrationInput = {
  assetId: Scalars['String']['input'];
  originId: Scalars['String']['input'];
  type: IntegrationType;
};

export type DeleteManyAssessmentOriginsInput = {
  /** Filter to find records to delete */
  filter: AssessmentOriginDeleteFilter;
};

export type DeleteManyAssessmentsInput = {
  /** Filter to find records to delete */
  filter: AssessmentDeleteFilter;
};

export type DeleteManyAssetGroupsInput = {
  /** Filter to find records to delete */
  filter: AssetGroupDeleteFilter;
};

export type DeleteManyCrremPathwaysInput = {
  /** Filter to find records to delete */
  filter: CrremPathwayDeleteFilter;
};

export type DeleteManyEnergyConversionFactorsInput = {
  /** Filter to find records to delete */
  filter: EnergyConversionFactorDeleteFilter;
};

export type DeleteManyLegacyBenchmarksInput = {
  /** Filter to find records to delete */
  filter: LegacyBenchmarkDeleteFilter;
};

export type DeleteManyLocationIntegrationsInput = {
  /** Filter to find records to delete */
  filter: LocationIntegrationDeleteFilter;
};

export type DeleteManyLocationMetadataInput = {
  /** Filter to find records to delete */
  filter: LocationMetadataDeleteFilter;
};

export type DeleteManyOrganizationsInput = {
  /** Filter to find records to delete */
  filter: OrganizationDeleteFilter;
};

export type DeleteManyPriorityBasedEmissionFactorsInput = {
  /** Filter to find records to delete */
  filter: PriorityBasedEmissionFactorDeleteFilter;
};

export type DeleteManyResponse = {
  __typename?: 'DeleteManyResponse';
  /** The number of records deleted. */
  deletedCount: Scalars['Int']['output'];
};

export type DeleteManySupplierLocationsInput = {
  /** Filter to find records to delete */
  filter: SupplierLocationDeleteFilter;
};

export type DeleteManySuppliersInput = {
  /** Filter to find records to delete */
  filter: SupplierDeleteFilter;
};

export type DeleteManyTargetSettingsInput = {
  /** Filter to find records to delete */
  filter: TargetSettingDeleteFilter;
};

export type DeleteManyUsersInput = {
  /** Filter to find records to delete */
  filter: UserDeleteFilter;
};

export type DeleteOneAssessmentInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneAssessmentOriginInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneAssetGroupInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneCrremPathwayInput = {
  /** The id of the record to delete. */
  id: Scalars['String']['input'];
};

export type DeleteOneEnergyConversionFactorInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneLegacyBenchmarkInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneLocationIntegrationInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneLocationMetadataInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneOrganizationInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOnePriorityBasedEmissionFactorInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOnePropertyInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneReportInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneSupplierInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneSupplierLocationInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneTargetSettingInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneUserInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteReportInput = {
  id: Scalars['String']['input'];
};

export type DeviceData = {
  __typename?: 'DeviceData';
  id: Scalars['Int']['output'];
};

export type DexmaLocationData = {
  __typename?: 'DexmaLocationData';
  activity?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reference_devices?: Maybe<Array<ReferenceDeviceData>>;
};

export type ElectralinkLocation = {
  __typename?: 'ElectralinkLocation';
  address: Scalars['String']['output'];
  hashedMPAN: Scalars['String']['output'];
  partialMPAN: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
};

export type EloverblikCustomer = {
  __typename?: 'EloverblikCustomer';
  customerCVR: Scalars['String']['output'];
  customerKey: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  includeFutureMeteringPoints: Scalars['Boolean']['output'];
};

export type EloverblikInitialState = {
  __typename?: 'EloverblikInitialState';
  customerLocation: Location;
  meterLocations: Array<EloverblikMeter>;
  rowIndex: Scalars['Float']['output'];
};

export type EloverblikMeter = {
  __typename?: 'EloverblikMeter';
  address: Scalars['String']['output'];
  consumerStartDate: Scalars['String']['output'];
  meterNumber: Scalars['String']['output'];
  meteringPointId: Scalars['String']['output'];
  parentMeteringPointId?: Maybe<Scalars['String']['output']>;
  typeOfMP: Scalars['String']['output'];
};

export type EmissionData = {
  __typename?: 'EmissionData';
  emission: EmissionDetails;
  emissionPerArea: EmissionDetails;
};

export type EmissionDetails = {
  __typename?: 'EmissionDetails';
  bestEffort: AssessmentEmission;
  epc: AssessmentEmission;
  meter: AssessmentEmission;
};

export type EmissionFactor = {
  __typename?: 'EmissionFactor';
  factor: Scalars['Float']['output'];
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type EmissionFactorData = {
  __typename?: 'EmissionFactorData';
  calculationMethod?: Maybe<CalculationMethod>;
  consumptionType?: Maybe<ConsumptionType>;
  dateOfPublication?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  factor: Scalars['Float']['output'];
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  publicationName?: Maybe<Scalars['String']['output']>;
  publishingCompany?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  source?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type EmissionSummary = {
  __typename?: 'EmissionSummary';
  aggregation: AssessmentAggregation;
  assetId: Scalars['String']['output'];
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ownedArea?: Maybe<Scalars['Float']['output']>;
  ownedEmission?: Maybe<Scalars['Float']['output']>;
  ownedEnergy?: Maybe<Scalars['Float']['output']>;
  sourceTypes?: Maybe<Array<Scalars['String']['output']>>;
  sources?: Maybe<Array<SummarySource>>;
  to: Scalars['DateTime']['output'];
  vertical: AssessmentVertical;
};

export type EmissionSummaryView = {
  __typename?: 'EmissionSummaryView';
  aggregation: AssessmentAggregation;
  assetCount: Scalars['Float']['output'];
  avgEmissionIntensity?: Maybe<Scalars['Float']['output']>;
  avgEmissionIntensityBreakdown: Scalars['JSONObject']['output'];
  avgEnergyIntensity?: Maybe<Scalars['Float']['output']>;
  avgEnergyIntensityBreakdown: Scalars['JSONObject']['output'];
  dataType: AssessmentDataType;
  emissionBreakdown: Scalars['JSONObject']['output'];
  emissionForAreaBreakdown: Scalars['JSONObject']['output'];
  emissionIntensity?: Maybe<Scalars['Float']['output']>;
  energyBreakdown: Scalars['JSONObject']['output'];
  energyForAreaBreakdown: Scalars['JSONObject']['output'];
  energyIntensity?: Maybe<Scalars['Float']['output']>;
  from: Scalars['DateTime']['output'];
  ownedArea?: Maybe<Scalars['Float']['output']>;
  ownedEmission?: Maybe<Scalars['Float']['output']>;
  ownedEmissionForArea?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use ownedEmissionForArea instead */
  ownedEmissionWithArea?: Maybe<Scalars['Float']['output']>;
  ownedEnergy?: Maybe<Scalars['Float']['output']>;
  ownedEnergyForArea?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use ownedEnergyForArea instead */
  ownedEnergyWithArea?: Maybe<Scalars['Float']['output']>;
  to: Scalars['DateTime']['output'];
  verticals: Array<AssessmentVertical>;
};

export enum EmissionUnit {
  DKK = 'DKK',
  GCAL = 'GCAL',
  GJ = 'GJ',
  KG = 'KG',
  KM = 'KM',
  KWH = 'KWH',
  LITER = 'LITER',
  M = 'M',
  MJ = 'MJ',
  M_3 = 'M_3',
  UNKNOWN = 'UNKNOWN'
}

export type EmissionUnitFilterComparison = {
  eq?: InputMaybe<EmissionUnit>;
  gt?: InputMaybe<EmissionUnit>;
  gte?: InputMaybe<EmissionUnit>;
  iLike?: InputMaybe<EmissionUnit>;
  in?: InputMaybe<Array<EmissionUnit>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<EmissionUnit>;
  lt?: InputMaybe<EmissionUnit>;
  lte?: InputMaybe<EmissionUnit>;
  neq?: InputMaybe<EmissionUnit>;
  notILike?: InputMaybe<EmissionUnit>;
  notIn?: InputMaybe<Array<EmissionUnit>>;
  notLike?: InputMaybe<EmissionUnit>;
};

export type EnergyConversionFactor = {
  __typename?: 'EnergyConversionFactor';
  consumptionType: ConsumptionType;
  consumptionUnit: EmissionUnit;
  countryCode?: Maybe<CountryCode>;
  createdAt: Scalars['DateTime']['output'];
  dateOfPublication?: Maybe<Scalars['DateTime']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  factor: Scalars['Float']['output'];
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  publicationName?: Maybe<Scalars['String']['output']>;
  publishingCompany?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EnergyConversionFactorConnection = {
  __typename?: 'EnergyConversionFactorConnection';
  /** Array of nodes. */
  nodes: Array<EnergyConversionFactor>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type EnergyConversionFactorDeleteFilter = {
  and?: InputMaybe<Array<EnergyConversionFactorDeleteFilter>>;
  consumptionType?: InputMaybe<ConsumptionTypeFilterComparison>;
  consumptionUnit?: InputMaybe<EmissionUnitFilterComparison>;
  countryCode?: InputMaybe<CountryCodeFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  dateOfPublication?: InputMaybe<DateFieldComparison>;
  externalSource?: InputMaybe<StringFieldComparison>;
  factor?: InputMaybe<NumberFieldComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isVerified?: InputMaybe<BooleanFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EnergyConversionFactorDeleteFilter>>;
  publicationName?: InputMaybe<StringFieldComparison>;
  publishingCompany?: InputMaybe<StringFieldComparison>;
  source?: InputMaybe<StringFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type EnergyConversionFactorDeleteResponse = {
  __typename?: 'EnergyConversionFactorDeleteResponse';
  consumptionType?: Maybe<ConsumptionType>;
  consumptionUnit?: Maybe<EmissionUnit>;
  countryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfPublication?: Maybe<Scalars['DateTime']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  factor?: Maybe<Scalars['Float']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  publicationName?: Maybe<Scalars['String']['output']>;
  publishingCompany?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EnergyConversionFactorFilter = {
  and?: InputMaybe<Array<EnergyConversionFactorFilter>>;
  consumptionType?: InputMaybe<ConsumptionTypeFilterComparison>;
  consumptionUnit?: InputMaybe<EmissionUnitFilterComparison>;
  countryCode?: InputMaybe<CountryCodeFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  dateOfPublication?: InputMaybe<DateFieldComparison>;
  externalSource?: InputMaybe<StringFieldComparison>;
  factor?: InputMaybe<NumberFieldComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isVerified?: InputMaybe<BooleanFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EnergyConversionFactorFilter>>;
  publicationName?: InputMaybe<StringFieldComparison>;
  publishingCompany?: InputMaybe<StringFieldComparison>;
  source?: InputMaybe<StringFieldComparison>;
  supplier?: InputMaybe<EnergyConversionFactorFiltersupplierFilter>;
  to?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type EnergyConversionFactorFiltersupplierFilter = {
  and?: InputMaybe<Array<EnergyConversionFactorFiltersupplierFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EnergyConversionFactorFiltersupplierFilter>>;
  website?: InputMaybe<StringFieldComparison>;
};

export type EnergyConversionFactorSort = {
  direction: SortDirection;
  field: EnergyConversionFactorSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum EnergyConversionFactorSortFields {
  CONSUMPTIONTYPE = 'consumptionType',
  CONSUMPTIONUNIT = 'consumptionUnit',
  COUNTRYCODE = 'countryCode',
  CREATEDAT = 'createdAt',
  DATEOFPUBLICATION = 'dateOfPublication',
  EXTERNALSOURCE = 'externalSource',
  FACTOR = 'factor',
  FROM = 'from',
  ID = 'id',
  ISVERIFIED = 'isVerified',
  NOTE = 'note',
  PUBLICATIONNAME = 'publicationName',
  PUBLISHINGCOMPANY = 'publishingCompany',
  SOURCE = 'source',
  TO = 'to',
  UPDATEDAT = 'updatedAt'
}

export type EnergyConversionFactorUpdateFilter = {
  and?: InputMaybe<Array<EnergyConversionFactorUpdateFilter>>;
  consumptionType?: InputMaybe<ConsumptionTypeFilterComparison>;
  consumptionUnit?: InputMaybe<EmissionUnitFilterComparison>;
  countryCode?: InputMaybe<CountryCodeFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  dateOfPublication?: InputMaybe<DateFieldComparison>;
  externalSource?: InputMaybe<StringFieldComparison>;
  factor?: InputMaybe<NumberFieldComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isVerified?: InputMaybe<BooleanFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EnergyConversionFactorUpdateFilter>>;
  publicationName?: InputMaybe<StringFieldComparison>;
  publishingCompany?: InputMaybe<StringFieldComparison>;
  source?: InputMaybe<StringFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type EntolabsLocationData = {
  __typename?: 'EntolabsLocationData';
  address?: Maybe<Scalars['String']['output']>;
  entolabsOrganizationId: Scalars['String']['output'];
  meterId: Scalars['String']['output'];
  meterName: Scalars['String']['output'];
  meterType: IntegrationEntolabsMeterType;
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
};

export type EntolabsOrganization = {
  __typename?: 'EntolabsOrganization';
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type EpcAssessment = {
  __typename?: 'EpcAssessment';
  buildingArea?: Maybe<Scalars['Float']['output']>;
  buildingIdentifiers?: Maybe<Array<Scalars['String']['output']>>;
  classification?: Maybe<Scalars['String']['output']>;
  consumption?: Maybe<Array<EpcAssessmentConsumption>>;
  from: Scalars['DateTime']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  isManual?: Maybe<Scalars['Boolean']['output']>;
  to: Scalars['DateTime']['output'];
};

export type EpcAssessmentConsumption = {
  __typename?: 'EpcAssessmentConsumption';
  unit?: Maybe<EmissionUnit>;
  value?: Maybe<Scalars['Float']['output']>;
  vertical?: Maybe<AssessmentVertical>;
};

export type EpcData = {
  __typename?: 'EpcData';
  classification: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
};

export type EpcExpiresSoonAlertData = {
  __typename?: 'EpcExpiresSoonAlertData';
  epcExpiryDates: Array<Scalars['String']['output']>;
};

export type EpcProposal = {
  __typename?: 'EpcProposal';
  category: Scalars['String']['output'];
  costSaving: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  emissionSaving: Scalars['Float']['output'];
  energySaving: Scalars['Float']['output'];
  fuelSavingBreakdown?: Maybe<Array<EpcProposalFuelSaving>>;
  investment: Scalars['String']['output'];
  investmentLifetime: Scalars['String']['output'];
  profitability: Scalars['String']['output'];
  renovationTime: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EpcProposalFuelSaving = {
  __typename?: 'EpcProposalFuelSaving';
  cost?: Maybe<Scalars['Float']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  energy?: Maybe<Scalars['Float']['output']>;
  material: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type EpcSummary = {
  __typename?: 'EpcSummary';
  allProposalClassification?: Maybe<Scalars['String']['output']>;
  bfe: Scalars['String']['output'];
  classification?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  postalCodeAndCity?: Maybe<Scalars['String']['output']>;
  profitableProposalClassification?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Array<EpcProposal>>;
  street?: Maybe<Scalars['String']['output']>;
};

export type File = {
  __typename?: 'File';
  createdBy: User;
  id: Scalars['ID']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  updatedBy: User;
  url: Scalars['String']['output'];
};

export type FileEdge = {
  __typename?: 'FileEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the File */
  node: File;
};

export type FileFilter = {
  and?: InputMaybe<Array<FileFilter>>;
  createdBy?: InputMaybe<FileFilterUserFilter>;
  id?: InputMaybe<IdFilterComparison>;
  mime?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FileFilter>>;
  organization?: InputMaybe<FileFilterOrganizationFilter>;
  updatedBy?: InputMaybe<FileFilterUserFilter>;
};

export type FileFilterOrganizationFilter = {
  and?: InputMaybe<Array<FileFilterOrganizationFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FileFilterOrganizationFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
};

export type FileFilterUserFilter = {
  and?: InputMaybe<Array<FileFilterUserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FileFilterUserFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type FileSort = {
  direction: SortDirection;
  field: FileSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FileSortFields {
  ID = 'id',
  MIME = 'mime',
  NAME = 'name'
}

export enum FillStyle {
  DEFAULT = 'default',
  DISABLED = 'disabled'
}

export enum FloorAreaType {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
  UNKNOWN = 'UNKNOWN',
  XLARGE = 'XLARGE',
  XXLARGE = 'XXLARGE',
  XXXLARGE = 'XXXLARGE'
}

export type HoforLocationData = {
  __typename?: 'HoforLocationData';
  installationNumber: Scalars['String']['output'];
};

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  iLike?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notILike?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notLike?: InputMaybe<Scalars['ID']['input']>;
};

export type InitialDexmaLocationIntegrationsStateData = {
  __typename?: 'InitialDexmaLocationIntegrationsStateData';
  customerLocation: Location;
  meterLocations: Array<DexmaLocationData>;
  rowIndex: Scalars['Int']['output'];
};

export type InitialElectralinkLocationIntegrationsState = {
  __typename?: 'InitialElectralinkLocationIntegrationsState';
  customerLocation: Location;
  meterLocations: Array<ElectralinkLocation>;
  rowIndex: Scalars['Int']['output'];
};

export type InitialEntolabsLocationIntegrationsStateData = {
  __typename?: 'InitialEntolabsLocationIntegrationsStateData';
  customerLocation: Location;
  meterLocations: Array<EntolabsLocationData>;
  rowIndex: Scalars['Int']['output'];
};

export type InitialHoforLocationIntegrationsStateData = {
  __typename?: 'InitialHoforLocationIntegrationsStateData';
  customerLocation: Location;
  meterLocations: Array<HoforLocationData>;
  rowIndex: Scalars['Int']['output'];
};

export type InitialState = {
  __typename?: 'InitialState';
  customerLocation: Location;
  meterLocations: Array<SoftvaerketMeter>;
  rowIndex: Scalars['Float']['output'];
};

export type InitialTechemLocationIntegrationsStateData = {
  __typename?: 'InitialTechemLocationIntegrationsStateData';
  customerLocation: Location;
  meterLocations: Array<TechemLocationData>;
  rowIndex: Scalars['Int']['output'];
};

export type InitialVitaniLocationIntegrationsStateData = {
  __typename?: 'InitialVitaniLocationIntegrationsStateData';
  customerLocation: Location;
  meterLocations: Array<VitaniLocationData>;
  rowIndex: Scalars['Int']['output'];
};

export type InsightAssetBenchmarkPerformance = {
  __typename?: 'InsightAssetBenchmarkPerformance';
  benchmark: InsightBenchmark;
  intensity: Scalars['Float']['output'];
  performance: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type InsightBenchmark = {
  __typename?: 'InsightBenchmark';
  countryCode: Scalars['String']['output'];
  numberOfBuildings: Scalars['Float']['output'];
  segment: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<InsightBenchmarkValue>;
};

export type InsightBenchmarkValue = {
  __typename?: 'InsightBenchmarkValue';
  category: Scalars['String']['output'];
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type InsightIntensity = {
  __typename?: 'InsightIntensity';
  area: Scalars['Float']['output'];
  breakdown: Array<InsightIntensityBreakdown>;
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type InsightIntensityBreakdown = {
  __typename?: 'InsightIntensityBreakdown';
  consumption: InsightIntensityConsumption;
  factors: Array<InsightIntensityFactor>;
};

export type InsightIntensityChartData = {
  __typename?: 'InsightIntensityChartData';
  emissionIntensity?: Maybe<Scalars['Float']['output']>;
  energyIntensity?: Maybe<Scalars['Float']['output']>;
  projectedEmissionIntensity?: Maybe<Scalars['Float']['output']>;
  projectedEnergyIntensity?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Float']['output'];
};

export type InsightIntensityConsumption = {
  __typename?: 'InsightIntensityConsumption';
  type: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type InsightIntensityFactor = {
  __typename?: 'InsightIntensityFactor';
  factor: Scalars['Float']['output'];
  from: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  source: Scalars['String']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  to: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type InsightsAsset = {
  __typename?: 'InsightsAsset';
  area?: Maybe<Scalars['Float']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  properties: Array<InsightsPropertyTree>;
};

export type InsightsAssetBenchmark = {
  __typename?: 'InsightsAssetBenchmark';
  benchmarkId: Scalars['String']['output'];
  benchmarkType: Scalars['String']['output'];
  bfe: Scalars['String']['output'];
  co2BenchmarkMethod1: Scalars['Float']['output'];
  kwhMethod1: Scalars['Float']['output'];
  numberOfBuildings: Scalars['Float']['output'];
  segment: Scalars['String']['output'];
  startTs: Scalars['String']['output'];
};

export type InsightsAssetHeatInstallation = {
  __typename?: 'InsightsAssetHeatInstallation';
  bfe: Scalars['String']['output'];
  heatInstallation?: Maybe<Scalars['String']['output']>;
};

export type InsightsAssetMaterialLifespan = {
  __typename?: 'InsightsAssetMaterialLifespan';
  address: Scalars['String']['output'];
  bfe: Scalars['String']['output'];
  buildingId: Scalars['String']['output'];
  constructionYear: Scalars['Float']['output'];
  heatInstallation?: Maybe<Scalars['String']['output']>;
  outerWallMaterial?: Maybe<Scalars['String']['output']>;
  outerWallMaterialLifetime: Scalars['Float']['output'];
  renovationYear: Scalars['Float']['output'];
  roofCoverMaterial?: Maybe<Scalars['String']['output']>;
};

export type InsightsAssetOwnership = {
  __typename?: 'InsightsAssetOwnership';
  administratorName?: Maybe<Scalars['String']['output']>;
  bfe: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
};

export type InsightsAssetSalesPrice = {
  __typename?: 'InsightsAssetSalesPrice';
  bfe: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  salesDate?: Maybe<Scalars['String']['output']>;
  salesPrice: Scalars['String']['output'];
};

export type InsightsAssetWaterSupplier = {
  __typename?: 'InsightsAssetWaterSupplier';
  bfe: Scalars['String']['output'];
  waterSupplier?: Maybe<Scalars['String']['output']>;
};

export type InsightsProperty = {
  __typename?: 'InsightsProperty';
  area?: Maybe<Scalars['Float']['output']>;
  assetExternalId: Scalars['String']['output'];
  assetId: Scalars['ID']['output'];
  city: Scalars['String']['output'];
  cityCode?: Maybe<Scalars['String']['output']>;
  constructionYear: Scalars['Float']['output'];
  countryCode: Scalars['String']['output'];
  crremPropertyType: CrremCategory;
  crremPropertyTypes: Array<CrremCategory>;
  doorNumber?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  fullAddress: Scalars['String']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  nationalPropertyType: Scalars['String']['output'];
  objectType: PropertyObjectType;
  propertyType?: Maybe<PropertyType>;
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type InsightsPropertyTree = {
  __typename?: 'InsightsPropertyTree';
  area?: Maybe<Scalars['Float']['output']>;
  children: Array<InsightsPropertyTree>;
  city: Scalars['String']['output'];
  cityCode?: Maybe<Scalars['String']['output']>;
  constructionYear: Scalars['Float']['output'];
  countryCode: Scalars['String']['output'];
  crremPropertyType: CrremCategory;
  doorNumber?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  fullAddress: Scalars['String']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  nationalPropertyType: Scalars['String']['output'];
  objectType: PropertyObjectType;
  propertyType?: Maybe<PropertyType>;
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type IntegrationDexmaAssessmentData = {
  __typename?: 'IntegrationDexmaAssessmentData';
  type: Scalars['String']['output'];
};

export type IntegrationDexmaLocationIntegrationData = {
  __typename?: 'IntegrationDexmaLocationIntegrationData';
  id: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type IntegrationElectralinkAssessmentData = {
  __typename?: 'IntegrationElectralinkAssessmentData';
  msn: Scalars['String']['output'];
  registerType: Scalars['String']['output'];
  ssc: Scalars['String']['output'];
  sscName: Scalars['String']['output'];
  tpr: Scalars['String']['output'];
  tprName: Scalars['String']['output'];
};

export type IntegrationElectralinkLocationIntegrationData = {
  __typename?: 'IntegrationElectralinkLocationIntegrationData';
  address: Scalars['String']['output'];
  mpan: Scalars['Float']['output'];
  partialMpan: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
};

export type IntegrationEloverblikAssetIntegrationData = {
  __typename?: 'IntegrationEloverblikAssetIntegrationData';
  address: Scalars['String']['output'];
  consumerStartDate: Scalars['String']['output'];
  meteringPointId: Scalars['String']['output'];
  parentMeteringPointId?: Maybe<Scalars['String']['output']>;
  typeOfMP: Scalars['String']['output'];
};

export type IntegrationEntolabsLocationIntegrationData = {
  __typename?: 'IntegrationEntolabsLocationIntegrationData';
  address?: Maybe<Scalars['String']['output']>;
  entolabsOrganizationId: Scalars['String']['output'];
  meterName: Scalars['String']['output'];
  meterType: IntegrationEntolabsMeterType;
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
};

export enum IntegrationEntolabsMeterType {
  COOLING = 'COOLING',
  DISTRICT_HEATING = 'DISTRICT_HEATING',
  ELECTRICITY = 'ELECTRICITY',
  GAS = 'GAS',
  PV_CONSUMPTION = 'PV_CONSUMPTION',
  PV_EXCESS = 'PV_EXCESS',
  PV_PRODUCTION = 'PV_PRODUCTION',
  WATER = 'WATER'
}

export type IntegrationEpcAssessmentData = {
  __typename?: 'IntegrationEpcAssessmentData';
  address: Scalars['String']['output'];
  buildingNumbers: Array<Scalars['Int']['output']>;
  classification: Scalars['String']['output'];
  epcIdentifier: Scalars['String']['output'];
  nationalIdentifiers: Array<Scalars['String']['output']>;
  originalPdfLink: Scalars['String']['output'];
  pdfLink: Scalars['String']['output'];
};

export type IntegrationEpcDkAssetIntegrationData = {
  __typename?: 'IntegrationEpcDkAssetIntegrationData';
  addresses?: Maybe<Array<Scalars['String']['output']>>;
};

export type IntegrationEpcLocationIntegrationData = {
  __typename?: 'IntegrationEpcLocationIntegrationData';
  building: Scalars['String']['output'];
  municipality: Scalars['String']['output'];
  ownership?: Maybe<Scalars['Float']['output']>;
  property: Scalars['String']['output'];
};

export type IntegrationEpcUkAssessmentData = {
  __typename?: 'IntegrationEpcUkAssessmentData';
  address: Scalars['String']['output'];
  assessmentLink?: Maybe<Scalars['String']['output']>;
  classification: Scalars['String']['output'];
  lmkKey: Scalars['String']['output'];
  nationalIdentifiers: Array<Scalars['String']['output']>;
};

export type IntegrationEpcUkLocationIntegrationData = {
  __typename?: 'IntegrationEpcUkLocationIntegrationData';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  buildingType: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
};

export type IntegrationHoforAssessmentData = {
  __typename?: 'IntegrationHoforAssessmentData';
  installationNumber: Scalars['String']['output'];
};

export type IntegrationHoforLocationIntegrationData = {
  __typename?: 'IntegrationHoforLocationIntegrationData';
  installationNumber: Scalars['String']['output'];
};

export type IntegrationOisAssessmentData = {
  __typename?: 'IntegrationOISAssessmentData';
  externalId: IntegrationOisExternalId;
  oisAjour?: Maybe<Scalars['String']['output']>;
  oisId?: Maybe<Scalars['String']['output']>;
  sourceReadings?: Maybe<Array<IntegrationOisSourceReading>>;
  status?: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['String']['output'];
};

export type IntegrationOisExternalId = {
  __typename?: 'IntegrationOISExternalId';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type IntegrationOisSourceReading = {
  __typename?: 'IntegrationOISSourceReading';
  externalId?: Maybe<IntegrationOisExternalId>;
  oisAjour: Scalars['String']['output'];
  oisId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type IntegrationOisLocationIntegrationData = {
  __typename?: 'IntegrationOisLocationIntegrationData';
  bbr?: Maybe<Scalars['String']['output']>;
  bfe?: Maybe<Scalars['String']['output']>;
  mappings?: Maybe<Array<OisMapping>>;
};

export type IntegrationSoftvaerketAssetIntegrationData = {
  __typename?: 'IntegrationSoftvaerketAssetIntegrationData';
  address: Scalars['String']['output'];
  meterDatabaseId: Scalars['String']['output'];
  softvaerketSupplierId: Scalars['String']['output'];
};

export type IntegrationTechemAssessmentData = {
  __typename?: 'IntegrationTechemAssessmentData';
  meterId: Scalars['String']['output'];
};

export type IntegrationTechemLocationIntegrationData = {
  __typename?: 'IntegrationTechemLocationIntegrationData';
  propertyId: Scalars['String']['output'];
};

export enum IntegrationType {
  DEXMA = 'DEXMA',
  ELECTRALINK = 'ELECTRALINK',
  ELOVERBLIK = 'ELOVERBLIK',
  ENTOLABS = 'ENTOLABS',
  EPC = 'EPC',
  EPC_DK = 'EPC_DK',
  EPC_UK = 'EPC_UK',
  HOFOR = 'HOFOR',
  INVOICE = 'INVOICE',
  MANUAL = 'MANUAL',
  METER = 'METER',
  OIS = 'OIS',
  SOFTVAERKET = 'SOFTVAERKET',
  TECHEM = 'TECHEM',
  UN_CATEGORIZED = 'UN_CATEGORIZED',
  VITANI = 'VITANI'
}

export type IntegrationTypeFilterComparison = {
  eq?: InputMaybe<IntegrationType>;
  gt?: InputMaybe<IntegrationType>;
  gte?: InputMaybe<IntegrationType>;
  iLike?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<IntegrationType>;
  lt?: InputMaybe<IntegrationType>;
  lte?: InputMaybe<IntegrationType>;
  neq?: InputMaybe<IntegrationType>;
  notILike?: InputMaybe<IntegrationType>;
  notIn?: InputMaybe<Array<IntegrationType>>;
  notLike?: InputMaybe<IntegrationType>;
};

export type IntegrationVitaniAssessmentData = {
  __typename?: 'IntegrationVitaniAssessmentData';
  tagId: Scalars['Float']['output'];
};

export type IntegrationVitaniLocationIntegrationData = {
  __typename?: 'IntegrationVitaniLocationIntegrationData';
  directoryId: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type JsonFilterComparison = {
  eq?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  iLike?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  neq?: InputMaybe<Scalars['JSON']['input']>;
  notILike?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  notLike?: InputMaybe<Scalars['JSON']['input']>;
};

export type LabelValueOption = {
  __typename?: 'LabelValueOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LegacyBenchmark = {
  __typename?: 'LegacyBenchmark';
  benchmarkType: LegacyBenchmarkType;
  countryCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalIdentifier: Scalars['String']['output'];
  numberOfBuildings: Scalars['Float']['output'];
  segment: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  values: Array<LegacyBenchmarkValue>;
};


export type LegacyBenchmarkValuesArgs = {
  filter?: LegacyBenchmarkValueFilter;
  sorting?: Array<LegacyBenchmarkValueSort>;
};

export type LegacyBenchmarkConnection = {
  __typename?: 'LegacyBenchmarkConnection';
  /** Array of edges. */
  edges: Array<LegacyBenchmarkEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type LegacyBenchmarkDeleteFilter = {
  and?: InputMaybe<Array<LegacyBenchmarkDeleteFilter>>;
  benchmarkType?: InputMaybe<LegacyBenchmarkTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<LegacyBenchmarkDeleteFilter>>;
};

export type LegacyBenchmarkDeleteResponse = {
  __typename?: 'LegacyBenchmarkDeleteResponse';
  benchmarkType?: Maybe<LegacyBenchmarkType>;
  countryCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalIdentifier?: Maybe<Scalars['String']['output']>;
  numberOfBuildings?: Maybe<Scalars['Float']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LegacyBenchmarkEdge = {
  __typename?: 'LegacyBenchmarkEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the LegacyBenchmark */
  node: LegacyBenchmark;
};

export type LegacyBenchmarkFilter = {
  and?: InputMaybe<Array<LegacyBenchmarkFilter>>;
  benchmarkType?: InputMaybe<LegacyBenchmarkTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<LegacyBenchmarkFilter>>;
};

export type LegacyBenchmarkSort = {
  direction: SortDirection;
  field: LegacyBenchmarkSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum LegacyBenchmarkSortFields {
  BENCHMARKTYPE = 'benchmarkType',
  ID = 'id'
}

export enum LegacyBenchmarkType {
  BBR_PROPERTY_TYPE = 'BBR_PROPERTY_TYPE',
  BUILDING_AGE = 'BUILDING_AGE',
  BUILDING_SIZE = 'BUILDING_SIZE',
  CONSUMPTION_TYPE = 'CONSUMPTION_TYPE',
  CRREM_PROPERTY_TYPE = 'CRREM_PROPERTY_TYPE',
  LEGACY_PROPERTY_TYPE = 'LEGACY_PROPERTY_TYPE',
  NATIONAL = 'NATIONAL',
  REGION = 'REGION',
  VERTICAL = 'VERTICAL'
}

export type LegacyBenchmarkTypeFilterComparison = {
  eq?: InputMaybe<LegacyBenchmarkType>;
  gt?: InputMaybe<LegacyBenchmarkType>;
  gte?: InputMaybe<LegacyBenchmarkType>;
  iLike?: InputMaybe<LegacyBenchmarkType>;
  in?: InputMaybe<Array<LegacyBenchmarkType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<LegacyBenchmarkType>;
  lt?: InputMaybe<LegacyBenchmarkType>;
  lte?: InputMaybe<LegacyBenchmarkType>;
  neq?: InputMaybe<LegacyBenchmarkType>;
  notILike?: InputMaybe<LegacyBenchmarkType>;
  notIn?: InputMaybe<Array<LegacyBenchmarkType>>;
  notLike?: InputMaybe<LegacyBenchmarkType>;
};

export type LegacyBenchmarkUpdateFilter = {
  and?: InputMaybe<Array<LegacyBenchmarkUpdateFilter>>;
  benchmarkType?: InputMaybe<LegacyBenchmarkTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<LegacyBenchmarkUpdateFilter>>;
};

export type LegacyBenchmarkValue = {
  __typename?: 'LegacyBenchmarkValue';
  category: AssessmentCategory;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  to: Scalars['DateTime']['output'];
  type: LegacyBenchmarkValueType;
  unit: BenchmarkValueUnit;
  value: Scalars['Float']['output'];
};

export type LegacyBenchmarkValueFilter = {
  and?: InputMaybe<Array<LegacyBenchmarkValueFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<LegacyBenchmarkValueFilter>>;
  type?: InputMaybe<LegacyBenchmarkValueTypeFilterComparison>;
};

export type LegacyBenchmarkValueSort = {
  direction: SortDirection;
  field: LegacyBenchmarkValueSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum LegacyBenchmarkValueSortFields {
  ID = 'id',
  TYPE = 'type'
}

export enum LegacyBenchmarkValueType {
  CONSUMPTION = 'CONSUMPTION',
  EMISSION = 'EMISSION',
  EMISSION_BOTTOM_15 = 'EMISSION_BOTTOM_15',
  EMISSION_TOP_15 = 'EMISSION_TOP_15',
  EMISSION_TOP_30 = 'EMISSION_TOP_30',
  INTENSITY_MEDIAN = 'INTENSITY_MEDIAN'
}

export type LegacyBenchmarkValueTypeFilterComparison = {
  eq?: InputMaybe<LegacyBenchmarkValueType>;
  gt?: InputMaybe<LegacyBenchmarkValueType>;
  gte?: InputMaybe<LegacyBenchmarkValueType>;
  iLike?: InputMaybe<LegacyBenchmarkValueType>;
  in?: InputMaybe<Array<LegacyBenchmarkValueType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<LegacyBenchmarkValueType>;
  lt?: InputMaybe<LegacyBenchmarkValueType>;
  lte?: InputMaybe<LegacyBenchmarkValueType>;
  neq?: InputMaybe<LegacyBenchmarkValueType>;
  notILike?: InputMaybe<LegacyBenchmarkValueType>;
  notIn?: InputMaybe<Array<LegacyBenchmarkValueType>>;
  notLike?: InputMaybe<LegacyBenchmarkValueType>;
};

export type Location = {
  __typename?: 'Location';
  assessmentGroups: Array<AssessmentsCoverage>;
  assessmentSummaries: Array<AssessmentSummary>;
  assessments: Array<Assessment>;
  assetAlerts: Array<AssetAlerts>;
  benchmarkPerformances: Array<BenchmarkPerformance>;
  buildingArea?: Maybe<Scalars['Float']['output']>;
  buildings: Array<LocationMetadata>;
  city?: Maybe<Scalars['String']['output']>;
  constructionDate?: Maybe<Scalars['DateTime']['output']>;
  consumptionTypes: Array<ConsumptionType>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdBy: User;
  crremPropertyType?: Maybe<Scalars['String']['output']>;
  dataFrom?: Maybe<Scalars['DateTime']['output']>;
  dataQuality: Array<DataQuality>;
  dataTo?: Maybe<Scalars['DateTime']['output']>;
  dgnbCertification?: Maybe<DgnbCertification>;
  displayName?: Maybe<Scalars['String']['output']>;
  emissionSummaries: Array<EmissionSummary>;
  emissionSummaryInventory: Array<ReportEmissionSummaryInventoryItem>;
  epcs: Array<EpcAssessment>;
  externalId?: Maybe<Scalars['String']['output']>;
  fallbackOwnedArea?: Maybe<Scalars['Float']['output']>;
  hasData: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integrationTypes: Array<IntegrationType>;
  integrations: Array<LocationIntegration>;
  internalDescriptor?: Maybe<Scalars['String']['output']>;
  legalOwner?: Maybe<Scalars['String']['output']>;
  longAddress?: Maybe<Scalars['String']['output']>;
  management?: Maybe<LocationManagementType>;
  manualAssessments: Array<Assessment>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['String']['output'];
  ownedArea?: Maybe<Scalars['Float']['output']>;
  ownership?: Maybe<Scalars['Float']['output']>;
  ownershipType: Scalars['String']['output'];
  projectedAssessmentSummaries: Array<ProjectedAssessmentSummary>;
  projectedAssessments: Array<Assessment>;
  projectedEmissionSummaries: Array<ProjectedEmissionSummary>;
  propertyCount: Scalars['Int']['output'];
  propertyType?: Maybe<PropertyType>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  saleDate?: Maybe<Scalars['DateTime']['output']>;
  shortAddress?: Maybe<Scalars['String']['output']>;
  supplierLocations?: Maybe<Array<SupplierLocation>>;
  targetEmissionSummary: Array<TargetEmissionSummary>;
  /** @deprecated Use `targetEmissionSummary` instead */
  targetEmissions?: Maybe<Array<TargetEmission>>;
  updatedBy: User;
  validateEmissions?: Maybe<Array<LocationEmissionTotal>>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type LocationAssessmentGroupsArgs = {
  aggregation?: InputMaybe<AssessmentAggregation>;
  categories?: InputMaybe<Array<AssessmentCategory>>;
  excludeCategories?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentQueryFilter>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreProxy?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<Array<AssessmentVertical>>;
};


export type LocationAssessmentSummariesArgs = {
  filter?: AssessmentSummaryFilter;
  sorting?: Array<AssessmentSummarySort>;
};


export type LocationAssessmentsArgs = {
  aggregation?: InputMaybe<AssessmentAggregation>;
  categories?: InputMaybe<Array<AssessmentCategory>>;
  excludeCategories?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentQueryFilter>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreProxy?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<Array<AssessmentVertical>>;
};


export type LocationAssetAlertsArgs = {
  filter?: AssetAlertsFilter;
  sorting?: Array<AssetAlertsSort>;
};


export type LocationBenchmarkPerformancesArgs = {
  filter?: BenchmarkPerformanceFilter;
  sorting?: Array<BenchmarkPerformanceSort>;
};


export type LocationBuildingsArgs = {
  filter?: LocationMetadataFilter;
  sorting?: Array<LocationMetadataSort>;
};


export type LocationDataFromArgs = {
  aggregation?: InputMaybe<AssessmentAggregation>;
  categories?: InputMaybe<Array<AssessmentCategory>>;
  excludeCategories?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentQueryFilter>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreProxy?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<Array<AssessmentVertical>>;
};


export type LocationDataQualityArgs = {
  aggregation?: InputMaybe<AssessmentAggregation>;
  categories?: InputMaybe<Array<AssessmentCategory>>;
  excludeCategories?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentQueryFilter>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreProxy?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<Array<AssessmentVertical>>;
};


export type LocationDataToArgs = {
  aggregation?: InputMaybe<AssessmentAggregation>;
  categories?: InputMaybe<Array<AssessmentCategory>>;
  excludeCategories?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentQueryFilter>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreProxy?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<Array<AssessmentVertical>>;
};


export type LocationEmissionSummariesArgs = {
  aggregation: AssessmentAggregation;
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type LocationEmissionSummaryInventoryArgs = {
  aggregation: AssessmentAggregation;
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['input'];
  language?: ReportLanguage;
  to: Scalars['DateTime']['input'];
};


export type LocationEpcsArgs = {
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type LocationFallbackOwnedAreaArgs = {
  aggregation: AssessmentAggregation;
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type LocationHasDataArgs = {
  aggregation: AssessmentAggregation;
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type LocationIntegrationsArgs = {
  filter?: LocationIntegrationFilter;
  sorting?: Array<LocationIntegrationSort>;
};


export type LocationProjectedAssessmentSummariesArgs = {
  filter?: ProjectedAssessmentSummaryFilter;
  sorting?: Array<ProjectedAssessmentSummarySort>;
};


export type LocationProjectedAssessmentsArgs = {
  aggregation?: InputMaybe<AssessmentAggregation>;
  categories?: InputMaybe<Array<AssessmentCategory>>;
  excludeCategories?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentQueryFilter>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreProxy?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<Array<AssessmentVertical>>;
};


export type LocationProjectedEmissionSummariesArgs = {
  aggregation: AssessmentAggregation;
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type LocationSupplierLocationsArgs = {
  filter?: SupplierLocationFilter;
  sorting?: Array<SupplierLocationSort>;
};


export type LocationTargetEmissionSummaryArgs = {
  dataType: AssessmentDataType;
};


export type LocationValidateEmissionsArgs = {
  dataType?: InputMaybe<AssessmentDataType>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationAggregateFilter = {
  and?: InputMaybe<Array<LocationAggregateFilter>>;
  assetGroupId?: InputMaybe<LocationAssetGroupIdFilterComparison>;
  benchmarkId?: InputMaybe<LocationBenchmarkIdFilterComparison>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  dataType?: InputMaybe<LocationDataTypeFilterComparison>;
  displayName?: InputMaybe<LocationDisplayNameFilterComparison>;
  emissionIntensitySort?: InputMaybe<LocationEmissionIntensitySortFilterComparison>;
  emissionSort?: InputMaybe<LocationEmissionSortFilterComparison>;
  energyIntensitySort?: InputMaybe<LocationEnergyIntensitySortFilterComparison>;
  energySort?: InputMaybe<LocationEnergySortFilterComparison>;
  externalId?: InputMaybe<StringFieldComparison>;
  from?: InputMaybe<LocationFromFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  legalOwner?: InputMaybe<StringFieldComparison>;
  management?: InputMaybe<LocationManagementTypeFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationAggregateFilter>>;
  organization?: InputMaybe<LocationAggregateFilterOrganizationAggregateFilter>;
  organizationId?: InputMaybe<StringFieldComparison>;
  ownership?: InputMaybe<NumberFieldComparison>;
  ownershipType?: InputMaybe<StringFieldComparison>;
  performance?: InputMaybe<LocationPerformanceFilterComparison>;
  purchaseDate?: InputMaybe<DateFieldComparison>;
  saleDate?: InputMaybe<DateFieldComparison>;
};

export type LocationAggregateFilterOrganizationAggregateFilter = {
  and?: InputMaybe<Array<LocationAggregateFilterOrganizationAggregateFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationAggregateFilterOrganizationAggregateFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
};

export type LocationAssetGroupIdFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type LocationBenchmarkIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
};

export type LocationCityFilter = {
  __typename?: 'LocationCityFilter';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
};

export type LocationConnection = {
  __typename?: 'LocationConnection';
  /** Array of edges. */
  edges: Array<LocationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type LocationDataTypeFilterComparison = {
  eq?: InputMaybe<AssessmentDataType>;
};

export type LocationDisplayNameFilterComparison = {
  iLike?: InputMaybe<Scalars['String']['input']>;
};

export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Location */
  node: Location;
};

export type LocationEmissionIntensitySortFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationEmissionSortFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationEmissionTotal = {
  __typename?: 'LocationEmissionTotal';
  assessmentEmission: Scalars['Float']['output'];
  difference: Scalars['Float']['output'];
  emissionSummaryEmission: Scalars['Float']['output'];
  key: Scalars['String']['output'];
};

export type LocationEnergyIntensitySortFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationEnergySortFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationFilter = {
  and?: InputMaybe<Array<LocationFilter>>;
  assetGroupId?: InputMaybe<LocationAssetGroupIdFilterComparison>;
  benchmarkId?: InputMaybe<LocationBenchmarkIdFilterComparison>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  dataType?: InputMaybe<LocationDataTypeFilterComparison>;
  displayName?: InputMaybe<LocationDisplayNameFilterComparison>;
  emissionIntensitySort?: InputMaybe<LocationEmissionIntensitySortFilterComparison>;
  emissionSort?: InputMaybe<LocationEmissionSortFilterComparison>;
  energyIntensitySort?: InputMaybe<LocationEnergyIntensitySortFilterComparison>;
  energySort?: InputMaybe<LocationEnergySortFilterComparison>;
  externalId?: InputMaybe<StringFieldComparison>;
  from?: InputMaybe<LocationFromFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  legalOwner?: InputMaybe<StringFieldComparison>;
  management?: InputMaybe<LocationManagementTypeFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationFilter>>;
  organization?: InputMaybe<LocationFilterOrganizationFilter>;
  organizationId?: InputMaybe<StringFieldComparison>;
  ownership?: InputMaybe<NumberFieldComparison>;
  ownershipType?: InputMaybe<StringFieldComparison>;
  performance?: InputMaybe<LocationPerformanceFilterComparison>;
  purchaseDate?: InputMaybe<DateFieldComparison>;
  saleDate?: InputMaybe<DateFieldComparison>;
};

export type LocationFilterOrganizationFilter = {
  and?: InputMaybe<Array<LocationFilterOrganizationFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationFilterOrganizationFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
};

export type LocationFromFilterComparison = {
  between?: InputMaybe<LocationFromFilterComparisonBetween>;
};

export type LocationFromFilterComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type LocationIntegration = {
  __typename?: 'LocationIntegration';
  address?: Maybe<Scalars['String']['output']>;
  allocationNote?: Maybe<Scalars['String']['output']>;
  allocations: Array<AssetIntegrationAllocation>;
  assetId: Scalars['String']['output'];
  consumptionTypes: Array<ConsumptionType>;
  data: LocationIntegrationData;
  dataQuality?: Maybe<DataQualityTypes>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastAssessments: Array<Assessment>;
  /** @deprecated Use assetId instead */
  locationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Will always return null. Use originId for OIS meter instead. */
  meters?: Maybe<Array<LocationIntegrationMeter>>;
  originId: Scalars['String']['output'];
  ownershipType: PropertyOwnershipType;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  type: IntegrationType;
};


export type LocationIntegrationAllocationsArgs = {
  filter?: AssetIntegrationAllocationFilter;
  sorting?: Array<AssetIntegrationAllocationSort>;
};

export type LocationIntegrationAllocationTypesFilterComparison = {
  in?: InputMaybe<Array<AllocationObjectType>>;
};

export type LocationIntegrationConnection = {
  __typename?: 'LocationIntegrationConnection';
  /** Array of edges. */
  edges: Array<LocationIntegrationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type LocationIntegrationConsumptionTypesFilterComparison = {
  in?: InputMaybe<Array<ConsumptionType>>;
};

export type LocationIntegrationData = IntegrationDexmaLocationIntegrationData | IntegrationElectralinkLocationIntegrationData | IntegrationEloverblikAssetIntegrationData | IntegrationEntolabsLocationIntegrationData | IntegrationEpcDkAssetIntegrationData | IntegrationEpcLocationIntegrationData | IntegrationEpcUkLocationIntegrationData | IntegrationHoforLocationIntegrationData | IntegrationOisLocationIntegrationData | IntegrationSoftvaerketAssetIntegrationData | IntegrationTechemLocationIntegrationData | IntegrationVitaniLocationIntegrationData | OriginIntegrationData;

export type LocationIntegrationDeleteFilter = {
  allocationNote?: InputMaybe<StringFieldComparison>;
  allocationTypes?: InputMaybe<LocationIntegrationAllocationTypesFilterComparison>;
  and?: InputMaybe<Array<LocationIntegrationDeleteFilter>>;
  assetId?: InputMaybe<StringFieldComparison>;
  consumptionTypes?: InputMaybe<LocationIntegrationConsumptionTypesFilterComparison>;
  endedAt?: InputMaybe<DateFieldComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  isActive?: InputMaybe<LocationIntegrationIsActiveFilterComparison>;
  or?: InputMaybe<Array<LocationIntegrationDeleteFilter>>;
  originId?: InputMaybe<StringFieldComparison>;
  ownershipType?: InputMaybe<PropertyOwnershipTypeFilterComparison>;
  startedAt?: InputMaybe<DateFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  type?: InputMaybe<IntegrationTypeFilterComparison>;
};

export type LocationIntegrationDeleteResponse = {
  __typename?: 'LocationIntegrationDeleteResponse';
  allocationNote?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  originId?: Maybe<Scalars['String']['output']>;
  ownershipType?: Maybe<PropertyOwnershipType>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<IntegrationType>;
};

export type LocationIntegrationEdge = {
  __typename?: 'LocationIntegrationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the LocationIntegration */
  node: LocationIntegration;
};

export type LocationIntegrationFilter = {
  allocationNote?: InputMaybe<StringFieldComparison>;
  allocationTypes?: InputMaybe<LocationIntegrationAllocationTypesFilterComparison>;
  allocations?: InputMaybe<LocationIntegrationFilterAssetIntegrationAllocationFilter>;
  and?: InputMaybe<Array<LocationIntegrationFilter>>;
  assetId?: InputMaybe<StringFieldComparison>;
  consumptionTypes?: InputMaybe<LocationIntegrationConsumptionTypesFilterComparison>;
  endedAt?: InputMaybe<DateFieldComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  isActive?: InputMaybe<LocationIntegrationIsActiveFilterComparison>;
  or?: InputMaybe<Array<LocationIntegrationFilter>>;
  originId?: InputMaybe<StringFieldComparison>;
  ownershipType?: InputMaybe<PropertyOwnershipTypeFilterComparison>;
  startedAt?: InputMaybe<DateFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  type?: InputMaybe<IntegrationTypeFilterComparison>;
};

export type LocationIntegrationFilterAssetIntegrationAllocationFilter = {
  and?: InputMaybe<Array<LocationIntegrationFilterAssetIntegrationAllocationFilter>>;
  assetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<LocationIntegrationFilterAssetIntegrationAllocationFilter>>;
  percentage?: InputMaybe<NumberFieldComparison>;
  propertyId?: InputMaybe<IdFilterComparison>;
};

export type LocationIntegrationIsActiveFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationIntegrationMeter = {
  __typename?: 'LocationIntegrationMeter';
  address?: Maybe<Scalars['String']['output']>;
  meterId?: Maybe<Scalars['String']['output']>;
  nationalBuildingId?: Maybe<Scalars['String']['output']>;
  vertical?: Maybe<AssessmentVertical>;
};

export type LocationIntegrationSort = {
  direction: SortDirection;
  field: LocationIntegrationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum LocationIntegrationSortFields {
  ALLOCATIONNOTE = 'allocationNote',
  ALLOCATIONTYPES = 'allocationTypes',
  ASSETID = 'assetId',
  CONSUMPTIONTYPES = 'consumptionTypes',
  ENDEDAT = 'endedAt',
  FROM = 'from',
  ID = 'id',
  IDENTIFIER = 'identifier',
  ISACTIVE = 'isActive',
  ORIGINID = 'originId',
  OWNERSHIPTYPE = 'ownershipType',
  STARTEDAT = 'startedAt',
  TO = 'to',
  TYPE = 'type'
}

export type LocationIntegrationUpdateFilter = {
  allocationNote?: InputMaybe<StringFieldComparison>;
  allocationTypes?: InputMaybe<LocationIntegrationAllocationTypesFilterComparison>;
  and?: InputMaybe<Array<LocationIntegrationUpdateFilter>>;
  assetId?: InputMaybe<StringFieldComparison>;
  consumptionTypes?: InputMaybe<LocationIntegrationConsumptionTypesFilterComparison>;
  endedAt?: InputMaybe<DateFieldComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  identifier?: InputMaybe<StringFieldComparison>;
  isActive?: InputMaybe<LocationIntegrationIsActiveFilterComparison>;
  or?: InputMaybe<Array<LocationIntegrationUpdateFilter>>;
  originId?: InputMaybe<StringFieldComparison>;
  ownershipType?: InputMaybe<PropertyOwnershipTypeFilterComparison>;
  startedAt?: InputMaybe<DateFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  type?: InputMaybe<IntegrationTypeFilterComparison>;
};

export enum LocationManagementType {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

export type LocationManagementTypeFilterComparison = {
  eq?: InputMaybe<LocationManagementType>;
  gt?: InputMaybe<LocationManagementType>;
  gte?: InputMaybe<LocationManagementType>;
  iLike?: InputMaybe<LocationManagementType>;
  in?: InputMaybe<Array<LocationManagementType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<LocationManagementType>;
  lt?: InputMaybe<LocationManagementType>;
  lte?: InputMaybe<LocationManagementType>;
  neq?: InputMaybe<LocationManagementType>;
  notILike?: InputMaybe<LocationManagementType>;
  notIn?: InputMaybe<Array<LocationManagementType>>;
  notLike?: InputMaybe<LocationManagementType>;
};

export type LocationMetadata = {
  __typename?: 'LocationMetadata';
  address?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Use externalId instead */
  bbr: Scalars['String']['output'];
  buildingArea?: Maybe<Scalars['Float']['output']>;
  buildingCategory?: Maybe<MetadataBuildingCategory>;
  constructionDate?: Maybe<Scalars['DateTime']['output']>;
  createdBy: User;
  externalId: Scalars['ID']['output'];
  location: Location;
  locationId?: Maybe<Scalars['String']['output']>;
  longAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationalIdentifier?: Maybe<Scalars['String']['output']>;
  shortAddress?: Maybe<Scalars['String']['output']>;
  updatedBy: User;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type LocationMetadataConnection = {
  __typename?: 'LocationMetadataConnection';
  /** Array of edges. */
  edges: Array<LocationMetadataEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type LocationMetadataDeleteFilter = {
  address?: InputMaybe<JsonFilterComparison>;
  and?: InputMaybe<Array<LocationMetadataDeleteFilter>>;
  buildingArea?: InputMaybe<NumberFieldComparison>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  externalId?: InputMaybe<IdFilterComparison>;
  locationId?: InputMaybe<StringFieldComparison>;
  longAddress?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  nationalIdentifier?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationMetadataDeleteFilter>>;
  shortAddress?: InputMaybe<StringFieldComparison>;
};

export type LocationMetadataDeleteResponse = {
  __typename?: 'LocationMetadataDeleteResponse';
  address?: Maybe<Scalars['JSON']['output']>;
  buildingArea?: Maybe<Scalars['Float']['output']>;
  constructionDate?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['ID']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  longAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationalIdentifier?: Maybe<Scalars['String']['output']>;
  shortAddress?: Maybe<Scalars['String']['output']>;
};

export type LocationMetadataEdge = {
  __typename?: 'LocationMetadataEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the LocationMetadata */
  node: LocationMetadata;
};

export type LocationMetadataFilter = {
  address?: InputMaybe<JsonFilterComparison>;
  and?: InputMaybe<Array<LocationMetadataFilter>>;
  buildingArea?: InputMaybe<NumberFieldComparison>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<LocationMetadataFilterUserFilter>;
  externalId?: InputMaybe<IdFilterComparison>;
  location?: InputMaybe<LocationMetadataFilterLocationFilter>;
  locationId?: InputMaybe<StringFieldComparison>;
  longAddress?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  nationalIdentifier?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationMetadataFilter>>;
  shortAddress?: InputMaybe<StringFieldComparison>;
  updatedBy?: InputMaybe<LocationMetadataFilterUserFilter>;
};

export type LocationMetadataFilterLocationFilter = {
  and?: InputMaybe<Array<LocationMetadataFilterLocationFilter>>;
  assetGroupId?: InputMaybe<LocationAssetGroupIdFilterComparison>;
  benchmarkId?: InputMaybe<LocationBenchmarkIdFilterComparison>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  dataType?: InputMaybe<LocationDataTypeFilterComparison>;
  displayName?: InputMaybe<LocationDisplayNameFilterComparison>;
  emissionIntensitySort?: InputMaybe<LocationEmissionIntensitySortFilterComparison>;
  emissionSort?: InputMaybe<LocationEmissionSortFilterComparison>;
  energyIntensitySort?: InputMaybe<LocationEnergyIntensitySortFilterComparison>;
  energySort?: InputMaybe<LocationEnergySortFilterComparison>;
  externalId?: InputMaybe<StringFieldComparison>;
  from?: InputMaybe<LocationFromFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  legalOwner?: InputMaybe<StringFieldComparison>;
  management?: InputMaybe<LocationManagementTypeFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationMetadataFilterLocationFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  ownership?: InputMaybe<NumberFieldComparison>;
  ownershipType?: InputMaybe<StringFieldComparison>;
  performance?: InputMaybe<LocationPerformanceFilterComparison>;
  purchaseDate?: InputMaybe<DateFieldComparison>;
  saleDate?: InputMaybe<DateFieldComparison>;
};

export type LocationMetadataFilterUserFilter = {
  and?: InputMaybe<Array<LocationMetadataFilterUserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationMetadataFilterUserFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type LocationMetadataSort = {
  direction: SortDirection;
  field: LocationMetadataSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum LocationMetadataSortFields {
  ADDRESS = 'address',
  BUILDINGAREA = 'buildingArea',
  CONSTRUCTIONDATE = 'constructionDate',
  EXTERNALID = 'externalId',
  LOCATIONID = 'locationId',
  LONGADDRESS = 'longAddress',
  NAME = 'name',
  NATIONALIDENTIFIER = 'nationalIdentifier',
  SHORTADDRESS = 'shortAddress'
}

export type LocationMetadataUpdateFilter = {
  address?: InputMaybe<JsonFilterComparison>;
  and?: InputMaybe<Array<LocationMetadataUpdateFilter>>;
  buildingArea?: InputMaybe<NumberFieldComparison>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  externalId?: InputMaybe<IdFilterComparison>;
  locationId?: InputMaybe<StringFieldComparison>;
  longAddress?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  nationalIdentifier?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationMetadataUpdateFilter>>;
  shortAddress?: InputMaybe<StringFieldComparison>;
};

export type LocationPerformanceFilterComparison = {
  gt?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
};

export type LocationSort = {
  direction: SortDirection;
  field: LocationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum LocationSortFields {
  ASSETGROUPID = 'assetGroupId',
  BENCHMARKID = 'benchmarkId',
  CONSTRUCTIONDATE = 'constructionDate',
  DATATYPE = 'dataType',
  DISPLAYNAME = 'displayName',
  EMISSIONINTENSITYSORT = 'emissionIntensitySort',
  EMISSIONSORT = 'emissionSort',
  ENERGYINTENSITYSORT = 'energyIntensitySort',
  ENERGYSORT = 'energySort',
  EXTERNALID = 'externalId',
  FROM = 'from',
  ID = 'id',
  INTERNALDESCRIPTOR = 'internalDescriptor',
  LEGALOWNER = 'legalOwner',
  MANAGEMENT = 'management',
  NAME = 'name',
  ORGANIZATIONID = 'organizationId',
  OWNERSHIP = 'ownership',
  OWNERSHIPTYPE = 'ownershipType',
  PERFORMANCE = 'performance',
  PURCHASEDATE = 'purchaseDate',
  SALEDATE = 'saleDate'
}

export type LocationUpdateFilter = {
  and?: InputMaybe<Array<LocationUpdateFilter>>;
  assetGroupId?: InputMaybe<LocationAssetGroupIdFilterComparison>;
  benchmarkId?: InputMaybe<LocationBenchmarkIdFilterComparison>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  dataType?: InputMaybe<LocationDataTypeFilterComparison>;
  displayName?: InputMaybe<LocationDisplayNameFilterComparison>;
  emissionIntensitySort?: InputMaybe<LocationEmissionIntensitySortFilterComparison>;
  emissionSort?: InputMaybe<LocationEmissionSortFilterComparison>;
  energyIntensitySort?: InputMaybe<LocationEnergyIntensitySortFilterComparison>;
  energySort?: InputMaybe<LocationEnergySortFilterComparison>;
  externalId?: InputMaybe<StringFieldComparison>;
  from?: InputMaybe<LocationFromFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  legalOwner?: InputMaybe<StringFieldComparison>;
  management?: InputMaybe<LocationManagementTypeFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LocationUpdateFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  ownership?: InputMaybe<NumberFieldComparison>;
  ownershipType?: InputMaybe<StringFieldComparison>;
  performance?: InputMaybe<LocationPerformanceFilterComparison>;
  purchaseDate?: InputMaybe<DateFieldComparison>;
  saleDate?: InputMaybe<DateFieldComparison>;
};

export type LocationsForDexmaIntegrationResponse = {
  __typename?: 'LocationsForDexmaIntegrationResponse';
  initialLocationIntegrationsState?: Maybe<Array<InitialDexmaLocationIntegrationsStateData>>;
  meterLocations: Array<DexmaLocationData>;
};

export type LocationsForElectralinkIntegrationResponse = {
  __typename?: 'LocationsForElectralinkIntegrationResponse';
  initialLocationIntegrationsState: Array<InitialElectralinkLocationIntegrationsState>;
  meterLocations: Array<ElectralinkLocation>;
};

export type LocationsForEloverblik = {
  __typename?: 'LocationsForEloverblik';
  initialLocationIntegrationsState: Array<EloverblikInitialState>;
  meterLocations: Array<EloverblikMeter>;
};

export type LocationsForEntolabsIntegrationResponse = {
  __typename?: 'LocationsForEntolabsIntegrationResponse';
  initialLocationIntegrationsState?: Maybe<Array<InitialEntolabsLocationIntegrationsStateData>>;
  meterLocations: Array<EntolabsLocationData>;
};

export type LocationsForHoforIntegrationResponse = {
  __typename?: 'LocationsForHoforIntegrationResponse';
  initialLocationIntegrationsState?: Maybe<Array<InitialHoforLocationIntegrationsStateData>>;
  meterLocations: Array<HoforLocationData>;
};

export type LocationsForSoftvaerket = {
  __typename?: 'LocationsForSoftvaerket';
  initialLocationIntegrationsState: Array<InitialState>;
  meterLocations: Array<SoftvaerketMeter>;
};

export type LocationsForTechemIntegrationResponse = {
  __typename?: 'LocationsForTechemIntegrationResponse';
  initialLocationIntegrationsState?: Maybe<Array<InitialTechemLocationIntegrationsStateData>>;
  meterLocations: Array<TechemLocationData>;
};

export type LocationsForVitaniIntegrationResponse = {
  __typename?: 'LocationsForVitaniIntegrationResponse';
  initialLocationIntegrationsState?: Maybe<Array<InitialVitaniLocationIntegrationsStateData>>;
  meterLocations: Array<VitaniLocationData>;
};

export type ManualAssessmentData = {
  __typename?: 'ManualAssessmentData';
  identifier?: Maybe<Scalars['String']['output']>;
};

export type MetadataBuildingArea = {
  __typename?: 'MetadataBuildingArea';
  area: MetadataBuildingAreaInterval;
  floorAreaType: FloorAreaType;
};

export type MetadataBuildingAreaInterval = {
  __typename?: 'MetadataBuildingAreaInterval';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type MetadataBuildingCategory = {
  __typename?: 'MetadataBuildingCategory';
  label: Scalars['String']['output'];
  useCode?: Maybe<Scalars['Float']['output']>;
};

export type MeterIntegration = {
  __typename?: 'MeterIntegration';
  category: AssessmentCategory;
  lastReading: Scalars['String']['output'];
  originId: Scalars['String']['output'];
  type: IntegrationType;
};

export type MissingMeterDataAlertData = {
  __typename?: 'MissingMeterDataAlertData';
  meterIntegrations: Array<MeterIntegration>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAssessmentsToAssessmentOrigin: AssessmentOrigin;
  addAssetProperty: Array<Property>;
  addLocationIntegration: Array<LocationIntegration>;
  addOrganizationIntegrationWithData: OrganizationIntegration;
  createManualConsumptions: Array<Assessment>;
  createManyAssessmentOrigins: Array<AssessmentOrigin>;
  createManyAssessments: Array<Assessment>;
  createManyAssetGroups: Array<AssetGroup>;
  createManyCRREMPathways: Array<CrremPathway>;
  createManyEnergyConversionFactors: Array<EnergyConversionFactor>;
  createManyLegacyBenchmarks: Array<LegacyBenchmark>;
  createManyLocationIntegrations: Array<LocationIntegration>;
  createManyLocationMetadata: Array<LocationMetadata>;
  createManyLocations: Array<Location>;
  createManyOrganizationIntegrations: Array<OrganizationIntegration>;
  createManyOrganizations: Array<Organization>;
  createManyPriorityBasedEmissionFactors: Array<PriorityBasedEmissionFactor>;
  createManyReports: Array<Report>;
  createManySupplierLocations: Array<SupplierLocation>;
  createManySuppliers: Array<Supplier>;
  createManyTargetSettings: Array<TargetSetting>;
  createManyUsers: Array<User>;
  createOneAssessment: Assessment;
  createOneAssessmentOrigin: AssessmentOrigin;
  createOneAssetGroup: AssetGroup;
  createOneCRREMPathway: CrremPathway;
  createOneEnergyConversionFactor: EnergyConversionFactor;
  createOneLegacyBenchmark: LegacyBenchmark;
  createOneLocation: Location;
  createOneLocationIntegration: LocationIntegration;
  createOneLocationMetadata: LocationMetadata;
  createOneOrganization: Organization;
  createOneOrganizationIntegration: OrganizationIntegration;
  createOnePriorityBasedEmissionFactor: PriorityBasedEmissionFactor;
  createOneReport: Report;
  createOneSupplier: Supplier;
  createOneSupplierLocation: SupplierLocation;
  createOneTargetSetting: TargetSetting;
  createOneUser: User;
  createReport: Report;
  deleteAssessment: Assessment;
  deleteAssetProperty: Scalars['ID']['output'];
  deleteLocationIntegration?: Maybe<Array<LocationIntegration>>;
  deleteManyAssessmentOrigins: DeleteManyResponse;
  deleteManyAssessments: DeleteManyResponse;
  deleteManyAssetGroups: DeleteManyResponse;
  deleteManyCRREMPathways: DeleteManyResponse;
  deleteManyEnergyConversionFactors: DeleteManyResponse;
  deleteManyLegacyBenchmarks: DeleteManyResponse;
  deleteManyLocationIntegrations: DeleteManyResponse;
  deleteManyLocationMetadata: DeleteManyResponse;
  deleteManyOrganizations: DeleteManyResponse;
  deleteManyPriorityBasedEmissionFactors: DeleteManyResponse;
  deleteManySupplierLocations: DeleteManyResponse;
  deleteManySuppliers: DeleteManyResponse;
  deleteManyTargetSettings: DeleteManyResponse;
  deleteManyUsers: DeleteManyResponse;
  deleteOneAssessment: AssessmentDeleteResponse;
  deleteOneAssessmentOrigin: AssessmentOriginDeleteResponse;
  deleteOneAssetGroup: AssetGroupDeleteResponse;
  deleteOneCRREMPathway: CrremPathwayDeleteResponse;
  deleteOneEnergyConversionFactor: EnergyConversionFactorDeleteResponse;
  deleteOneLegacyBenchmark: LegacyBenchmarkDeleteResponse;
  deleteOneLocationIntegration: LocationIntegrationDeleteResponse;
  deleteOneLocationMetadata: LocationMetadataDeleteResponse;
  deleteOneOrganization: OrganizationDeleteResponse;
  deleteOnePriorityBasedEmissionFactor: PriorityBasedEmissionFactorDeleteResponse;
  deleteOneProperty: PropertyDeleteResponse;
  deleteOneReport: ReportDeleteResponse;
  deleteOneSupplier: SupplierDeleteResponse;
  deleteOneSupplierLocation: SupplierLocationDeleteResponse;
  deleteOneTargetSetting: TargetSettingDeleteResponse;
  deleteOneUser: UserDeleteResponse;
  deleteReport: Report;
  setAssessmentsOnAssessmentOrigin: AssessmentOrigin;
  setFileOnAssessmentOrigin: AssessmentOrigin;
  updateAssetIntegrationAllocations: LocationIntegration;
  updateManualConsumption?: Maybe<Assessment>;
  updateManyAssessmentOrigins: UpdateManyResponse;
  updateManyAssessments: UpdateManyResponse;
  updateManyAssetGroups: UpdateManyResponse;
  updateManyCRREMPathways: UpdateManyResponse;
  updateManyEnergyConversionFactors: UpdateManyResponse;
  updateManyLegacyBenchmarks: UpdateManyResponse;
  updateManyLocationIntegrations: UpdateManyResponse;
  updateManyLocationMetadata: UpdateManyResponse;
  updateManyLocations: UpdateManyResponse;
  updateManyOrganizations: UpdateManyResponse;
  updateManyPriorityBasedEmissionFactors: UpdateManyResponse;
  updateManyProperties: UpdateManyResponse;
  updateManyReports: UpdateManyResponse;
  updateManySupplierLocations: UpdateManyResponse;
  updateManySuppliers: UpdateManyResponse;
  updateManyTargetSettings: UpdateManyResponse;
  updateManyUsers: UpdateManyResponse;
  updateMe: User;
  updateOneAssessment: Assessment;
  updateOneAssessmentOrigin: AssessmentOrigin;
  updateOneAssetGroup: AssetGroup;
  updateOneCRREMPathway: CrremPathway;
  updateOneEnergyConversionFactor: EnergyConversionFactor;
  updateOneLegacyBenchmark: LegacyBenchmark;
  updateOneLocation: Location;
  updateOneLocationIntegration: LocationIntegration;
  updateOneLocationMetadata: LocationMetadata;
  updateOneOrganization: Organization;
  updateOneOrganizationIntegration: OrganizationIntegration;
  updateOnePriorityBasedEmissionFactor: PriorityBasedEmissionFactor;
  updateOneProperty: Property;
  updateOneReport: Report;
  updateOneSupplier: Supplier;
  updateOneSupplierLocation: SupplierLocation;
  updateOneTargetSetting: TargetSetting;
  updateOneUser: User;
  uploadFile: File;
  upsertManyLocationMetadata: Array<LocationMetadata>;
};


export type MutationAddAssessmentsToAssessmentOriginArgs = {
  input: AddAssessmentsToAssessmentOriginInput;
};


export type MutationAddAssetPropertyArgs = {
  input: AddAssetPropertyInput;
};


export type MutationAddLocationIntegrationArgs = {
  input: Array<CreateAssetIntegrationInput>;
};


export type MutationAddOrganizationIntegrationWithDataArgs = {
  integrationData: OrganizationIntegrationData;
};


export type MutationCreateManualConsumptionsArgs = {
  input: Array<CreateManualConsumptionInput>;
};


export type MutationCreateManyAssessmentOriginsArgs = {
  input: CreateManyAssessmentOriginsInput;
};


export type MutationCreateManyAssessmentsArgs = {
  input: CreateManyAssessmentsInput;
};


export type MutationCreateManyAssetGroupsArgs = {
  input: CreateManyAssetGroupsInput;
};


export type MutationCreateManyCrremPathwaysArgs = {
  input: CreateManyCrremPathwaysInput;
};


export type MutationCreateManyEnergyConversionFactorsArgs = {
  input: CreateManyEnergyConversionFactorsInput;
};


export type MutationCreateManyLegacyBenchmarksArgs = {
  input: CreateManyLegacyBenchmarksInput;
};


export type MutationCreateManyLocationIntegrationsArgs = {
  input: CreateManyLocationIntegrationsInput;
};


export type MutationCreateManyLocationMetadataArgs = {
  input: CreateManyLocationMetadataInput;
};


export type MutationCreateManyLocationsArgs = {
  input: CreateManyLocationsInput;
};


export type MutationCreateManyOrganizationIntegrationsArgs = {
  input: CreateManyOrganizationIntegrationsInput;
};


export type MutationCreateManyOrganizationsArgs = {
  input: CreateManyOrganizationsInput;
};


export type MutationCreateManyPriorityBasedEmissionFactorsArgs = {
  input: CreateManyPriorityBasedEmissionFactorsInput;
};


export type MutationCreateManyReportsArgs = {
  input: CreateManyReportsInput;
};


export type MutationCreateManySupplierLocationsArgs = {
  input: CreateManySupplierLocationsInput;
};


export type MutationCreateManySuppliersArgs = {
  input: CreateManySuppliersInput;
};


export type MutationCreateManyTargetSettingsArgs = {
  input: CreateManyTargetSettingsInput;
};


export type MutationCreateManyUsersArgs = {
  input: CreateManyUsersInput;
};


export type MutationCreateOneAssessmentArgs = {
  input: CreateOneAssessmentInput;
};


export type MutationCreateOneAssessmentOriginArgs = {
  input: CreateOneAssessmentOriginInput;
};


export type MutationCreateOneAssetGroupArgs = {
  input: CreateOneAssetGroupInput;
};


export type MutationCreateOneCrremPathwayArgs = {
  input: CreateOneCrremPathwayInput;
};


export type MutationCreateOneEnergyConversionFactorArgs = {
  input: CreateOneEnergyConversionFactorInput;
};


export type MutationCreateOneLegacyBenchmarkArgs = {
  input: CreateOneLegacyBenchmarkInput;
};


export type MutationCreateOneLocationArgs = {
  input: CreateOneLocationInput;
};


export type MutationCreateOneLocationIntegrationArgs = {
  input: CreateOneLocationIntegrationInput;
};


export type MutationCreateOneLocationMetadataArgs = {
  input: CreateOneLocationMetadataInput;
};


export type MutationCreateOneOrganizationArgs = {
  input: CreateOneOrganizationInput;
};


export type MutationCreateOneOrganizationIntegrationArgs = {
  input: CreateOneOrganizationIntegrationInput;
};


export type MutationCreateOnePriorityBasedEmissionFactorArgs = {
  input: CreateOnePriorityBasedEmissionFactorInput;
};


export type MutationCreateOneReportArgs = {
  input: CreateOneReportInput;
};


export type MutationCreateOneSupplierArgs = {
  input: CreateOneSupplierInput;
};


export type MutationCreateOneSupplierLocationArgs = {
  input: CreateOneSupplierLocationInput;
};


export type MutationCreateOneTargetSettingArgs = {
  input: CreateOneTargetSettingInput;
};


export type MutationCreateOneUserArgs = {
  input: CreateOneUserInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationDeleteAssessmentArgs = {
  input: DeleteAssessmentInput;
};


export type MutationDeleteAssetPropertyArgs = {
  input: DeleteAssetPropertyInput;
};


export type MutationDeleteLocationIntegrationArgs = {
  input: Array<DeleteLocationIntegrationInput>;
};


export type MutationDeleteManyAssessmentOriginsArgs = {
  input: DeleteManyAssessmentOriginsInput;
};


export type MutationDeleteManyAssessmentsArgs = {
  input: DeleteManyAssessmentsInput;
};


export type MutationDeleteManyAssetGroupsArgs = {
  input: DeleteManyAssetGroupsInput;
};


export type MutationDeleteManyCrremPathwaysArgs = {
  input: DeleteManyCrremPathwaysInput;
};


export type MutationDeleteManyEnergyConversionFactorsArgs = {
  input: DeleteManyEnergyConversionFactorsInput;
};


export type MutationDeleteManyLegacyBenchmarksArgs = {
  input: DeleteManyLegacyBenchmarksInput;
};


export type MutationDeleteManyLocationIntegrationsArgs = {
  input: DeleteManyLocationIntegrationsInput;
};


export type MutationDeleteManyLocationMetadataArgs = {
  input: DeleteManyLocationMetadataInput;
};


export type MutationDeleteManyOrganizationsArgs = {
  input: DeleteManyOrganizationsInput;
};


export type MutationDeleteManyPriorityBasedEmissionFactorsArgs = {
  input: DeleteManyPriorityBasedEmissionFactorsInput;
};


export type MutationDeleteManySupplierLocationsArgs = {
  input: DeleteManySupplierLocationsInput;
};


export type MutationDeleteManySuppliersArgs = {
  input: DeleteManySuppliersInput;
};


export type MutationDeleteManyTargetSettingsArgs = {
  input: DeleteManyTargetSettingsInput;
};


export type MutationDeleteManyUsersArgs = {
  input: DeleteManyUsersInput;
};


export type MutationDeleteOneAssessmentArgs = {
  input: DeleteOneAssessmentInput;
};


export type MutationDeleteOneAssessmentOriginArgs = {
  input: DeleteOneAssessmentOriginInput;
};


export type MutationDeleteOneAssetGroupArgs = {
  input: DeleteOneAssetGroupInput;
};


export type MutationDeleteOneCrremPathwayArgs = {
  input: DeleteOneCrremPathwayInput;
};


export type MutationDeleteOneEnergyConversionFactorArgs = {
  input: DeleteOneEnergyConversionFactorInput;
};


export type MutationDeleteOneLegacyBenchmarkArgs = {
  input: DeleteOneLegacyBenchmarkInput;
};


export type MutationDeleteOneLocationIntegrationArgs = {
  input: DeleteOneLocationIntegrationInput;
};


export type MutationDeleteOneLocationMetadataArgs = {
  input: DeleteOneLocationMetadataInput;
};


export type MutationDeleteOneOrganizationArgs = {
  input: DeleteOneOrganizationInput;
};


export type MutationDeleteOnePriorityBasedEmissionFactorArgs = {
  input: DeleteOnePriorityBasedEmissionFactorInput;
};


export type MutationDeleteOnePropertyArgs = {
  input: DeleteOnePropertyInput;
};


export type MutationDeleteOneReportArgs = {
  input: DeleteOneReportInput;
};


export type MutationDeleteOneSupplierArgs = {
  input: DeleteOneSupplierInput;
};


export type MutationDeleteOneSupplierLocationArgs = {
  input: DeleteOneSupplierLocationInput;
};


export type MutationDeleteOneTargetSettingArgs = {
  input: DeleteOneTargetSettingInput;
};


export type MutationDeleteOneUserArgs = {
  input: DeleteOneUserInput;
};


export type MutationDeleteReportArgs = {
  input: DeleteReportInput;
};


export type MutationSetAssessmentsOnAssessmentOriginArgs = {
  input: SetAssessmentsOnAssessmentOriginInput;
};


export type MutationSetFileOnAssessmentOriginArgs = {
  input: SetFileOnAssessmentOriginInput;
};


export type MutationUpdateAssetIntegrationAllocationsArgs = {
  input: UpdateAssetIntegrationAllocation;
};


export type MutationUpdateManualConsumptionArgs = {
  input: UpdateManualConsumptionInput;
};


export type MutationUpdateManyAssessmentOriginsArgs = {
  input: UpdateManyAssessmentOriginsInput;
};


export type MutationUpdateManyAssessmentsArgs = {
  input: UpdateManyAssessmentsInput;
};


export type MutationUpdateManyAssetGroupsArgs = {
  input: UpdateManyAssetGroupsInput;
};


export type MutationUpdateManyCrremPathwaysArgs = {
  input: UpdateManyCrremPathwaysInput;
};


export type MutationUpdateManyEnergyConversionFactorsArgs = {
  input: UpdateManyEnergyConversionFactorsInput;
};


export type MutationUpdateManyLegacyBenchmarksArgs = {
  input: UpdateManyLegacyBenchmarksInput;
};


export type MutationUpdateManyLocationIntegrationsArgs = {
  input: UpdateManyLocationIntegrationsInput;
};


export type MutationUpdateManyLocationMetadataArgs = {
  input: UpdateManyLocationMetadataInput;
};


export type MutationUpdateManyLocationsArgs = {
  input: UpdateManyLocationsInput;
};


export type MutationUpdateManyOrganizationsArgs = {
  input: UpdateManyOrganizationsInput;
};


export type MutationUpdateManyPriorityBasedEmissionFactorsArgs = {
  input: UpdateManyPriorityBasedEmissionFactorsInput;
};


export type MutationUpdateManyPropertiesArgs = {
  input: UpdateManyPropertiesInput;
};


export type MutationUpdateManyReportsArgs = {
  input: UpdateManyReportsInput;
};


export type MutationUpdateManySupplierLocationsArgs = {
  input: UpdateManySupplierLocationsInput;
};


export type MutationUpdateManySuppliersArgs = {
  input: UpdateManySuppliersInput;
};


export type MutationUpdateManyTargetSettingsArgs = {
  input: UpdateManyTargetSettingsInput;
};


export type MutationUpdateManyUsersArgs = {
  input: UpdateManyUsersInput;
};


export type MutationUpdateMeArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateOneAssessmentArgs = {
  input: UpdateOneAssessmentInput;
};


export type MutationUpdateOneAssessmentOriginArgs = {
  input: UpdateOneAssessmentOriginInput;
};


export type MutationUpdateOneAssetGroupArgs = {
  input: UpdateOneAssetGroupInput;
};


export type MutationUpdateOneCrremPathwayArgs = {
  input: UpdateOneCrremPathwayInput;
};


export type MutationUpdateOneEnergyConversionFactorArgs = {
  input: UpdateOneEnergyConversionFactorInput;
};


export type MutationUpdateOneLegacyBenchmarkArgs = {
  input: UpdateOneLegacyBenchmarkInput;
};


export type MutationUpdateOneLocationArgs = {
  input: UpdateOneLocationInput;
};


export type MutationUpdateOneLocationIntegrationArgs = {
  input: UpdateOneLocationIntegrationInput;
};


export type MutationUpdateOneLocationMetadataArgs = {
  input: UpdateOneLocationMetadataInput;
};


export type MutationUpdateOneOrganizationArgs = {
  input: UpdateOneOrganizationInput;
};


export type MutationUpdateOneOrganizationIntegrationArgs = {
  input: UpdateOneOrganizationIntegrationInput;
};


export type MutationUpdateOnePriorityBasedEmissionFactorArgs = {
  input: UpdateOnePriorityBasedEmissionFactorInput;
};


export type MutationUpdateOnePropertyArgs = {
  input: UpdateOnePropertyInput;
};


export type MutationUpdateOneReportArgs = {
  input: UpdateOneReportInput;
};


export type MutationUpdateOneSupplierArgs = {
  input: UpdateOneSupplierInput;
};


export type MutationUpdateOneSupplierLocationArgs = {
  input: UpdateOneSupplierLocationInput;
};


export type MutationUpdateOneTargetSettingArgs = {
  input: UpdateOneTargetSettingInput;
};


export type MutationUpdateOneUserArgs = {
  input: UpdateOneUserInput;
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpsertManyLocationMetadataArgs = {
  input: Array<CreateLocationMetadataInput>;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type OffsetAssetConnection = {
  __typename?: 'OffsetAssetConnection';
  /** Array of nodes. */
  nodes: Array<Location>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
};

export type OffsetPaging = {
  /** Limit the number of records returned */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Offset to start returning records from */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OisMapping = {
  __typename?: 'OisMapping';
  bbrType: BbrMappingType;
  bbrTypeId: Scalars['String']['output'];
};

export type OisMappingInput = {
  bbrType: BbrMappingType;
  bbrTypeId: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  allLocationsCount: Scalars['Float']['output'];
  baselineYear?: Maybe<Scalars['Float']['output']>;
  benchmarks: Array<Benchmark>;
  buildingAreas?: Maybe<Array<MetadataBuildingArea>>;
  buildingCities?: Maybe<Array<LocationCityFilter>>;
  children: Array<Organization>;
  countryBenchmarks: Array<CountryBenchmark>;
  createdBy: User;
  dataQuality: Array<DataQuality>;
  emissionSummaries: Array<EmissionSummary>;
  files: OrganizationFilesConnection;
  /** @deprecated Use `getAssets` query instead */
  getLocations?: Maybe<Array<Location>>;
  id: Scalars['ID']['output'];
  integrations: Array<OrganizationIntegration>;
  legalOwners?: Maybe<Array<Scalars['String']['output']>>;
  locations: OrganizationLocationsConnection;
  name: Scalars['String']['output'];
  nationalPropertyTypes?: Maybe<Array<LabelValueOption>>;
  parents: Array<Organization>;
  reportingYear?: Maybe<Scalars['Float']['output']>;
  supplier: OrganizationSupplierConnection;
  targetSetting?: Maybe<TargetSetting>;
  updatedBy: User;
};


export type OrganizationBenchmarksArgs = {
  filter?: BenchmarkFilter;
  sorting?: Array<BenchmarkSort>;
};


export type OrganizationChildrenArgs = {
  filter?: OrganizationFilter;
  sorting?: Array<OrganizationSort>;
};


export type OrganizationCountryBenchmarksArgs = {
  filter?: CountryBenchmarkFilter;
  sorting?: Array<CountryBenchmarkSort>;
};


export type OrganizationDataQualityArgs = {
  aggregation?: InputMaybe<AssessmentAggregation>;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  categories?: InputMaybe<Array<AssessmentCategory>>;
  excludeCategories?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentQueryFilter>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreProxy?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<Array<AssessmentVertical>>;
};


export type OrganizationEmissionSummariesArgs = {
  aggregation: AssessmentAggregation;
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type OrganizationFilesArgs = {
  filter?: FileFilter;
  paging?: CursorPaging;
  sorting?: Array<FileSort>;
};


export type OrganizationGetLocationsArgs = {
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationIntegrationsArgs = {
  filter?: OrganizationIntegrationFilter;
  sorting?: Array<OrganizationIntegrationSort>;
};


export type OrganizationLocationsArgs = {
  filter?: LocationFilter;
  paging?: CursorPaging;
  sorting?: Array<LocationSort>;
};


export type OrganizationParentsArgs = {
  filter?: OrganizationFilter;
  sorting?: Array<OrganizationSort>;
};


export type OrganizationSupplierArgs = {
  filter?: SupplierFilter;
  paging?: CursorPaging;
  sorting?: Array<SupplierSort>;
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** Array of edges. */
  edges: Array<OrganizationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type OrganizationDeleteFilter = {
  and?: InputMaybe<Array<OrganizationDeleteFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationDeleteFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
};

export type OrganizationDeleteResponse = {
  __typename?: 'OrganizationDeleteResponse';
  baselineYear?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reportingYear?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Organization */
  node: Organization;
};

export type OrganizationFilesConnection = {
  __typename?: 'OrganizationFilesConnection';
  /** Array of edges. */
  edges: Array<FileEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type OrganizationFilter = {
  and?: InputMaybe<Array<OrganizationFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  createdBy?: InputMaybe<OrganizationFilterUserFilter>;
  files?: InputMaybe<OrganizationFilterFileFilter>;
  id?: InputMaybe<IdFilterComparison>;
  locations?: InputMaybe<OrganizationFilterLocationFilter>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
  supplier?: InputMaybe<OrganizationFiltersupplierFilter>;
  targetSetting?: InputMaybe<OrganizationFilterTargetSettingFilter>;
  updatedBy?: InputMaybe<OrganizationFilterUserFilter>;
};

export type OrganizationFilterFileFilter = {
  and?: InputMaybe<Array<OrganizationFilterFileFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  mime?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationFilterFileFilter>>;
};

export type OrganizationFilterLocationFilter = {
  and?: InputMaybe<Array<OrganizationFilterLocationFilter>>;
  assetGroupId?: InputMaybe<LocationAssetGroupIdFilterComparison>;
  benchmarkId?: InputMaybe<LocationBenchmarkIdFilterComparison>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  dataType?: InputMaybe<LocationDataTypeFilterComparison>;
  displayName?: InputMaybe<LocationDisplayNameFilterComparison>;
  emissionIntensitySort?: InputMaybe<LocationEmissionIntensitySortFilterComparison>;
  emissionSort?: InputMaybe<LocationEmissionSortFilterComparison>;
  energyIntensitySort?: InputMaybe<LocationEnergyIntensitySortFilterComparison>;
  energySort?: InputMaybe<LocationEnergySortFilterComparison>;
  externalId?: InputMaybe<StringFieldComparison>;
  from?: InputMaybe<LocationFromFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  legalOwner?: InputMaybe<StringFieldComparison>;
  management?: InputMaybe<LocationManagementTypeFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationFilterLocationFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  ownership?: InputMaybe<NumberFieldComparison>;
  ownershipType?: InputMaybe<StringFieldComparison>;
  performance?: InputMaybe<LocationPerformanceFilterComparison>;
  purchaseDate?: InputMaybe<DateFieldComparison>;
  saleDate?: InputMaybe<DateFieldComparison>;
};

export type OrganizationFilterTargetSettingFilter = {
  and?: InputMaybe<Array<OrganizationFilterTargetSettingFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrganizationFilterTargetSettingFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  reduction?: InputMaybe<NumberFieldComparison>;
  targetYear?: InputMaybe<NumberFieldComparison>;
  type?: InputMaybe<TargetTypeFilterComparison>;
};

export type OrganizationFilterUserFilter = {
  and?: InputMaybe<Array<OrganizationFilterUserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationFilterUserFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type OrganizationFiltersupplierFilter = {
  and?: InputMaybe<Array<OrganizationFiltersupplierFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationFiltersupplierFilter>>;
  website?: InputMaybe<StringFieldComparison>;
};

export type OrganizationIntegration = {
  __typename?: 'OrganizationIntegration';
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
  type: IntegrationType;
};

export type OrganizationIntegrationData = {
  data: Scalars['JSONObject']['input'];
  integrationType: SupportedIntegrationForOnboarding;
};

export type OrganizationIntegrationEdge = {
  __typename?: 'OrganizationIntegrationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the OrganizationIntegration */
  node: OrganizationIntegration;
};

export type OrganizationIntegrationFilter = {
  and?: InputMaybe<Array<OrganizationIntegrationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrganizationIntegrationFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<IntegrationTypeFilterComparison>;
};

export type OrganizationIntegrationSort = {
  direction: SortDirection;
  field: OrganizationIntegrationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrganizationIntegrationSortFields {
  ID = 'id',
  ORGANIZATIONID = 'organizationId',
  TYPE = 'type'
}

export type OrganizationLocationsConnection = {
  __typename?: 'OrganizationLocationsConnection';
  /** Array of edges. */
  edges: Array<LocationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type OrganizationSort = {
  direction: SortDirection;
  field: OrganizationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrganizationSortFields {
  BASELINEYEAR = 'baselineYear',
  ID = 'id',
  NAME = 'name',
  REPORTINGYEAR = 'reportingYear'
}

export type OrganizationSupplierConnection = {
  __typename?: 'OrganizationSupplierConnection';
  /** Array of edges. */
  edges: Array<SupplierEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type OrganizationUpdateFilter = {
  and?: InputMaybe<Array<OrganizationUpdateFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OrganizationUpdateFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
};

export type OriginIntegrationData = {
  __typename?: 'OriginIntegrationData';
  originId: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
};

export type Pathway = {
  __typename?: 'Pathway';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PathwayConnection = {
  __typename?: 'PathwayConnection';
  /** Array of edges. */
  edges: Array<PathwayEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type PathwayEdge = {
  __typename?: 'PathwayEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Pathway */
  node: Pathway;
};

export type PathwayFilter = {
  and?: InputMaybe<Array<PathwayFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PathwayFilter>>;
};

export type PathwaySort = {
  direction: SortDirection;
  field: PathwaySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PathwaySortFields {
  ID = 'id',
  NAME = 'name'
}

export type PriorityBasedEmissionFactor = {
  __typename?: 'PriorityBasedEmissionFactor';
  calculationMethod?: Maybe<CalculationMethod>;
  consumptionType: ConsumptionType;
  consumptionUnit: EmissionUnit;
  countryCode?: Maybe<CountryCode>;
  createdAt: Scalars['DateTime']['output'];
  dateOfPublication?: Maybe<Scalars['DateTime']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  factor: Scalars['Float']['output'];
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isProjected?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  publicationName?: Maybe<Scalars['String']['output']>;
  publishingCompany?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  source?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PriorityBasedEmissionFactorConnection = {
  __typename?: 'PriorityBasedEmissionFactorConnection';
  /** Array of nodes. */
  nodes: Array<PriorityBasedEmissionFactor>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type PriorityBasedEmissionFactorDeleteFilter = {
  and?: InputMaybe<Array<PriorityBasedEmissionFactorDeleteFilter>>;
  calculationMethod?: InputMaybe<CalculationMethodFilterComparison>;
  consumptionType?: InputMaybe<ConsumptionTypeFilterComparison>;
  consumptionUnit?: InputMaybe<EmissionUnitFilterComparison>;
  countryCode?: InputMaybe<CountryCodeFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  dateOfPublication?: InputMaybe<DateFieldComparison>;
  externalSource?: InputMaybe<StringFieldComparison>;
  factor?: InputMaybe<NumberFieldComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isProjected?: InputMaybe<BooleanFieldComparison>;
  isVerified?: InputMaybe<BooleanFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PriorityBasedEmissionFactorDeleteFilter>>;
  publicationName?: InputMaybe<StringFieldComparison>;
  publishingCompany?: InputMaybe<StringFieldComparison>;
  region?: InputMaybe<RegionFilterComparison>;
  source?: InputMaybe<StringFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type PriorityBasedEmissionFactorDeleteResponse = {
  __typename?: 'PriorityBasedEmissionFactorDeleteResponse';
  calculationMethod?: Maybe<CalculationMethod>;
  consumptionType?: Maybe<ConsumptionType>;
  consumptionUnit?: Maybe<EmissionUnit>;
  countryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfPublication?: Maybe<Scalars['DateTime']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  factor?: Maybe<Scalars['Float']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isProjected?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  publicationName?: Maybe<Scalars['String']['output']>;
  publishingCompany?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  source?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PriorityBasedEmissionFactorFilter = {
  and?: InputMaybe<Array<PriorityBasedEmissionFactorFilter>>;
  calculationMethod?: InputMaybe<CalculationMethodFilterComparison>;
  consumptionType?: InputMaybe<ConsumptionTypeFilterComparison>;
  consumptionUnit?: InputMaybe<EmissionUnitFilterComparison>;
  countryCode?: InputMaybe<CountryCodeFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  dateOfPublication?: InputMaybe<DateFieldComparison>;
  externalSource?: InputMaybe<StringFieldComparison>;
  factor?: InputMaybe<NumberFieldComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isProjected?: InputMaybe<BooleanFieldComparison>;
  isVerified?: InputMaybe<BooleanFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PriorityBasedEmissionFactorFilter>>;
  publicationName?: InputMaybe<StringFieldComparison>;
  publishingCompany?: InputMaybe<StringFieldComparison>;
  region?: InputMaybe<RegionFilterComparison>;
  source?: InputMaybe<StringFieldComparison>;
  supplier?: InputMaybe<PriorityBasedEmissionFactorFiltersupplierFilter>;
  to?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type PriorityBasedEmissionFactorFiltersupplierFilter = {
  and?: InputMaybe<Array<PriorityBasedEmissionFactorFiltersupplierFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PriorityBasedEmissionFactorFiltersupplierFilter>>;
  website?: InputMaybe<StringFieldComparison>;
};

export type PriorityBasedEmissionFactorSort = {
  direction: SortDirection;
  field: PriorityBasedEmissionFactorSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PriorityBasedEmissionFactorSortFields {
  CALCULATIONMETHOD = 'calculationMethod',
  CONSUMPTIONTYPE = 'consumptionType',
  CONSUMPTIONUNIT = 'consumptionUnit',
  COUNTRYCODE = 'countryCode',
  CREATEDAT = 'createdAt',
  DATEOFPUBLICATION = 'dateOfPublication',
  EXTERNALSOURCE = 'externalSource',
  FACTOR = 'factor',
  FROM = 'from',
  ID = 'id',
  ISPROJECTED = 'isProjected',
  ISVERIFIED = 'isVerified',
  NOTE = 'note',
  PUBLICATIONNAME = 'publicationName',
  PUBLISHINGCOMPANY = 'publishingCompany',
  REGION = 'region',
  SOURCE = 'source',
  TO = 'to',
  UPDATEDAT = 'updatedAt'
}

export type PriorityBasedEmissionFactorUpdateFilter = {
  and?: InputMaybe<Array<PriorityBasedEmissionFactorUpdateFilter>>;
  calculationMethod?: InputMaybe<CalculationMethodFilterComparison>;
  consumptionType?: InputMaybe<ConsumptionTypeFilterComparison>;
  consumptionUnit?: InputMaybe<EmissionUnitFilterComparison>;
  countryCode?: InputMaybe<CountryCodeFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  dateOfPublication?: InputMaybe<DateFieldComparison>;
  externalSource?: InputMaybe<StringFieldComparison>;
  factor?: InputMaybe<NumberFieldComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isProjected?: InputMaybe<BooleanFieldComparison>;
  isVerified?: InputMaybe<BooleanFieldComparison>;
  note?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PriorityBasedEmissionFactorUpdateFilter>>;
  publicationName?: InputMaybe<StringFieldComparison>;
  publishingCompany?: InputMaybe<StringFieldComparison>;
  region?: InputMaybe<RegionFilterComparison>;
  source?: InputMaybe<StringFieldComparison>;
  to?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ProjectedAssessmentSummary = {
  __typename?: 'ProjectedAssessmentSummary';
  emissionData: EmissionData;
  emissionDataGrams: EmissionData;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  to: Scalars['DateTime']['output'];
  vertical: AssessmentVertical;
};

export type ProjectedAssessmentSummaryFilter = {
  and?: InputMaybe<Array<ProjectedAssessmentSummaryFilter>>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ProjectedAssessmentSummaryFilter>>;
  to?: InputMaybe<DateFieldComparison>;
};

export type ProjectedAssessmentSummarySort = {
  direction: SortDirection;
  field: ProjectedAssessmentSummarySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ProjectedAssessmentSummarySortFields {
  FROM = 'from',
  ID = 'id',
  TO = 'to'
}

export type ProjectedEmissionSummary = {
  __typename?: 'ProjectedEmissionSummary';
  aggregation: AssessmentAggregation;
  assetId: Scalars['String']['output'];
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ownedArea?: Maybe<Scalars['Float']['output']>;
  ownedEmission?: Maybe<Scalars['Float']['output']>;
  ownedEnergy?: Maybe<Scalars['Float']['output']>;
  sourceTypes?: Maybe<Array<Scalars['String']['output']>>;
  sources?: Maybe<Array<ProjectedSummarySource>>;
  to: Scalars['DateTime']['output'];
  vertical: AssessmentVertical;
};

export type ProjectedEmissionSummaryView = {
  __typename?: 'ProjectedEmissionSummaryView';
  aggregation: AssessmentAggregation;
  assetCount: Scalars['Float']['output'];
  avgEmissionIntensity?: Maybe<Scalars['Float']['output']>;
  avgEmissionIntensityBreakdown: Scalars['JSONObject']['output'];
  avgEnergyIntensity?: Maybe<Scalars['Float']['output']>;
  avgEnergyIntensityBreakdown: Scalars['JSONObject']['output'];
  dataType: AssessmentDataType;
  emissionBreakdown: Scalars['JSONObject']['output'];
  emissionForAreaBreakdown: Scalars['JSONObject']['output'];
  emissionIntensity?: Maybe<Scalars['Float']['output']>;
  energyBreakdown: Scalars['JSONObject']['output'];
  energyForAreaBreakdown: Scalars['JSONObject']['output'];
  energyIntensity?: Maybe<Scalars['Float']['output']>;
  from: Scalars['DateTime']['output'];
  ownedArea?: Maybe<Scalars['Float']['output']>;
  ownedEmission?: Maybe<Scalars['Float']['output']>;
  ownedEmissionForArea?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use ownedEmissionForArea instead */
  ownedEmissionWithArea?: Maybe<Scalars['Float']['output']>;
  ownedEnergy?: Maybe<Scalars['Float']['output']>;
  ownedEnergyForArea?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use ownedEnergyForArea instead */
  ownedEnergyWithArea?: Maybe<Scalars['Float']['output']>;
  to: Scalars['DateTime']['output'];
  verticals: Array<AssessmentVertical>;
};

export type ProjectedSummarySource = {
  __typename?: 'ProjectedSummarySource';
  areaData: AssessmentArea;
  category: AssessmentCategory;
  consumptionData: AssessmentConsumption;
  dataType: AssessmentDataType;
  emissionData?: Maybe<AssessmentEmission>;
  emissionFactorData?: Maybe<EmissionFactorData>;
  energyConversionFactorData?: Maybe<ConversionFactorData>;
  energyData?: Maybe<AssessmentEnergy>;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  integrationType?: Maybe<IntegrationType>;
  isProxy: Scalars['Boolean']['output'];
  originalFrom: Scalars['DateTime']['output'];
  originalTo: Scalars['DateTime']['output'];
  ownershipType?: Maybe<PropertyOwnershipType>;
  sourceMetadata: SourceMetadata;
  to: Scalars['DateTime']['output'];
  unit?: Maybe<EmissionUnit>;
};

export type Property = {
  __typename?: 'Property';
  address?: Maybe<Scalars['JSON']['output']>;
  allocations: Array<AssetIntegrationAllocation>;
  buildingArea?: Maybe<Scalars['Float']['output']>;
  children?: Maybe<Array<Property>>;
  constructionDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  crremPropertyCategory?: Maybe<CrremCategory>;
  generalPropertyType?: Maybe<PropertyType>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  longAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationalPropertyType?: Maybe<Scalars['String']['output']>;
  nationalPropertyTypeValue?: Maybe<Scalars['String']['output']>;
  objectType: PropertyObjectType;
  ownershipType: PropertyOwnershipType;
  parent?: Maybe<Property>;
  propertyType?: Maybe<PropertyType>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  saleDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PropertyDeleteResponse = {
  __typename?: 'PropertyDeleteResponse';
  address?: Maybe<Scalars['JSON']['output']>;
  buildingArea?: Maybe<Scalars['Float']['output']>;
  children?: Maybe<Array<Property>>;
  constructionDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationalPropertyType?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<PropertyObjectType>;
  ownershipType?: Maybe<PropertyOwnershipType>;
  propertyType?: Maybe<PropertyType>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  saleDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PropertyDto = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  children?: InputMaybe<Array<PropertyDto>>;
  constructionDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalPropertyType?: InputMaybe<Scalars['String']['input']>;
  objectType: PropertyObjectType;
  ownershipType: PropertyOwnershipType;
  propertyType?: InputMaybe<PropertyType>;
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  saleDate?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt: Scalars['DateTime']['input'];
};

export type PropertyEdge = {
  __typename?: 'PropertyEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Property */
  node: Property;
};

export enum PropertyObjectType {
  BUILDING = 'BUILDING',
  PLOT = 'PLOT',
  TECHNICAL_FACILITY = 'TECHNICAL_FACILITY',
  UNIT = 'UNIT'
}

export enum PropertyOwnershipType {
  LANDLORD = 'LANDLORD',
  MIXED = 'MIXED',
  OTHER = 'OTHER',
  TENANT = 'TENANT'
}

export type PropertyOwnershipTypeFilterComparison = {
  eq?: InputMaybe<PropertyOwnershipType>;
  gt?: InputMaybe<PropertyOwnershipType>;
  gte?: InputMaybe<PropertyOwnershipType>;
  iLike?: InputMaybe<PropertyOwnershipType>;
  in?: InputMaybe<Array<PropertyOwnershipType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<PropertyOwnershipType>;
  lt?: InputMaybe<PropertyOwnershipType>;
  lte?: InputMaybe<PropertyOwnershipType>;
  neq?: InputMaybe<PropertyOwnershipType>;
  notILike?: InputMaybe<PropertyOwnershipType>;
  notIn?: InputMaybe<Array<PropertyOwnershipType>>;
  notLike?: InputMaybe<PropertyOwnershipType>;
};

export enum PropertyType {
  AGRICULTURAL = 'AGRICULTURAL',
  COMMERCIAL_RETAIL = 'COMMERCIAL_RETAIL',
  CULTURAL_PUBLIC_SPACES = 'CULTURAL_PUBLIC_SPACES',
  EDUCATIONAL = 'EDUCATIONAL',
  GOVERNMENT_CIVIC = 'GOVERNMENT_CIVIC',
  HEALTHCARE = 'HEALTHCARE',
  HOSPITALITY_LODGING = 'HOSPITALITY_LODGING',
  INDUSTRIAL = 'INDUSTRIAL',
  LEISURE_RECREATION = 'LEISURE_RECREATION',
  MIXED_USE = 'MIXED_USE',
  OFFICE_ADMINISTRATION = 'OFFICE_ADMINISTRATION',
  OTHER = 'OTHER',
  RESIDENTIAL = 'RESIDENTIAL',
  SPECIAL_USE = 'SPECIAL_USE',
  TECHNOLOGY_SCIENCE = 'TECHNOLOGY_SCIENCE',
  TRANSPORT_INFRASTRUCTURE = 'TRANSPORT_INFRASTRUCTURE'
}

export type PropertyUpdateFilter = {
  and?: InputMaybe<Array<PropertyUpdateFilter>>;
  constructionDate?: InputMaybe<DateFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<PropertyUpdateFilter>>;
  purchaseDate?: InputMaybe<DateFieldComparison>;
  saleDate?: InputMaybe<DateFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type Query = {
  __typename?: 'Query';
  AllocationObjectType: Array<AllocationObjectType>;
  CrremPropertyTypes: Array<CrremCategory>;
  DKBuildingUse: Array<DkBuildingUse>;
  UKPropertyType: Array<UkPropertyType>;
  assessment: Assessment;
  assessmentOrigin: AssessmentOrigin;
  assessmentOrigins: AssessmentOriginConnection;
  assessments: AssessmentConnection;
  assetGroup: AssetGroup;
  assetGroups: AssetGroupConnection;
  assets_offset: OffsetAssetConnection;
  benchmark: Benchmark;
  benchmarks: BenchmarkConnection;
  cRREMPathway: CrremPathway;
  cRREMPathways: CrremPathwayConnection;
  changeLog: ChangeLog;
  changeLogs: ChangeLogConnection;
  changeLogsFieldsCount: Scalars['Float']['output'];
  energyConversionFactor: EnergyConversionFactor;
  energyConversionFactors: EnergyConversionFactorConnection;
  entolabsOrganizations: Array<EntolabsOrganization>;
  getActiveReports: Array<Report>;
  getAssetBenchmarkPerformance: Array<InsightAssetBenchmarkPerformance>;
  getAssetGroupPreview: Array<Location>;
  getAssetPropertyTree: Array<Property>;
  getAssetRiskChartData: Array<AssetRiskChartData>;
  getAssets: Array<Location>;
  getChangeLogs: Array<ChangeLog>;
  getConsumptionChartData: Array<YearlyConsumptionChartData>;
  getCrremPathways: Array<CrremPathway>;
  getEloverblikCustomers: Array<EloverblikCustomer>;
  getEpcSummaries: Array<EpcSummary>;
  getIntensity?: Maybe<InsightIntensity>;
  getIntensityChartData: Array<InsightIntensityChartData>;
  getLegacyBenchmarks: Array<LegacyBenchmark>;
  getLegacyBenchmarksByAssetId: Array<LegacyBenchmark>;
  getLegacyNextAsset?: Maybe<InsightsAsset>;
  getLegacyNextAssetBenchmarks?: Maybe<Array<InsightsAssetBenchmark>>;
  getLegacyNextAssetHeatInstallation?: Maybe<InsightsAssetHeatInstallation>;
  getLegacyNextAssetMaterialsLifespan?: Maybe<InsightsAssetMaterialLifespan>;
  getLegacyNextAssetOwnership?: Maybe<InsightsAssetOwnership>;
  getLegacyNextAssetSalesPrice?: Maybe<InsightsAssetSalesPrice>;
  getLegacyNextAssetWaterSupplier?: Maybe<InsightsAssetWaterSupplier>;
  getLegacyNextAssets: Array<InsightsProperty>;
  getOrganizationIntegration?: Maybe<SimpleOrganizationIntegrationDto>;
  getReportEmissionFactor: Array<ReportEmissionFactorItem>;
  getReportEmissionFactorHeaders: Array<ReportEmissionFactorHeader>;
  getReportEnergyConversionFactor: Array<ReportEnergyConversionFactorItem>;
  getReportEnergyConversionFactorHeaders: Array<ReportEnergyConversionFactorHeader>;
  getReportInventory: Array<ReportInventoryItem>;
  getReportInventoryHeaders: Array<ReportInventoryHeader>;
  getReportSummary: Array<ReportSummaryItem>;
  getReportSummaryHeader: Array<ReportSummaryHeader>;
  integrationTypesForOnboarding: Array<SupportedIntegrationForOnboarding>;
  legacyBenchmark: LegacyBenchmark;
  legacyBenchmarks: LegacyBenchmarkConnection;
  location: Location;
  locationIntegration: LocationIntegration;
  locationIntegrations: LocationIntegrationConnection;
  locationMetadata: LocationMetadataConnection;
  locations: LocationConnection;
  locationsForDexmaIntegration: LocationsForDexmaIntegrationResponse;
  locationsForElectralinkIntegration: LocationsForElectralinkIntegrationResponse;
  locationsForEloverblik: LocationsForEloverblik;
  locationsForEntolabsIntegration: LocationsForEntolabsIntegrationResponse;
  locationsForHoforIntegration: LocationsForHoforIntegrationResponse;
  locationsForSoftvaerket: LocationsForSoftvaerket;
  locationsForTechemIntegration: LocationsForTechemIntegrationResponse;
  locationsForVitaniIntegration: LocationsForVitaniIntegrationResponse;
  me: User;
  orgEmissionSummaries: Array<EmissionSummaryView>;
  orgProjectedEmissionSummaries: Array<ProjectedEmissionSummaryView>;
  organization: Organization;
  organizations: OrganizationConnection;
  pathway: Pathway;
  pathways: PathwayConnection;
  priorityBasedEmissionFactor: PriorityBasedEmissionFactor;
  priorityBasedEmissionFactors: PriorityBasedEmissionFactorConnection;
  property: Property;
  report: Report;
  reports: ReportConnection;
  simpleAssetInventoryHeaders: Array<AssetSimpleInventoryHeader>;
  supplier: Supplier;
  supplierLocation: SupplierLocation;
  supplierLocations: SupplierLocationConnection;
  suppliers: SupplierConnection;
  targetSetting: TargetSetting;
  targetSettings: TargetSettingConnection;
  user: User;
  users: UserConnection;
};


export type QueryAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssessmentOriginArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssessmentOriginsArgs = {
  filter?: AssessmentOriginFilter;
  paging?: CursorPaging;
  sorting?: Array<AssessmentOriginSort>;
};


export type QueryAssessmentsArgs = {
  filter?: AssessmentFilter;
  paging?: CursorPaging;
  sorting?: Array<AssessmentSort>;
};


export type QueryAssetGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssetGroupsArgs = {
  filter?: AssetGroupFilter;
  paging?: CursorPaging;
  sorting?: Array<AssetGroupSort>;
};


export type QueryAssets_OffsetArgs = {
  paging?: OffsetPaging;
  sorting?: Array<LocationSort>;
};


export type QueryBenchmarkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBenchmarksArgs = {
  filter?: BenchmarkFilter;
  paging?: CursorPaging;
  sorting?: Array<BenchmarkSort>;
};


export type QueryCRremPathwayArgs = {
  id: Scalars['String']['input'];
};


export type QueryCRremPathwaysArgs = {
  filter?: CrremPathwayFilter;
  paging?: CursorPaging;
  sorting?: Array<CrremPathwaySort>;
};


export type QueryChangeLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChangeLogsArgs = {
  filter?: ChangeLogFilter;
  paging?: CursorPaging;
  sorting?: Array<ChangeLogSort>;
};


export type QueryChangeLogsFieldsCountArgs = {
  eventType: ChangeLogEventType;
  recordId: Scalars['ID']['input'];
};


export type QueryEnergyConversionFactorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnergyConversionFactorsArgs = {
  filter?: EnergyConversionFactorFilter;
  paging?: OffsetPaging;
  sorting?: Array<EnergyConversionFactorSort>;
};


export type QueryGetAssetBenchmarkPerformanceArgs = {
  assetId: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryGetAssetGroupPreviewArgs = {
  assetGroupFilters: Array<AssetGroupFilterInput>;
};


export type QueryGetAssetPropertyTreeArgs = {
  assetId: Scalars['ID']['input'];
};


export type QueryGetAssetRiskChartDataArgs = {
  propertyIds: Array<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetAssetsArgs = {
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetChangeLogsArgs = {
  eventType?: InputMaybe<ChangeLogEventType>;
  recordId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetConsumptionChartDataArgs = {
  assetId: Scalars['ID']['input'];
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetCrremPathwaysArgs = {
  categories: Array<CrremCategory>;
  countries: Array<Scalars['String']['input']>;
  versions: Array<Scalars['String']['input']>;
};


export type QueryGetEpcSummariesArgs = {
  bfes: Array<Scalars['String']['input']>;
};


export type QueryGetIntensityArgs = {
  assetId: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryGetIntensityChartDataArgs = {
  assetId: Scalars['ID']['input'];
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetLegacyBenchmarksArgs = {
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLegacyBenchmarksByAssetIdArgs = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLegacyNextAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLegacyNextAssetBenchmarksArgs = {
  bfe: Scalars['String']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetLegacyNextAssetHeatInstallationArgs = {
  bfe: Scalars['String']['input'];
};


export type QueryGetLegacyNextAssetMaterialsLifespanArgs = {
  bfe: Scalars['String']['input'];
};


export type QueryGetLegacyNextAssetOwnershipArgs = {
  bfe: Scalars['String']['input'];
};


export type QueryGetLegacyNextAssetSalesPriceArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetLegacyNextAssetWaterSupplierArgs = {
  bfe: Scalars['String']['input'];
};


export type QueryGetLegacyNextAssetsArgs = {
  searchFilters: SearchFiltersInput;
};


export type QueryGetOrganizationIntegrationArgs = {
  integrationType: SupportedIntegrationForOnboarding;
};


export type QueryGetReportEmissionFactorArgs = {
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  input: ReportQuery;
};


export type QueryGetReportEmissionFactorHeadersArgs = {
  input: ReportQuery;
};


export type QueryGetReportEnergyConversionFactorArgs = {
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  input: ReportQuery;
};


export type QueryGetReportEnergyConversionFactorHeadersArgs = {
  input: ReportQuery;
};


export type QueryGetReportInventoryArgs = {
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  input: ReportQuery;
};


export type QueryGetReportSummaryArgs = {
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  input: ReportQuery;
};


export type QueryGetReportSummaryHeaderArgs = {
  input: ReportQuery;
};


export type QueryLegacyBenchmarkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLegacyBenchmarksArgs = {
  filter?: LegacyBenchmarkFilter;
  paging?: CursorPaging;
  sorting?: Array<LegacyBenchmarkSort>;
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationIntegrationsArgs = {
  filter?: LocationIntegrationFilter;
  paging?: CursorPaging;
  sorting?: Array<LocationIntegrationSort>;
};


export type QueryLocationMetadataArgs = {
  filter?: LocationMetadataFilter;
  paging?: CursorPaging;
  sorting?: Array<LocationMetadataSort>;
};


export type QueryLocationsArgs = {
  filter?: LocationFilter;
  paging?: CursorPaging;
  sorting?: Array<LocationSort>;
};


export type QueryOrgEmissionSummariesArgs = {
  aggregation: AssessmentAggregation;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  dataType: AssessmentDataType;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryOrgProjectedEmissionSummariesArgs = {
  aggregation: AssessmentAggregation;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  dataType: AssessmentDataType;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  filter?: OrganizationFilter;
  paging?: CursorPaging;
  sorting?: Array<OrganizationSort>;
};


export type QueryPathwayArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPathwaysArgs = {
  filter?: PathwayFilter;
  paging?: CursorPaging;
  sorting?: Array<PathwaySort>;
};


export type QueryPriorityBasedEmissionFactorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPriorityBasedEmissionFactorsArgs = {
  filter?: PriorityBasedEmissionFactorFilter;
  paging?: OffsetPaging;
  sorting?: Array<PriorityBasedEmissionFactorSort>;
};


export type QueryPropertyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportsArgs = {
  filter?: ReportFilter;
  paging?: CursorPaging;
  sorting?: Array<ReportSort>;
};


export type QuerySupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierLocationsArgs = {
  filter?: SupplierLocationFilter;
  paging?: CursorPaging;
  sorting?: Array<SupplierLocationSort>;
};


export type QuerySuppliersArgs = {
  filter?: SupplierFilter;
  paging?: CursorPaging;
  sorting?: Array<SupplierSort>;
};


export type QueryTargetSettingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTargetSettingsArgs = {
  filter?: TargetSettingFilter;
  paging?: CursorPaging;
  sorting?: Array<TargetSettingSort>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  filter?: UserFilter;
  paging?: CursorPaging;
  sorting?: Array<UserSort>;
};

export type ReferenceDeviceData = {
  __typename?: 'ReferenceDeviceData';
  device: DeviceData;
  type: Scalars['String']['output'];
};

export enum Region {
  DK_1 = 'DK_1',
  DK_2 = 'DK_2'
}

export type RegionFilterComparison = {
  eq?: InputMaybe<Region>;
  gt?: InputMaybe<Region>;
  gte?: InputMaybe<Region>;
  iLike?: InputMaybe<Region>;
  in?: InputMaybe<Array<Region>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Region>;
  lt?: InputMaybe<Region>;
  lte?: InputMaybe<Region>;
  neq?: InputMaybe<Region>;
  notILike?: InputMaybe<Region>;
  notIn?: InputMaybe<Array<Region>>;
  notLike?: InputMaybe<Region>;
};

export type RelationInput = {
  id: Scalars['ID']['input'];
};

export type Report = {
  __typename?: 'Report';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  framework: ReportFramework;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  numberOfAssets: Scalars['Float']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  segmentName?: Maybe<Scalars['String']['output']>;
  source: AssessmentDataType;
  to: Scalars['DateTime']['output'];
};

export type ReportCrremSummaryItem = {
  __typename?: 'ReportCRREMSummaryItem';
  address: Scalars['String']['output'];
  assetId: Scalars['String']['output'];
  assetName: Scalars['String']['output'];
  buildingArea: Scalars['String']['output'];
  buildingDistrictCoolingChilledWaterDataCoverageM2: Scalars['String']['output'];
  buildingDistrictCoolingChilledWaterUsageKWh: Scalars['String']['output'];
  buildingDistrictHeatingSteamDataCoverageM2: Scalars['String']['output'];
  buildingDistrictHeatingSteamUsageKWh: Scalars['String']['output'];
  buildingGridElectricityDataCoverageM2: Scalars['String']['output'];
  buildingGridElectricityUsageKWh: Scalars['String']['output'];
  buildingNaturalGasDataCoverageM2: Scalars['String']['output'];
  buildingNaturalGasUsageKWh: Scalars['String']['output'];
  buildingOtherEnergyConsumptionType1DataCoverageM2: Scalars['String']['output'];
  buildingOtherEnergyConsumptionType1Type: Scalars['String']['output'];
  buildingOtherEnergyConsumptionType1UsageKWh: Scalars['String']['output'];
  buildingPercentageOwnership: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  crremPropertyType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inclusion: Scalars['String']['output'];
  legalOwner: Scalars['String']['output'];
  monthsReportingPeriod: Scalars['String']['output'];
  onSiteRenewableElectricityGeneratedAndConsumedOnSite: Scalars['String']['output'];
  reportingYear: Scalars['String']['output'];
  startReportingPeriod: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type ReportConnection = {
  __typename?: 'ReportConnection';
  /** Array of edges. */
  edges: Array<ReportEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ReportDeleteResponse = {
  __typename?: 'ReportDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  framework?: Maybe<ReportFramework>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  numberOfAssets?: Maybe<Scalars['Float']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<AssessmentDataType>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportEsgSummaryItem = {
  __typename?: 'ReportESGSummaryItem';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReportEdge = {
  __typename?: 'ReportEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Report */
  node: Report;
};

export type ReportEmissionFactorHeader = {
  __typename?: 'ReportEmissionFactorHeader';
  columnStyle?: Maybe<ReportStyle>;
  header: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ReportEmissionFactorItem = {
  __typename?: 'ReportEmissionFactorItem';
  activity?: Maybe<Scalars['String']['output']>;
  calculationMethod?: Maybe<Scalars['String']['output']>;
  consumptionType?: Maybe<Scalars['String']['output']>;
  coveragePeriod?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use source instead */
  emissionDataSource?: Maybe<Scalars['String']['output']>;
  emissionFactor?: Maybe<Scalars['String']['output']>;
  emissionFactorSourceNote?: Maybe<Scalars['String']['output']>;
  emissionFactorUnit?: Maybe<Scalars['String']['output']>;
  externalSourceLink?: Maybe<Scalars['String']['output']>;
  ghgCategory: Scalars['String']['output'];
  id: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDownloadLink?: Maybe<Scalars['String']['output']>;
  totalEmissionShare?: Maybe<Scalars['String']['output']>;
};

export type ReportEmissionSummaryInventoryItem = {
  __typename?: 'ReportEmissionSummaryInventoryItem';
  activity: Scalars['String']['output'];
  addresses: Scalars['String']['output'];
  assetArea: Scalars['String']['output'];
  assetAreaUnit: Scalars['String']['output'];
  assetConsumption: Scalars['String']['output'];
  assetEmission: Scalars['String']['output'];
  assetEnergyConsumption: Scalars['String']['output'];
  assetPercentageOwnership: Scalars['String']['output'];
  consumptionDataSource: Scalars['String']['output'];
  consumptionType: Scalars['String']['output'];
  consumptionUnit: Scalars['String']['output'];
  emissionDataSource: Scalars['String']['output'];
  emissionFactor: Scalars['String']['output'];
  emissionFactorUnit: Scalars['String']['output'];
  emissionSourceNote: Scalars['String']['output'];
  emissionUnit: Scalars['String']['output'];
  energyConversionFactor: Scalars['String']['output'];
  energyConversionFactorUnit: Scalars['String']['output'];
  energyConversionSource: Scalars['String']['output'];
  energyConversionSourceNote: Scalars['String']['output'];
  from: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nationalBuildingIds: Scalars['String']['output'];
  ownedConsumption: Scalars['String']['output'];
  ownedEmission: Scalars['String']['output'];
  ownedEnergyConsumption: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type ReportEnergyConversionFactorHeader = {
  __typename?: 'ReportEnergyConversionFactorHeader';
  columnStyle?: Maybe<ReportStyle>;
  header: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ReportEnergyConversionFactorItem = {
  __typename?: 'ReportEnergyConversionFactorItem';
  activity?: Maybe<Scalars['String']['output']>;
  calculationMethod?: Maybe<Scalars['String']['output']>;
  consumptionType?: Maybe<Scalars['String']['output']>;
  coveragePeriod?: Maybe<Scalars['String']['output']>;
  energyConversionFactor?: Maybe<Scalars['String']['output']>;
  energyConversionFactorUnit?: Maybe<Scalars['String']['output']>;
  externalSourceLink?: Maybe<Scalars['String']['output']>;
  ghgCategory: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDownloadLink?: Maybe<Scalars['String']['output']>;
  totalEnergyShare?: Maybe<Scalars['String']['output']>;
};

export type ReportFilter = {
  and?: InputMaybe<Array<ReportFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  createdBy?: InputMaybe<ReportFilterUserFilter>;
  framework?: InputMaybe<ReportFrameworkFilterComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ReportFilter>>;
  organization?: InputMaybe<ReportFilterOrganizationFilter>;
  organizationId?: InputMaybe<StringFieldComparison>;
  source?: InputMaybe<AssessmentDataTypeFilterComparison>;
  to?: InputMaybe<DateFieldComparison>;
};

export type ReportFilterOrganizationFilter = {
  and?: InputMaybe<Array<ReportFilterOrganizationFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ReportFilterOrganizationFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
};

export type ReportFilterUserFilter = {
  and?: InputMaybe<Array<ReportFilterUserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ReportFilterUserFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export enum ReportFramework {
  CRREM = 'CRREM',
  ESG = 'ESG',
  GHG = 'GHG'
}

export type ReportFrameworkFilterComparison = {
  eq?: InputMaybe<ReportFramework>;
  gt?: InputMaybe<ReportFramework>;
  gte?: InputMaybe<ReportFramework>;
  iLike?: InputMaybe<ReportFramework>;
  in?: InputMaybe<Array<ReportFramework>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ReportFramework>;
  lt?: InputMaybe<ReportFramework>;
  lte?: InputMaybe<ReportFramework>;
  neq?: InputMaybe<ReportFramework>;
  notILike?: InputMaybe<ReportFramework>;
  notIn?: InputMaybe<Array<ReportFramework>>;
  notLike?: InputMaybe<ReportFramework>;
};

export type ReportGhgSummaryItem = {
  __typename?: 'ReportGHGSummaryItem';
  baselineYearUnit: Scalars['String']['output'];
  baselineYearValue: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReportInventoryHeader = {
  __typename?: 'ReportInventoryHeader';
  columnStyle?: Maybe<ReportStyle>;
  header: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ReportInventoryItem = {
  __typename?: 'ReportInventoryItem';
  activity?: Maybe<Scalars['String']['output']>;
  addresses?: Maybe<Scalars['String']['output']>;
  assetArea?: Maybe<Scalars['String']['output']>;
  assetAreaUnit?: Maybe<Scalars['String']['output']>;
  assetConsumption?: Maybe<Scalars['String']['output']>;
  assetConsumptionUnit?: Maybe<Scalars['String']['output']>;
  assetEmission?: Maybe<Scalars['String']['output']>;
  assetEmissionUnit?: Maybe<Scalars['String']['output']>;
  assetEnergyConsumption?: Maybe<Scalars['String']['output']>;
  assetEnergyConsumptionUnit?: Maybe<Scalars['String']['output']>;
  assetPercentageOwnership?: Maybe<Scalars['String']['output']>;
  buildingArea?: Maybe<Scalars['String']['output']>;
  buildingAreaUnit?: Maybe<Scalars['String']['output']>;
  buildingConsumption?: Maybe<Scalars['String']['output']>;
  buildingConsumptionUnit?: Maybe<Scalars['String']['output']>;
  buildingEmission?: Maybe<Scalars['String']['output']>;
  buildingEmissionUnit?: Maybe<Scalars['String']['output']>;
  buildingEnergyConsumption?: Maybe<Scalars['String']['output']>;
  buildingEnergyConsumptionUnit?: Maybe<Scalars['String']['output']>;
  buildingPercentageOwnership?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  consumption?: Maybe<Scalars['String']['output']>;
  consumptionDataSource?: Maybe<Scalars['String']['output']>;
  dataArea?: Maybe<Scalars['String']['output']>;
  dataAreaUnit?: Maybe<Scalars['String']['output']>;
  dataGap?: Maybe<Scalars['String']['output']>;
  dataPercentageOwnership?: Maybe<Scalars['String']['output']>;
  emissionDataSource?: Maybe<Scalars['String']['output']>;
  emissionFactor?: Maybe<Scalars['String']['output']>;
  emissionFactorUnit?: Maybe<Scalars['String']['output']>;
  emissionSourceNote?: Maybe<Scalars['String']['output']>;
  energyConversionFactor: Scalars['String']['output'];
  energyConversionFactorUnit: Scalars['String']['output'];
  energyConversionSource: Scalars['String']['output'];
  energyConversionSourceNote: Scalars['String']['output'];
  epcLink?: Maybe<Scalars['String']['output']>;
  epcProxy?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  ghgCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  legalOwner?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationOwnership?: Maybe<Scalars['String']['output']>;
  management: Scalars['String']['output'];
  nationalBuildingIds?: Maybe<Scalars['String']['output']>;
  ownedArea?: Maybe<Scalars['String']['output']>;
  ownedAreaUnit?: Maybe<Scalars['String']['output']>;
  ownedConsumption?: Maybe<Scalars['String']['output']>;
  ownedConsumptionUnit?: Maybe<Scalars['String']['output']>;
  ownedEmission?: Maybe<Scalars['String']['output']>;
  ownedEmissionUnit?: Maybe<Scalars['String']['output']>;
  ownedEnergyConsumption?: Maybe<Scalars['String']['output']>;
  ownedEnergyConsumptionUnit?: Maybe<Scalars['String']['output']>;
  partialOwnershipPercentDistribution?: Maybe<Scalars['String']['output']>;
  percentDistribution?: Maybe<Scalars['String']['output']>;
  propertyType?: Maybe<Scalars['String']['output']>;
  purchaseDate: Scalars['String']['output'];
  saleDate: Scalars['String']['output'];
  scope?: Maybe<Scalars['String']['output']>;
  to: Scalars['String']['output'];
  totalArea?: Maybe<Scalars['String']['output']>;
  totalAreaUnit?: Maybe<Scalars['String']['output']>;
  totalEmission?: Maybe<Scalars['String']['output']>;
  totalEmissionUnit?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type ReportInventoryItemInput = {
  activity?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Scalars['String']['input']>;
  assetArea?: InputMaybe<Scalars['String']['input']>;
  assetAreaUnit?: InputMaybe<Scalars['String']['input']>;
  assetConsumption?: InputMaybe<Scalars['String']['input']>;
  assetConsumptionUnit?: InputMaybe<Scalars['String']['input']>;
  assetEmission?: InputMaybe<Scalars['String']['input']>;
  assetEmissionUnit?: InputMaybe<Scalars['String']['input']>;
  assetEnergyConsumption?: InputMaybe<Scalars['String']['input']>;
  assetEnergyConsumptionUnit?: InputMaybe<Scalars['String']['input']>;
  assetPercentageOwnership?: InputMaybe<Scalars['String']['input']>;
  buildingArea?: InputMaybe<Scalars['String']['input']>;
  buildingAreaUnit?: InputMaybe<Scalars['String']['input']>;
  buildingConsumption?: InputMaybe<Scalars['String']['input']>;
  buildingConsumptionUnit?: InputMaybe<Scalars['String']['input']>;
  buildingEmission?: InputMaybe<Scalars['String']['input']>;
  buildingEmissionUnit?: InputMaybe<Scalars['String']['input']>;
  buildingEnergyConsumption?: InputMaybe<Scalars['String']['input']>;
  buildingEnergyConsumptionUnit?: InputMaybe<Scalars['String']['input']>;
  buildingPercentageOwnership?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  consumption?: InputMaybe<Scalars['String']['input']>;
  consumptionDataSource?: InputMaybe<Scalars['String']['input']>;
  dataArea?: InputMaybe<Scalars['String']['input']>;
  dataAreaUnit?: InputMaybe<Scalars['String']['input']>;
  dataGap?: InputMaybe<Scalars['String']['input']>;
  dataPercentageOwnership?: InputMaybe<Scalars['String']['input']>;
  emissionDataSource?: InputMaybe<Scalars['String']['input']>;
  emissionFactor?: InputMaybe<Scalars['String']['input']>;
  emissionFactorUnit?: InputMaybe<Scalars['String']['input']>;
  emissionSourceNote?: InputMaybe<Scalars['String']['input']>;
  energyConversionFactor: Scalars['String']['input'];
  energyConversionFactorUnit: Scalars['String']['input'];
  energyConversionSource: Scalars['String']['input'];
  energyConversionSourceNote: Scalars['String']['input'];
  epcLink?: InputMaybe<Scalars['String']['input']>;
  epcProxy?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  ghgCategory?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  identifier?: InputMaybe<Scalars['String']['input']>;
  legalOwner?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  locationName: Scalars['String']['input'];
  locationOwnership?: InputMaybe<Scalars['String']['input']>;
  management: Scalars['String']['input'];
  nationalBuildingIds?: InputMaybe<Scalars['String']['input']>;
  ownedArea?: InputMaybe<Scalars['String']['input']>;
  ownedAreaUnit?: InputMaybe<Scalars['String']['input']>;
  ownedConsumption?: InputMaybe<Scalars['String']['input']>;
  ownedConsumptionUnit?: InputMaybe<Scalars['String']['input']>;
  ownedEmission?: InputMaybe<Scalars['String']['input']>;
  ownedEmissionUnit?: InputMaybe<Scalars['String']['input']>;
  ownedEnergyConsumption?: InputMaybe<Scalars['String']['input']>;
  ownedEnergyConsumptionUnit?: InputMaybe<Scalars['String']['input']>;
  partialOwnershipPercentDistribution?: InputMaybe<Scalars['String']['input']>;
  percentDistribution?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  purchaseDate: Scalars['String']['input'];
  saleDate: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  totalArea?: InputMaybe<Scalars['String']['input']>;
  totalAreaUnit?: InputMaybe<Scalars['String']['input']>;
  totalEmission?: InputMaybe<Scalars['String']['input']>;
  totalEmissionUnit?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export enum ReportLanguage {
  DA = 'DA',
  EN = 'EN'
}

export type ReportQuery = {
  framework?: InputMaybe<ReportFramework>;
  from: Scalars['DateTime']['input'];
  language?: InputMaybe<ReportLanguage>;
  numberOfAssets?: InputMaybe<Scalars['Int']['input']>;
  segmentName?: InputMaybe<Scalars['String']['input']>;
  source: AssessmentDataType;
  to: Scalars['DateTime']['input'];
};

export type ReportSort = {
  direction: SortDirection;
  field: ReportSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ReportSortFields {
  CREATEDAT = 'createdAt',
  FRAMEWORK = 'framework',
  FROM = 'from',
  ID = 'id',
  ORGANIZATIONID = 'organizationId',
  SOURCE = 'source',
  TO = 'to'
}

export type ReportStyle = {
  __typename?: 'ReportStyle';
  fill?: Maybe<FillStyle>;
};

export type ReportSummaryHeader = {
  __typename?: 'ReportSummaryHeader';
  columnStyle?: Maybe<ReportStyle>;
  header: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ReportSummaryItem = ReportCrremSummaryItem | ReportEsgSummaryItem | ReportGhgSummaryItem;

export type ReportUpdateFilter = {
  and?: InputMaybe<Array<ReportUpdateFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  framework?: InputMaybe<ReportFrameworkFilterComparison>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ReportUpdateFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  source?: InputMaybe<AssessmentDataTypeFilterComparison>;
  to?: InputMaybe<DateFieldComparison>;
};

export type RetoolFile = {
  base64Data: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sizeBytes: Scalars['Float']['input'];
  type: Scalars['String']['input'];
};

export type SearchFiltersInput = {
  bfeList: Array<Scalars['String']['input']>;
  epcClassificationList: Array<Scalars['String']['input']>;
};

export type SetAssessmentsOnAssessmentOriginInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type SetFileOnAssessmentOriginInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SimpleOrganizationIntegrationDto = {
  __typename?: 'SimpleOrganizationIntegrationDto';
  id: Scalars['ID']['output'];
};

export type SoftvaerketMeter = {
  __typename?: 'SoftvaerketMeter';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
};

/** Sort Directions */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Sort Nulls Options */
export enum SortNulls {
  NULLS_FIRST = 'NULLS_FIRST',
  NULLS_LAST = 'NULLS_LAST'
}

export type SourceMetadata = {
  __typename?: 'SourceMetadata';
  addresses: Array<Scalars['String']['output']>;
  classifications: Array<Scalars['String']['output']>;
  documentation: Array<Scalars['String']['output']>;
  identifiers: Array<Scalars['String']['output']>;
  nationalBuildingIds: Array<Scalars['String']['output']>;
};

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notILike?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SummarySource = {
  __typename?: 'SummarySource';
  areaData: AssessmentArea;
  category: AssessmentCategory;
  consumptionData: AssessmentConsumption;
  dataType: AssessmentDataType;
  emissionData?: Maybe<AssessmentEmission>;
  emissionFactorData?: Maybe<EmissionFactorData>;
  energyConversionFactorData?: Maybe<ConversionFactorData>;
  energyData?: Maybe<AssessmentEnergy>;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  integrationType?: Maybe<IntegrationType>;
  isProxy: Scalars['Boolean']['output'];
  originalFrom: Scalars['DateTime']['output'];
  originalTo: Scalars['DateTime']['output'];
  ownershipType?: Maybe<PropertyOwnershipType>;
  sourceMetadata: SourceMetadata;
  to: Scalars['DateTime']['output'];
  unit?: Maybe<EmissionUnit>;
};

export type SupplierConnection = {
  __typename?: 'SupplierConnection';
  /** Array of edges. */
  edges: Array<SupplierEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type SupplierDeleteResponse = {
  __typename?: 'SupplierDeleteResponse';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internalDescriptor?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type SupplierLocation = {
  __typename?: 'SupplierLocation';
  emissionType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  supplier: Supplier;
};

export type SupplierLocationConnection = {
  __typename?: 'SupplierLocationConnection';
  /** Array of edges. */
  edges: Array<SupplierLocationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type SupplierLocationDeleteFilter = {
  and?: InputMaybe<Array<SupplierLocationDeleteFilter>>;
  emissionType?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SupplierLocationDeleteFilter>>;
};

export type SupplierLocationDeleteResponse = {
  __typename?: 'SupplierLocationDeleteResponse';
  emissionType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SupplierLocationEdge = {
  __typename?: 'SupplierLocationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SupplierLocation */
  node: SupplierLocation;
};

export type SupplierLocationFilter = {
  and?: InputMaybe<Array<SupplierLocationFilter>>;
  emissionType?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SupplierLocationFilter>>;
  supplier?: InputMaybe<SupplierLocationFiltersupplierFilter>;
};

export type SupplierLocationFiltersupplierFilter = {
  and?: InputMaybe<Array<SupplierLocationFiltersupplierFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SupplierLocationFiltersupplierFilter>>;
  website?: InputMaybe<StringFieldComparison>;
};

export type SupplierLocationSort = {
  direction: SortDirection;
  field: SupplierLocationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SupplierLocationSortFields {
  EMISSIONTYPE = 'emissionType',
  ID = 'id'
}

export type SupplierLocationUpdateFilter = {
  and?: InputMaybe<Array<SupplierLocationUpdateFilter>>;
  emissionType?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SupplierLocationUpdateFilter>>;
};

export type SupplierOrganizationConnection = {
  __typename?: 'SupplierOrganizationConnection';
  /** Array of edges. */
  edges: Array<OrganizationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export enum SupportedIntegrationForOnboarding {
  DEXMA = 'DEXMA',
  ELECTRALINK = 'ELECTRALINK',
  ELOVERBLIK = 'ELOVERBLIK',
  ENTOLABS = 'ENTOLABS',
  HOFOR = 'HOFOR',
  OIS = 'OIS',
  SOFTVAERKET = 'SOFTVAERKET',
  TECHEM = 'TECHEM',
  VITANI = 'VITANI'
}

export type TargetEmission = {
  __typename?: 'TargetEmission';
  emissionGrams: TargetEmissionDetails;
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
};

export type TargetEmissionDetails = {
  __typename?: 'TargetEmissionDetails';
  bestEffort: TargetEmissionEmission;
  epc: TargetEmissionEmission;
  meter: TargetEmissionEmission;
};

export type TargetEmissionEmission = {
  __typename?: 'TargetEmissionEmission';
  assetEmission?: Maybe<Scalars['Float']['output']>;
  buildingEmission?: Maybe<Scalars['Float']['output']>;
  isStranded?: Maybe<Scalars['Boolean']['output']>;
  ownedEmission?: Maybe<Scalars['Float']['output']>;
  totalEmission?: Maybe<Scalars['Float']['output']>;
};

export type TargetEmissionSummary = {
  __typename?: 'TargetEmissionSummary';
  from: Scalars['DateTime']['output'];
  ownedEmission?: Maybe<Scalars['Float']['output']>;
};

export type TargetSetting = {
  __typename?: 'TargetSetting';
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
  pathwayName: Scalars['String']['output'];
  reduction?: Maybe<Scalars['Float']['output']>;
  targetYear?: Maybe<Scalars['Float']['output']>;
  type: TargetType;
};

export type TargetSettingConnection = {
  __typename?: 'TargetSettingConnection';
  /** Array of edges. */
  edges: Array<TargetSettingEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type TargetSettingDeleteFilter = {
  and?: InputMaybe<Array<TargetSettingDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TargetSettingDeleteFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  reduction?: InputMaybe<NumberFieldComparison>;
  targetYear?: InputMaybe<NumberFieldComparison>;
  type?: InputMaybe<TargetTypeFilterComparison>;
};

export type TargetSettingDeleteResponse = {
  __typename?: 'TargetSettingDeleteResponse';
  id?: Maybe<Scalars['ID']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  reduction?: Maybe<Scalars['Float']['output']>;
  targetYear?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<TargetType>;
};

export type TargetSettingEdge = {
  __typename?: 'TargetSettingEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TargetSetting */
  node: TargetSetting;
};

export type TargetSettingFilter = {
  and?: InputMaybe<Array<TargetSettingFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TargetSettingFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  reduction?: InputMaybe<NumberFieldComparison>;
  targetYear?: InputMaybe<NumberFieldComparison>;
  type?: InputMaybe<TargetTypeFilterComparison>;
};

export type TargetSettingSort = {
  direction: SortDirection;
  field: TargetSettingSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TargetSettingSortFields {
  ID = 'id',
  ORGANIZATIONID = 'organizationId',
  REDUCTION = 'reduction',
  TARGETYEAR = 'targetYear',
  TYPE = 'type'
}

export type TargetSettingUpdateFilter = {
  and?: InputMaybe<Array<TargetSettingUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TargetSettingUpdateFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  reduction?: InputMaybe<NumberFieldComparison>;
  targetYear?: InputMaybe<NumberFieldComparison>;
  type?: InputMaybe<TargetTypeFilterComparison>;
};

export enum TargetType {
  PATHWAY = 'PATHWAY',
  YEAR_OVER_YEAR = 'YEAR_OVER_YEAR'
}

export type TargetTypeFilterComparison = {
  eq?: InputMaybe<TargetType>;
  gt?: InputMaybe<TargetType>;
  gte?: InputMaybe<TargetType>;
  iLike?: InputMaybe<TargetType>;
  in?: InputMaybe<Array<TargetType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<TargetType>;
  lt?: InputMaybe<TargetType>;
  lte?: InputMaybe<TargetType>;
  neq?: InputMaybe<TargetType>;
  notILike?: InputMaybe<TargetType>;
  notIn?: InputMaybe<Array<TargetType>>;
  notLike?: InputMaybe<TargetType>;
};

export type TechemLocationData = {
  __typename?: 'TechemLocationData';
  property_number: Scalars['String']['output'];
};

export enum UkPropertyType {
  A1_A2_RETAIL = 'A1_A2_Retail',
  A3_A4_A5_RESTAURANT = 'A3_A4_A5_Restaurant',
  AIRPORTTERMINALS = 'AirportTerminals',
  B1_OFFICES = 'B1_Offices',
  B2_B7_GENERALINDUSTRIAL = 'B2_B7_GeneralIndustrial',
  B8_STORAGE = 'B8_Storage',
  BUNGALOW = 'Bungalow',
  BUSSTATION = 'BusStation',
  C1_HOTELS = 'C1_Hotels',
  C2A_SECURERESIDENTIALINSTITUTIONS = 'C2A_SecureResidentialInstitutions',
  C2_RESIDENTIALINSTITUTIONS = 'C2_ResidentialInstitutions',
  C2_RESIDENTIALSCHOOLS = 'C2_ResidentialSchools',
  C2_UNIVERSITIESCOLLEGES = 'C2_UniversitiesColleges',
  COMMUNITYDAYCENTRE = 'CommunityDayCentre',
  CROWNCOUNTYCOURTS = 'CrownCountyCourts',
  D1_COMMUNITYDAYCENTRE = 'D1_CommunityDayCentre',
  D1_CROWNCOUNTYCOURTS = 'D1_CrownCountyCourts',
  D1_EDUCATION = 'D1_Education',
  D1_LIBRARIESMUSEUMSGALLERIES = 'D1_LibrariesMuseumsGalleries',
  D1_NONRESIDENTIALINSTITUTIONS = 'D1_NonResidentialInstitutions',
  D2_GENERALASSEMBLYLEISURE = 'D2_GeneralAssemblyLeisure',
  EMERGENCYSERVICES = 'EmergencyServices',
  FLAT = 'Flat',
  FURTHEREDUCATIONUNIVERSITIES = 'FurtherEducationUniversities',
  GENERALASSEMBLYLEISURE = 'GeneralAssemblyLeisure',
  GENERALINDUSTRIAL = 'GeneralIndustrial',
  HOSPITAL = 'Hospital',
  HOTEL = 'Hotel',
  HOTELS = 'Hotels',
  HOUSE = 'House',
  INDUSTRIALPROCESSBUILDING = 'IndustrialProcessBuilding',
  LAUNDERETTE = 'Launderette',
  LIBRARIESMUSEUMSGALLERIES = 'LibrariesMuseumsGalleries',
  MAISONETTE = 'Maisonette',
  MISCELLANEOUS24HR = 'Miscellaneous24hr',
  NONRESIDENTIALINSTITUTIONS_EDUCATION = 'NonResidentialInstitutions_Education',
  NURSINGRESIDENTIALHOMES = 'NursingResidentialHomes',
  OFFICE = 'Office',
  OFFICES_WORKSHOPBUSINESSES = 'Offices_WorkshopBusinesses',
  OTHERS_CARPARKS = 'Others_CarParks',
  OTHERS_EMERGENCYSERVICES = 'Others_EmergencyServices',
  OTHERS_MISCELLANEOUS24HR = 'Others_Miscellaneous24hr',
  OTHERS_STANDALONEUTILITYBLOCK = 'Others_StandAloneUtilityBlock',
  OTHERS_TELEPHONEEXCHANGES = 'Others_TelephoneExchanges',
  PARKHOUSE = 'ParkHouse',
  PASSENGERTERMINALS = 'PassengerTerminals',
  PRIMARYHEALTHCAREBUILDINGS = 'PrimaryHealthCareBuildings',
  PRIMARYSCHOOL = 'PrimarySchool',
  PRISONS = 'Prisons',
  RESTAURANT_CAFE = 'Restaurant_Cafe',
  RESTAURANT_PUBLICHOUSE = 'Restaurant_PublicHouse',
  RETAIL = 'Retail',
  RETAIL_FINANCIAL_PROFESSIONALSERVICES = 'Retail_Financial_ProfessionalServices',
  SECONDARYSCHOOL = 'SecondarySchool',
  SOCIALCLUBS = 'SocialClubs',
  SPORTSGROUNDARENA = 'SportsGroundArena',
  SPORTSLEISURECENTRE = 'SportsLeisureCentre',
  STORAGE_DISTRIBUTION = 'Storage_Distribution',
  TELEPHONEEXCHANGES = 'TelephoneExchanges',
  THEATRESCINEMASMUSICHALLS = 'TheatresCinemasMusicHalls',
  WAREHOUSESTORAGE = 'WarehouseStorage',
  WORKSHOPSMAINTENANCEDEPOT = 'WorkshopsMaintenanceDepot'
}

export type UpdateAssessment = {
  aggregation?: InputMaybe<AssessmentAggregation>;
  bestEffortPriority?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<AssessmentCategory>;
  consumption?: InputMaybe<Scalars['Float']['input']>;
  consumptionType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  isProjected?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  originalFrom?: InputMaybe<Scalars['DateTime']['input']>;
  originalTo?: InputMaybe<Scalars['DateTime']['input']>;
  ownedBuildingConsumptionPercentage?: InputMaybe<Scalars['Float']['input']>;
  ownershipType?: InputMaybe<PropertyOwnershipType>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  property?: InputMaybe<PropertyDto>;
  source?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  totalBuildingSqm?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EmissionUnit>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateAssessmentOrigin = {
  assessmentType?: InputMaybe<AssessmentDataType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateAssetGroupInput = {
  assets?: InputMaybe<Array<RelationInput>>;
  filters?: InputMaybe<Array<AssetGroupFilterInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetIntegrationAllocation = {
  allocations: Array<AssetIntegrationAllocationInput>;
  id: Scalars['String']['input'];
};

export type UpdateAssetIntegrationInput = {
  allocationNote?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCrremPathway = {
  color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  crremCategory?: InputMaybe<CrremCategory>;
  target?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateEnergyConversionFactorInput = {
  consumptionType?: InputMaybe<ConsumptionType>;
  consumptionUnit?: InputMaybe<EmissionUnit>;
  countryCode?: InputMaybe<CountryCode>;
  dateOfPublication?: InputMaybe<Scalars['DateTime']['input']>;
  externalSource?: InputMaybe<Scalars['String']['input']>;
  factor?: InputMaybe<Scalars['Float']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  publicationName?: InputMaybe<Scalars['String']['input']>;
  publishingCompany?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceFile?: InputMaybe<RetoolFile>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateLegacyBenchmark = {
  benchmarkType?: InputMaybe<LegacyBenchmarkType>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalIdentifier?: InputMaybe<Scalars['String']['input']>;
  numberOfBuildings?: InputMaybe<Scalars['Float']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateLocationInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  bfeCodes?: InputMaybe<Array<Scalars['Float']['input']>>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  constructionDate?: InputMaybe<Scalars['DateTime']['input']>;
  dgnbCertification?: InputMaybe<DgnbCertification>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  internalDescriptor?: InputMaybe<Scalars['String']['input']>;
  legalOwner?: InputMaybe<Scalars['String']['input']>;
  management?: InputMaybe<LocationManagementType>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownership?: InputMaybe<Scalars['Float']['input']>;
  propertyType?: InputMaybe<PropertyType>;
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  saleDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateLocationMetadata = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  constructionDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  longAddress?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalIdentifier?: InputMaybe<Scalars['String']['input']>;
  shortAddress?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManualConsumptionFields = {
  consumption?: InputMaybe<Scalars['Float']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateManualConsumptionInput = {
  assessmentId: Scalars['String']['input'];
  consumptionType?: InputMaybe<ConsumptionType>;
  emissionUnit?: InputMaybe<EmissionUnit>;
  fields?: InputMaybe<UpdateManualConsumptionFields>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyAssessmentOriginsInput = {
  /** Filter used to find fields to update */
  filter: AssessmentOriginUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateAssessmentOrigin;
};

export type UpdateManyAssessmentsInput = {
  /** Filter used to find fields to update */
  filter: AssessmentUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateAssessment;
};

export type UpdateManyAssetGroupsInput = {
  /** Filter used to find fields to update */
  filter: AssetGroupUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateAssetGroupInput;
};

export type UpdateManyCrremPathwaysInput = {
  /** Filter used to find fields to update */
  filter: CrremPathwayUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateCrremPathway;
};

export type UpdateManyEnergyConversionFactorsInput = {
  /** Filter used to find fields to update */
  filter: EnergyConversionFactorUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateEnergyConversionFactorInput;
};

export type UpdateManyLegacyBenchmarksInput = {
  /** Filter used to find fields to update */
  filter: LegacyBenchmarkUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateLegacyBenchmark;
};

export type UpdateManyLocationIntegrationsInput = {
  /** Filter used to find fields to update */
  filter: LocationIntegrationUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateAssetIntegrationInput;
};

export type UpdateManyLocationMetadataInput = {
  /** Filter used to find fields to update */
  filter: LocationMetadataUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateLocationMetadata;
};

export type UpdateManyLocationsInput = {
  /** Filter used to find fields to update */
  filter: LocationUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateLocationInput;
};

export type UpdateManyOrganizationsInput = {
  /** Filter used to find fields to update */
  filter: OrganizationUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateOrganization;
};

export type UpdateManyPriorityBasedEmissionFactorsInput = {
  /** Filter used to find fields to update */
  filter: PriorityBasedEmissionFactorUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdatePriorityBasedEmissionFactorInput;
};

export type UpdateManyPropertiesInput = {
  /** Filter used to find fields to update */
  filter: PropertyUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdatePropertyInput;
};

export type UpdateManyReportsInput = {
  /** Filter used to find fields to update */
  filter: ReportUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateReportInput;
};

export type UpdateManyResponse = {
  __typename?: 'UpdateManyResponse';
  /** The number of records updated. */
  updatedCount: Scalars['Int']['output'];
};

export type UpdateManySupplierLocationsInput = {
  /** Filter used to find fields to update */
  filter: SupplierLocationUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateSupplierLocation;
};

export type UpdateManySuppliersInput = {
  /** Filter used to find fields to update */
  filter: SupplierUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateSupplier;
};

export type UpdateManyTargetSettingsInput = {
  /** Filter used to find fields to update */
  filter: TargetSettingUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateTargetSettingsInput;
};

export type UpdateManyUsersInput = {
  /** Filter used to find fields to update */
  filter: UserUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateUser;
};

export type UpdateOneAssessmentInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateAssessment;
};

export type UpdateOneAssessmentOriginInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateAssessmentOrigin;
};

export type UpdateOneAssetGroupInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateAssetGroupInput;
};

export type UpdateOneCrremPathwayInput = {
  /** The id of the record to update */
  id: Scalars['String']['input'];
  /** The update to apply. */
  update: UpdateCrremPathway;
};

export type UpdateOneEnergyConversionFactorInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateEnergyConversionFactorInput;
};

export type UpdateOneLegacyBenchmarkInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateLegacyBenchmark;
};

export type UpdateOneLocationInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateLocationInput;
};

export type UpdateOneLocationIntegrationInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateAssetIntegrationInput;
};

export type UpdateOneLocationMetadataInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateLocationMetadata;
};

export type UpdateOneOrganizationInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateOrganization;
};

export type UpdateOneOrganizationIntegrationInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateOrganizationIntegrationInput;
};

export type UpdateOnePriorityBasedEmissionFactorInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdatePriorityBasedEmissionFactorInput;
};

export type UpdateOnePropertyInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdatePropertyInput;
};

export type UpdateOneReportInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateReportInput;
};

export type UpdateOneSupplierInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateSupplier;
};

export type UpdateOneSupplierLocationInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateSupplierLocation;
};

export type UpdateOneTargetSettingInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateTargetSettingsInput;
};

export type UpdateOneUserInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateUser;
};

export type UpdateOrganization = {
  baselineYear?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportingYear?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOrganizationIntegrationInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdatePriorityBasedEmissionFactorInput = {
  calculationMethod?: InputMaybe<CalculationMethod>;
  consumptionType?: InputMaybe<ConsumptionType>;
  consumptionUnit?: InputMaybe<EmissionUnit>;
  countryCode?: InputMaybe<CountryCode>;
  dateOfPublication?: InputMaybe<Scalars['DateTime']['input']>;
  externalSource?: InputMaybe<Scalars['String']['input']>;
  factor?: InputMaybe<Scalars['Float']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  isProjected?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  publicationName?: InputMaybe<Scalars['String']['input']>;
  publishingCompany?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceFile?: InputMaybe<RetoolFile>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdatePropertyInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  constructionDate?: InputMaybe<Scalars['DateTime']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalPropertyType?: InputMaybe<Scalars['String']['input']>;
  ownershipType?: InputMaybe<PropertyOwnershipType>;
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  saleDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateReportInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplier = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalDescriptor?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierLocation = {
  emissionType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTargetSettingsInput = {
  pathwayId?: InputMaybe<Scalars['String']['input']>;
  reduction?: InputMaybe<Scalars['Float']['input']>;
  targetYear?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  activeFilterId?: InputMaybe<Scalars['String']['input']>;
  confirmPassword?: InputMaybe<Scalars['String']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatedFields = {
  __typename?: 'UpdatedFields';
  field: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** Array of edges. */
  edges: Array<UserEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type UserDeleteFilter = {
  and?: InputMaybe<Array<UserDeleteFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<UserDeleteFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type UserDeleteResponse = {
  __typename?: 'UserDeleteResponse';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the User */
  node: User;
};

export type UserFilter = {
  and?: InputMaybe<Array<UserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<UserFilter>>;
  organization?: InputMaybe<UserFilterOrganizationFilter>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type UserFilterOrganizationFilter = {
  and?: InputMaybe<Array<UserFilterOrganizationFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<UserFilterOrganizationFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
};

export type UserSort = {
  direction: SortDirection;
  field: UserSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum UserSortFields {
  EMAIL = 'email',
  ID = 'id',
  NAME = 'name',
  PHONE = 'phone'
}

export type UserUpdateFilter = {
  and?: InputMaybe<Array<UserUpdateFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<UserUpdateFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type VitaniLocationData = {
  __typename?: 'VitaniLocationData';
  BuildingID: Scalars['String']['output'];
  DirectoryID: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
};

export type YearlyConsumptionChartData = {
  __typename?: 'YearlyConsumptionChartData';
  emission: Array<ConsumptionBreakdownItem>;
  energy: Array<ConsumptionBreakdownItem>;
  projectedEmission: Array<ConsumptionBreakdownItem>;
  projectedEnergy: Array<ConsumptionBreakdownItem>;
  year: Scalars['String']['output'];
};

export type AssetAlerts = {
  __typename?: 'assetAlerts';
  data?: Maybe<AssetAlertData>;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  to: Scalars['DateTime']['output'];
  type: AssetAlertFlag;
};

export type AssetAlertsFilter = {
  and?: InputMaybe<Array<AssetAlertsFilter>>;
  from?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AssetAlertsFilter>>;
  to?: InputMaybe<DateFieldComparison>;
  type?: InputMaybe<AssetAlertFlagFilterComparison>;
};

export type AssetAlertsSort = {
  direction: SortDirection;
  field: AssetAlertsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AssetAlertsSortFields {
  FROM = 'from',
  ID = 'id',
  TO = 'to',
  TYPE = 'type'
}

export type Supplier = {
  __typename?: 'supplier';
  createdBy: User;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalDescriptor?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization: SupplierOrganizationConnection;
  updatedBy: User;
  website?: Maybe<Scalars['String']['output']>;
};


export type SupplierOrganizationArgs = {
  filter?: OrganizationFilter;
  paging?: CursorPaging;
  sorting?: Array<OrganizationSort>;
};

export type SupplierDeleteFilter = {
  and?: InputMaybe<Array<SupplierDeleteFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SupplierDeleteFilter>>;
  website?: InputMaybe<StringFieldComparison>;
};

export type SupplierEdge = {
  __typename?: 'supplierEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the supplier */
  node: Supplier;
};

export type SupplierFilter = {
  and?: InputMaybe<Array<SupplierFilter>>;
  createdBy?: InputMaybe<SupplierFilterUserFilter>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SupplierFilter>>;
  organization?: InputMaybe<SupplierFilterOrganizationFilter>;
  updatedBy?: InputMaybe<SupplierFilterUserFilter>;
  website?: InputMaybe<StringFieldComparison>;
};

export type SupplierFilterOrganizationFilter = {
  and?: InputMaybe<Array<SupplierFilterOrganizationFilter>>;
  baselineYear?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SupplierFilterOrganizationFilter>>;
  reportingYear?: InputMaybe<NumberFieldComparison>;
};

export type SupplierFilterUserFilter = {
  and?: InputMaybe<Array<SupplierFilterUserFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SupplierFilterUserFilter>>;
  phone?: InputMaybe<StringFieldComparison>;
};

export type SupplierSort = {
  direction: SortDirection;
  field: SupplierSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SupplierSortFields {
  EMAIL = 'email',
  ID = 'id',
  INTERNALDESCRIPTOR = 'internalDescriptor',
  NAME = 'name',
  WEBSITE = 'website'
}

export type SupplierUpdateFilter = {
  and?: InputMaybe<Array<SupplierUpdateFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  internalDescriptor?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SupplierUpdateFilter>>;
  website?: InputMaybe<StringFieldComparison>;
};

export type AssetFragment = { __typename?: 'Location', id: string, externalId?: string | null, displayName?: string | null, fallbackOwnedArea?: number | null, emissionSummaries: Array<{ __typename?: 'EmissionSummary', id: string, vertical: AssessmentVertical, sourceTypes?: Array<string> | null, ownedArea?: number | null, ownedEmission?: number | null }>, dataQuality?: Array<{ __typename?: 'DataQuality', from: any, to: any, highQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, mediumQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, lowQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }> }>, benchmarkPerformances?: Array<{ __typename?: 'BenchmarkPerformance', id: string, performance: number }>, epcs?: Array<{ __typename?: 'EpcAssessment', classification?: string | null }> };

export type GetAssetsQueryVariables = Exact<{
  paging: CursorPaging;
  filter: LocationFilter;
  sorting: LocationSort;
  dataType: AssessmentDataType;
  fromLower: Scalars['DateTime']['input'];
  fromUpper: Scalars['DateTime']['input'];
  benchmarkId?: InputMaybe<Scalars['ID']['input']>;
  fromYear?: InputMaybe<Scalars['Float']['input']>;
  skipPerformance: Scalars['Boolean']['input'];
  skipDataQuality: Scalars['Boolean']['input'];
  skipClassifications: Scalars['Boolean']['input'];
}>;


export type GetAssetsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', totalCount: number, edges: Array<{ __typename?: 'LocationEdge', node: { __typename?: 'Location', id: string, externalId?: string | null, displayName?: string | null, fallbackOwnedArea?: number | null, emissionSummaries: Array<{ __typename?: 'EmissionSummary', id: string, vertical: AssessmentVertical, sourceTypes?: Array<string> | null, ownedArea?: number | null, ownedEmission?: number | null }>, dataQuality?: Array<{ __typename?: 'DataQuality', from: any, to: any, highQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, mediumQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, lowQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }> }>, benchmarkPerformances?: Array<{ __typename?: 'BenchmarkPerformance', id: string, performance: number }>, epcs?: Array<{ __typename?: 'EpcAssessment', classification?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: any | null } } };

export type GetAllAssetsQueryVariables = Exact<{
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  dataType: AssessmentDataType;
  fromLower: Scalars['DateTime']['input'];
  fromUpper: Scalars['DateTime']['input'];
  benchmarkId?: InputMaybe<Scalars['ID']['input']>;
  fromYear?: InputMaybe<Scalars['Float']['input']>;
  skipPerformance: Scalars['Boolean']['input'];
  skipDataQuality: Scalars['Boolean']['input'];
  skipClassifications: Scalars['Boolean']['input'];
}>;


export type GetAllAssetsQuery = { __typename?: 'Query', getAssets: Array<{ __typename?: 'Location', id: string, externalId?: string | null, displayName?: string | null, fallbackOwnedArea?: number | null, emissionSummaries: Array<{ __typename?: 'EmissionSummary', id: string, vertical: AssessmentVertical, sourceTypes?: Array<string> | null, ownedArea?: number | null, ownedEmission?: number | null }>, dataQuality?: Array<{ __typename?: 'DataQuality', from: any, to: any, highQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, mediumQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, lowQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }> }>, benchmarkPerformances?: Array<{ __typename?: 'BenchmarkPerformance', id: string, performance: number }>, epcs?: Array<{ __typename?: 'EpcAssessment', classification?: string | null }> }> };

export type GetAssetsGroupCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetsGroupCitiesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', buildingCities?: Array<{ __typename?: 'LocationCityFilter', city: string }> | null } | null } };

export type GetAssetGroupLegalOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetGroupLegalOwnersQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', legalOwners?: Array<string> | null } | null } };

export type GetAssetsGroupLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetsGroupLocationsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', getLocations?: Array<{ __typename?: 'Location', id: string, name?: string | null, displayName?: string | null, externalId?: string | null }> | null } | null } };

export type GetAssetGroupNationalPropertyTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetGroupNationalPropertyTypeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', nationalPropertyTypes?: Array<{ __typename?: 'LabelValueOption', label: string, value: string }> | null } | null } };

export type GetAssetsGroupPropertySizeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetsGroupPropertySizeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', buildingAreas?: Array<{ __typename?: 'MetadataBuildingArea', floorAreaType: FloorAreaType, area: { __typename?: 'MetadataBuildingAreaInterval', min: number, max: number } }> | null } | null } };

export type AssetGroupFragment = { __typename?: 'AssetGroup', id: string, name: string, assetsAggregate: Array<{ __typename?: 'AssetGroupAssetsAggregateResponse', count?: { __typename?: 'AssetGroupAssetsCountAggregate', id?: number | null } | null }> };

export type GetAssetGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetGroupsQuery = { __typename?: 'Query', assetGroups: { __typename?: 'AssetGroupConnection', edges: Array<{ __typename?: 'AssetGroupEdge', node: { __typename?: 'AssetGroup', id: string, name: string, assetsAggregate: Array<{ __typename?: 'AssetGroupAssetsAggregateResponse', count?: { __typename?: 'AssetGroupAssetsCountAggregate', id?: number | null } | null }> } }> } };

export type DeleteAssetGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAssetGroupMutation = { __typename?: 'Mutation', deleteOneAssetGroup: { __typename?: 'AssetGroupDeleteResponse', id?: string | null } };

export type CreateAssetGroupMutationVariables = Exact<{
  input: CreateOneAssetGroupInput;
}>;


export type CreateAssetGroupMutation = { __typename?: 'Mutation', createOneAssetGroup: { __typename?: 'AssetGroup', id: string, name: string, assetsAggregate: Array<{ __typename?: 'AssetGroupAssetsAggregateResponse', count?: { __typename?: 'AssetGroupAssetsCountAggregate', id?: number | null } | null }> } };

export type UpdateAssetGroupMutationVariables = Exact<{
  input: UpdateOneAssetGroupInput;
}>;


export type UpdateAssetGroupMutation = { __typename?: 'Mutation', updateOneAssetGroup: { __typename?: 'AssetGroup', id: string } };

export type GetAssetGroupsPreviewQueryVariables = Exact<{
  input: Array<AssetGroupFilterInput> | AssetGroupFilterInput;
}>;


export type GetAssetGroupsPreviewQuery = { __typename?: 'Query', getAssetGroupPreview: Array<{ __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null }> };

export type GetAssetGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAssetGroupQuery = { __typename?: 'Query', assetGroup: { __typename?: 'AssetGroup', id: string, name: string, filters: Array<{ __typename?: 'AssetGroupFilterQuery', category: AssetGroupFilterCategory, values: Array<string> }>, assets: Array<{ __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null }> } };

export type ChangeLogFragmentFragment = { __typename?: 'ChangeLog', id: string, eventCreatedAt: any, eventType: ChangeLogEventType, eventPayload: { __typename?: 'ChangeLogEventPayload', user: { __typename?: 'ChangeLogUser', name: string, email: string }, changes: Array<{ __typename?: 'UpdatedFields', field: string, oldValue?: string | null, newValue?: string | null }> }, updatedBy?: { __typename?: 'User', name?: string | null } | null };

export type ChangeLogLabelsFragment = { __typename?: 'ChangeLog', recordLabels: Array<{ __typename?: 'ChangeLogLabel', label: string, value: string }> };

export type GetChangeLogsQueryVariables = Exact<{
  recordId?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<ChangeLogEventType>;
}>;


export type GetChangeLogsQuery = { __typename?: 'Query', getChangeLogs: Array<{ __typename?: 'ChangeLog', id: string, eventCreatedAt: any, eventType: ChangeLogEventType, eventPayload: { __typename?: 'ChangeLogEventPayload', user: { __typename?: 'ChangeLogUser', name: string, email: string }, changes: Array<{ __typename?: 'UpdatedFields', field: string, oldValue?: string | null, newValue?: string | null }> }, updatedBy?: { __typename?: 'User', name?: string | null } | null, recordLabels: Array<{ __typename?: 'ChangeLogLabel', label: string, value: string }> }> };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOneOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOneOrganization: { __typename?: 'Organization', id: string, baselineYear?: number | null } };

export type GetForecastAssessmentsQueryVariables = Exact<{
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  projectedFrom: Scalars['DateTime']['input'];
  projectedTo: Scalars['DateTime']['input'];
  dataType: AssessmentDataType;
}>;


export type GetForecastAssessmentsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, targetSetting?: { __typename?: 'TargetSetting', id: string, type: TargetType, targetYear?: number | null, reduction?: number | null, pathwayName: string } | null } | null }, getAssets: Array<{ __typename?: 'Location', id: string, externalId?: string | null, displayName?: string | null, emissionSummaries: Array<{ __typename?: 'EmissionSummary', from: any, ownedEmission?: number | null, ownedEnergy?: number | null }>, projectedEmissionSummaries: Array<{ __typename?: 'ProjectedEmissionSummary', from: any, ownedEmission?: number | null, ownedEnergy?: number | null }>, targetEmissionSummary: Array<{ __typename?: 'TargetEmissionSummary', from: any, ownedEmission?: number | null }> }>, pathways: { __typename?: 'PathwayConnection', edges: Array<{ __typename?: 'PathwayEdge', node: { __typename?: 'Pathway', id: string, name: string } }> } };

export type DataQualityFragment = { __typename?: 'DataQuality', from: any, to: any, highQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, mediumQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, lowQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }> };

export type GetDataQualityQueryVariables = Exact<{
  assessmentDataType: AssessmentDataType;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  aggregation?: InputMaybe<AssessmentAggregation>;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDataQualityQuery = { __typename?: 'Query', me: { __typename?: 'User', organization?: { __typename?: 'Organization', dataQuality: Array<{ __typename?: 'DataQuality', from: any, to: any, highQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, mediumQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }>, lowQuality: Array<{ __typename?: 'DataQualityDistribution', sources: Array<string>, assessmentDays: number, priorityDistribution: number }> }> } | null } };

export type GetOrgEmissionSummariesForYearlyBreakdownQueryVariables = Exact<{
  aggregation: AssessmentAggregation;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  dataType: AssessmentDataType;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetOrgEmissionSummariesForYearlyBreakdownQuery = { __typename?: 'Query', getAssets: Array<{ __typename?: 'Location', id: string, hasData: boolean, ownedArea?: number | null }>, orgEmissionSummaries: Array<{ __typename?: 'EmissionSummaryView', from: any, assetCount: number, avgEnergyIntensity?: number | null, avgEmissionIntensity?: number | null, ownedEnergyForArea?: number | null, ownedEnergy?: number | null, ownedEmissionForArea?: number | null, ownedEmission?: number | null, ownedArea?: number | null, energyBreakdown: any, emissionBreakdown: any, energyForAreaBreakdown: any, emissionForAreaBreakdown: any, avgEnergyIntensityBreakdown: any, avgEmissionIntensityBreakdown: any }>, orgProjectedEmissionSummaries: Array<{ __typename?: 'ProjectedEmissionSummaryView', from: any, ownedEnergy?: number | null, ownedEmission?: number | null, ownedEnergyForArea?: number | null, ownedEmissionForArea?: number | null, avgEnergyIntensity?: number | null, avgEmissionIntensity?: number | null, energyBreakdown: any, emissionBreakdown: any, ownedArea?: number | null }> };

export type OrgEmissionSummaryFragment = { __typename?: 'EmissionSummaryView', from: any, assetCount: number, avgEnergyIntensity?: number | null, avgEmissionIntensity?: number | null, ownedEnergyForArea?: number | null, ownedEnergy?: number | null, ownedEmissionForArea?: number | null, ownedEmission?: number | null, ownedArea?: number | null };

export type OrgProjectedEmissionSummaryFragment = { __typename?: 'ProjectedEmissionSummaryView', from: any, ownedEnergy?: number | null, ownedEmission?: number | null, ownedEnergyForArea?: number | null, ownedEmissionForArea?: number | null, avgEnergyIntensity?: number | null, avgEmissionIntensity?: number | null, energyBreakdown: any, emissionBreakdown: any, ownedArea?: number | null };

export type BreakdownFragment = { __typename?: 'EmissionSummaryView', energyBreakdown: any, emissionBreakdown: any, energyForAreaBreakdown: any, emissionForAreaBreakdown: any, avgEnergyIntensityBreakdown: any, avgEmissionIntensityBreakdown: any };

export type OutlierAssetsQueryVariables = Exact<{
  filter: LocationFilter;
  sorting: LocationSort;
  dataType: AssessmentDataType;
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
}>;


export type OutlierAssetsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationEdge', node: { __typename?: 'Location', id: string, externalId?: string | null, shortAddress?: string | null, displayName?: string | null, name?: string | null, emissionSummaries: Array<{ __typename?: 'EmissionSummary', id: string, ownedArea?: number | null, ownedEnergy?: number | null, ownedEmission?: number | null }> } }> } };

export type PerformanceLocationFragment = { __typename?: 'Location', id: string, displayName?: string | null, ownedArea?: number | null, externalId?: string | null, assetAlerts: Array<{ __typename?: 'assetAlerts', id: string }>, benchmarkPerformances: Array<{ __typename?: 'BenchmarkPerformance', to: any, from: any, dataType: AssessmentDataType, benchmarkType?: string | null, performance: number, ownedEmission: number }> };

export type GetYearlyPerformanceQueryVariables = Exact<{
  dataType: AssessmentDataType;
  benchmarkId?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Array<Scalars['DateTime']['input']> | Scalars['DateTime']['input']>;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetYearlyPerformanceQuery = { __typename?: 'Query', getAssets: Array<{ __typename?: 'Location', id: string, displayName?: string | null, ownedArea?: number | null, externalId?: string | null, assetAlerts: Array<{ __typename?: 'assetAlerts', id: string }>, benchmarkPerformances: Array<{ __typename?: 'BenchmarkPerformance', to: any, from: any, dataType: AssessmentDataType, benchmarkType?: string | null, performance: number, ownedEmission: number }> }> };

export type GetPortfolioOverviewEmissionSummariesQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTime']['input']>;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  dataType: AssessmentDataType;
}>;


export type GetPortfolioOverviewEmissionSummariesQuery = { __typename?: 'Query', orgEmissionSummaries: Array<{ __typename?: 'EmissionSummaryView', from: any, to: any, assetCount: number, ownedEmission?: number | null, ownedEnergy?: number | null, avgEmissionIntensity?: number | null, ownedArea?: number | null, emissionBreakdown: any, energyBreakdown: any, energyForAreaBreakdown: any, emissionForAreaBreakdown: any, avgEnergyIntensityBreakdown: any, avgEmissionIntensityBreakdown: any }>, orgProjectedEmissionSummaries: Array<{ __typename?: 'ProjectedEmissionSummaryView', from: any, to: any, ownedArea?: number | null, assetCount: number, ownedEmission?: number | null, ownedEnergy?: number | null, avgEnergyIntensity?: number | null, avgEmissionIntensity?: number | null }> };

export type DashboardSummaryFragment = { __typename?: 'EmissionSummaryView', from: any, to: any, assetCount: number, ownedEmission?: number | null, ownedEnergy?: number | null, avgEmissionIntensity?: number | null, ownedArea?: number | null, emissionBreakdown: any, energyBreakdown: any };

export type DashboardProjectedSummaryFragment = { __typename?: 'ProjectedEmissionSummaryView', from: any, to: any, ownedArea?: number | null, assetCount: number, ownedEmission?: number | null, ownedEnergy?: number | null, avgEnergyIntensity?: number | null, avgEmissionIntensity?: number | null };

export type ReportEnergyConversionFactorQueryVariables = Exact<{
  input: ReportQuery;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReportEnergyConversionFactorQuery = { __typename?: 'Query', getReportEnergyConversionFactorHeaders: Array<{ __typename?: 'ReportEnergyConversionFactorHeader', key: string, header: string }>, getReportEnergyConversionFactor: Array<{ __typename?: 'ReportEnergyConversionFactorItem', id: string, activity?: string | null, ghgCategory: string, totalEnergyShare?: string | null, energyConversionFactor?: string | null, energyConversionFactorUnit?: string | null, note?: string | null, source?: string | null, consumptionType?: string | null, releaseDate?: string | null, coveragePeriod?: string | null, calculationMethod?: string | null, region?: string | null, sourceDownloadLink?: string | null, externalSourceLink?: string | null }> };

export type ReportEmissionFactorQueryVariables = Exact<{
  input: ReportQuery;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReportEmissionFactorQuery = { __typename?: 'Query', getReportEmissionFactorHeaders: Array<{ __typename?: 'ReportEmissionFactorHeader', key: string, header: string }>, getReportEmissionFactor: Array<{ __typename?: 'ReportEmissionFactorItem', id: string, activity?: string | null, ghgCategory: string, totalEmissionShare?: string | null, emissionFactor?: string | null, emissionFactorUnit?: string | null, emissionFactorSourceNote?: string | null, emissionDataSource?: string | null, source?: string | null, consumptionType?: string | null, releaseDate?: string | null, coveragePeriod?: string | null, calculationMethod?: string | null, region?: string | null, sourceDownloadLink?: string | null, externalSourceLink?: string | null }> };

export type ReportGhgSummaryFragment = { __typename?: 'ReportGHGSummaryItem', id: string, title: string, value: string, unit: string, baselineYearUnit: string, baselineYearValue: string };

export type ReportEsgSummaryFragment = { __typename?: 'ReportESGSummaryItem', id: string, title: string, value: string, unit: string };

export type ReportCrremSummaryFragment = { __typename?: 'ReportCRREMSummaryItem', id: string, assetId: string, inclusion: string, assetName: string, reportingYear: string, buildingPercentageOwnership: string, startReportingPeriod: string, monthsReportingPeriod: string, legalOwner: string, country: string, city: string, zipCode: string, address: string, crremPropertyType: string, buildingArea: string, buildingDistrictCoolingChilledWaterUsageKWh: string, buildingDistrictCoolingChilledWaterDataCoverageM2: string, buildingGridElectricityUsageKWh: string, buildingGridElectricityDataCoverageM2: string, buildingNaturalGasUsageKWh: string, buildingNaturalGasDataCoverageM2: string, buildingDistrictHeatingSteamUsageKWh: string, buildingDistrictHeatingSteamDataCoverageM2: string, onSiteRenewableElectricityGeneratedAndConsumedOnSite: string, buildingOtherEnergyConsumptionType1Type: string, buildingOtherEnergyConsumptionType1UsageKWh: string, buildingOtherEnergyConsumptionType1DataCoverageM2: string };

export type ReportSummaryQueryVariables = Exact<{
  input: ReportQuery;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReportSummaryQuery = { __typename?: 'Query', getReportSummaryHeader: Array<{ __typename?: 'ReportSummaryHeader', key: string, header: string, columnStyle?: { __typename?: 'ReportStyle', fill?: FillStyle | null } | null }>, getReportSummary: Array<{ __typename: 'ReportCRREMSummaryItem', id: string, assetId: string, inclusion: string, assetName: string, reportingYear: string, buildingPercentageOwnership: string, startReportingPeriod: string, monthsReportingPeriod: string, legalOwner: string, country: string, city: string, zipCode: string, address: string, crremPropertyType: string, buildingArea: string, buildingDistrictCoolingChilledWaterUsageKWh: string, buildingDistrictCoolingChilledWaterDataCoverageM2: string, buildingGridElectricityUsageKWh: string, buildingGridElectricityDataCoverageM2: string, buildingNaturalGasUsageKWh: string, buildingNaturalGasDataCoverageM2: string, buildingDistrictHeatingSteamUsageKWh: string, buildingDistrictHeatingSteamDataCoverageM2: string, onSiteRenewableElectricityGeneratedAndConsumedOnSite: string, buildingOtherEnergyConsumptionType1Type: string, buildingOtherEnergyConsumptionType1UsageKWh: string, buildingOtherEnergyConsumptionType1DataCoverageM2: string } | { __typename: 'ReportESGSummaryItem', id: string, title: string, value: string, unit: string } | { __typename: 'ReportGHGSummaryItem', id: string, title: string, value: string, unit: string, baselineYearUnit: string, baselineYearValue: string }> };

export type ReportInventoryQueryVariables = Exact<{
  input: ReportQuery;
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReportInventoryQuery = { __typename?: 'Query', getReportInventoryHeaders: Array<{ __typename?: 'ReportInventoryHeader', key: string, header: string }>, getReportInventory: Array<{ __typename?: 'ReportInventoryItem', id: string, activity?: string | null, addresses?: string | null, assetArea?: string | null, assetAreaUnit?: string | null, assetConsumption?: string | null, assetConsumptionUnit?: string | null, assetEmission?: string | null, assetEmissionUnit?: string | null, assetPercentageOwnership?: string | null, buildingArea?: string | null, buildingAreaUnit?: string | null, buildingConsumption?: string | null, buildingConsumptionUnit?: string | null, buildingEmission?: string | null, buildingEmissionUnit?: string | null, buildingPercentageOwnership?: string | null, ghgCategory?: string | null, classification?: string | null, consumption?: string | null, consumptionDataSource?: string | null, dataArea?: string | null, dataAreaUnit?: string | null, dataGap?: string | null, dataPercentageOwnership?: string | null, emissionDataSource?: string | null, emissionFactor?: string | null, emissionFactorUnit?: string | null, emissionSourceNote?: string | null, epcLink?: string | null, epcProxy?: string | null, from: string, identifier?: string | null, legalOwner?: string | null, locationId: string, locationName: string, locationOwnership?: string | null, management: string, nationalBuildingIds?: string | null, ownedArea?: string | null, ownedAreaUnit?: string | null, ownedConsumption?: string | null, ownedConsumptionUnit?: string | null, ownedEmission?: string | null, ownedEmissionUnit?: string | null, partialOwnershipPercentDistribution?: string | null, percentDistribution?: string | null, propertyType?: string | null, purchaseDate: string, scope?: string | null, to: string, totalArea?: string | null, totalAreaUnit?: string | null, totalEmission?: string | null, totalEmissionUnit?: string | null, unit?: string | null, assetEnergyConsumption?: string | null, ownedEnergyConsumption?: string | null, energyConversionFactor: string, energyConversionFactorUnit: string, energyConversionSource: string, energyConversionSourceNote: string }> };

export type CreateTargetSettingMutationVariables = Exact<{
  input: CreateOneTargetSettingInput;
}>;


export type CreateTargetSettingMutation = { __typename?: 'Mutation', createOneTargetSetting: { __typename?: 'TargetSetting', id: string } };

export type UpdateTargetSettingMutationVariables = Exact<{
  input: UpdateOneTargetSettingInput;
}>;


export type UpdateTargetSettingMutation = { __typename?: 'Mutation', updateOneTargetSetting: { __typename?: 'TargetSetting', id: string } };

export type DeleteTargetSettingMutationVariables = Exact<{
  input: DeleteOneTargetSettingInput;
}>;


export type DeleteTargetSettingMutation = { __typename?: 'Mutation', deleteOneTargetSetting: { __typename?: 'TargetSettingDeleteResponse', id?: string | null } };

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name?: string | null, email: string, phone?: string | null } };

export type AutomaticSourceFragment = { __typename?: 'LocationIntegration', id: string, from?: any | null, to?: any | null, isActive: boolean, endedAt?: any | null, type: IntegrationType, address?: string | null, identifier: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType>, allocationNote?: string | null, ownershipType: PropertyOwnershipType, allocations?: Array<{ __typename?: 'AssetIntegrationAllocation', percentage: number, propertyId?: string | null, assetId?: string | null, property?: { __typename?: 'Property', objectType: PropertyObjectType } | null }> };

export type AutomaticSourceAllocationFragment = { __typename?: 'AssetIntegrationAllocation', percentage: number, propertyId?: string | null, assetId?: string | null, property?: { __typename?: 'Property', objectType: PropertyObjectType } | null };

export type PropertyInfoFragmentFragment = { __typename?: 'Property', id: string, name?: string | null, objectType: PropertyObjectType };

export type GetPropertyTreeForAllocationQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetPropertyTreeForAllocationQuery = { __typename?: 'Query', getAssetPropertyTree: Array<{ __typename?: 'Property', id: string, name?: string | null, objectType: PropertyObjectType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, objectType: PropertyObjectType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, objectType: PropertyObjectType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, objectType: PropertyObjectType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, objectType: PropertyObjectType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, objectType: PropertyObjectType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, objectType: PropertyObjectType }> | null }> | null }> | null }> | null }> | null }> | null }> };

export type GetAllAssetIntegrationsQueryVariables = Exact<{
  filter: LocationIntegrationFilter;
  paging: CursorPaging;
  sorting: LocationIntegrationSort;
  skipAllocation: Scalars['Boolean']['input'];
}>;


export type GetAllAssetIntegrationsQuery = { __typename?: 'Query', locationIntegrations: { __typename?: 'LocationIntegrationConnection', totalCount: number, edges: Array<{ __typename?: 'LocationIntegrationEdge', node: { __typename?: 'LocationIntegration', id: string, from?: any | null, to?: any | null, isActive: boolean, endedAt?: any | null, type: IntegrationType, address?: string | null, identifier: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType>, allocationNote?: string | null, ownershipType: PropertyOwnershipType, allocations?: Array<{ __typename?: 'AssetIntegrationAllocation', percentage: number, propertyId?: string | null, assetId?: string | null, property?: { __typename?: 'Property', objectType: PropertyObjectType } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: any | null } } };

export type GetAllAssetAutomaticSourcesQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  skipAllocation: Scalars['Boolean']['input'];
}>;


export type GetAllAssetAutomaticSourcesQuery = { __typename?: 'Query', location: { __typename?: 'Location', integrations: Array<{ __typename?: 'LocationIntegration', id: string, from?: any | null, to?: any | null, isActive: boolean, endedAt?: any | null, type: IntegrationType, address?: string | null, identifier: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType>, allocationNote?: string | null, ownershipType: PropertyOwnershipType, allocations?: Array<{ __typename?: 'AssetIntegrationAllocation', percentage: number, propertyId?: string | null, assetId?: string | null, property?: { __typename?: 'Property', objectType: PropertyObjectType } | null }> }> } };

export type GetAssetAutomaticSourcesCountQueryVariables = Exact<{
  assetId: Scalars['String']['input'];
}>;


export type GetAssetAutomaticSourcesCountQuery = { __typename?: 'Query', locationIntegrations: { __typename?: 'LocationIntegrationConnection', totalCount: number } };

export type GetAssetAutomaticSourcesOptionsQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAssetAutomaticSourcesOptionsQuery = { __typename?: 'Query', location: { __typename?: 'Location', integrationTypes: Array<IntegrationType>, consumptionTypes: Array<ConsumptionType> } };

export type UpdateAssetIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  update: UpdateAssetIntegrationInput;
}>;


export type UpdateAssetIntegrationMutation = { __typename?: 'Mutation', updateOneLocationIntegration: { __typename?: 'LocationIntegration', id: string, type: IntegrationType, assetId: string, allocationNote?: string | null } };

export type GetAssetIntegrationAllocationsQueryVariables = Exact<{
  assetIntegrationId: Scalars['ID']['input'];
}>;


export type GetAssetIntegrationAllocationsQuery = { __typename?: 'Query', locationIntegration: { __typename?: 'LocationIntegration', id: string, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, percentage: number, assetId?: string | null, propertyId?: string | null }> } };

export type AssetIntegrationAllocationItemFragment = { __typename?: 'AssetIntegrationAllocation', id: string, percentage: number, assetId?: string | null, propertyId?: string | null };

export type UpdateAssetIntegrationAllocationMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  allocations: Array<AssetIntegrationAllocationInput> | AssetIntegrationAllocationInput;
}>;


export type UpdateAssetIntegrationAllocationMutation = { __typename?: 'Mutation', updateAssetIntegrationAllocations: { __typename?: 'LocationIntegration', id: string, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, percentage: number, assetId?: string | null, propertyId?: string | null }> } };

export type CreateManualConsumptionsMutationVariables = Exact<{
  input: Array<CreateManualConsumptionInput> | CreateManualConsumptionInput;
}>;


export type CreateManualConsumptionsMutation = { __typename?: 'Mutation', createManualConsumptions: Array<{ __typename?: 'Assessment', id: string }> };

export type UpdateManualConsumptionMutationVariables = Exact<{
  input: UpdateManualConsumptionInput;
}>;


export type UpdateManualConsumptionMutation = { __typename?: 'Mutation', updateManualConsumption?: { __typename?: 'Assessment', id: string } | null };

export type GetAssetManualSourcesQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetAssetManualSourcesQuery = { __typename?: 'Query', location: { __typename?: 'Location', displayName?: string | null, manualAssessments: Array<{ __typename?: 'Assessment', id: string, consumption: number, consumptionType: string, unit?: EmissionUnit | null, to: any, from: any, vertical?: AssessmentVertical | null, createdAt: any, updatedAt: any, isEditable: boolean, origin?: { __typename?: 'AssessmentOrigin', assessmentType?: AssessmentDataType | null, file?: { __typename?: 'File', name: string, url: string } | null } | null, data?: { __typename?: 'IntegrationDexmaAssessmentData' } | { __typename?: 'IntegrationElectralinkAssessmentData' } | { __typename?: 'IntegrationEpcAssessmentData', classification: string, pdfLink: string } | { __typename?: 'IntegrationEpcUkAssessmentData', lmkKey: string } | { __typename?: 'IntegrationHoforAssessmentData' } | { __typename?: 'IntegrationOISAssessmentData' } | { __typename?: 'IntegrationTechemAssessmentData' } | { __typename?: 'IntegrationVitaniAssessmentData' } | { __typename?: 'ManualAssessmentData', identifier?: string | null } | null }> } };

export type AssetCoverageAssessmentFragment = { __typename?: 'Assessment', id: string, to: any, from: any, source?: string | null, bestEffortPriority?: number | null, unit?: EmissionUnit | null, emissionDataGrams?: { __typename?: 'AssessmentEmission', ownedEmission?: number | null } | null, consumptionData: { __typename?: 'AssessmentConsumption', ownedConsumption: number } };

export type GetAssetDataCoverageQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetAssetDataCoverageQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, assessmentGroups: Array<{ __typename?: 'AssessmentsCoverage', vertical: AssessmentVertical, maxHighPriority: number, maxMediumPriority: number, assessments: Array<{ __typename?: 'Assessment', id: string, to: any, from: any, source?: string | null, bestEffortPriority?: number | null, unit?: EmissionUnit | null, emissionDataGrams?: { __typename?: 'AssessmentEmission', ownedEmission?: number | null } | null, consumptionData: { __typename?: 'AssessmentConsumption', ownedConsumption: number } }> }> } };

export type GetAllAssetDetailsQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  eventType?: InputMaybe<ChangeLogEventType>;
}>;


export type GetAllAssetDetailsQuery = { __typename?: 'Query', changeLogsFieldsCount: number, location: { __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null, constructionDate?: any | null, countryCode?: string | null, propertyCount: number, ownership?: number | null, purchaseDate?: any | null, saleDate?: any | null, management?: LocationManagementType | null, legalOwner?: string | null, buildingArea?: number | null, propertyType?: PropertyType | null, ownedArea?: number | null } };

export type GetAssetPropertyAllocationCountQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAssetPropertyAllocationCountQuery = { __typename?: 'Query', locationIntegrations: { __typename?: 'LocationIntegrationConnection', totalCount: number } };

export type PropertyAllocationFragmentFragment = { __typename?: 'Property', allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, assetIntegration: { __typename?: 'LocationIntegration', id: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType> } }> };

export type AssetPropertyTreeFragmentFragment = { __typename?: 'Property', id: string, name?: string | null, longAddress?: string | null, objectType: PropertyObjectType, ownershipType: PropertyOwnershipType, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, assetIntegration: { __typename?: 'LocationIntegration', id: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType> } }> };

export type GetAssetPropertyTreeQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAssetPropertyTreeQuery = { __typename?: 'Query', getAssetPropertyTree: Array<{ __typename?: 'Property', id: string, name?: string | null, longAddress?: string | null, objectType: PropertyObjectType, ownershipType: PropertyOwnershipType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, longAddress?: string | null, objectType: PropertyObjectType, ownershipType: PropertyOwnershipType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, longAddress?: string | null, objectType: PropertyObjectType, ownershipType: PropertyOwnershipType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, longAddress?: string | null, objectType: PropertyObjectType, ownershipType: PropertyOwnershipType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, longAddress?: string | null, objectType: PropertyObjectType, ownershipType: PropertyOwnershipType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, longAddress?: string | null, objectType: PropertyObjectType, ownershipType: PropertyOwnershipType, children?: Array<{ __typename?: 'Property', id: string, name?: string | null, longAddress?: string | null, objectType: PropertyObjectType, ownershipType: PropertyOwnershipType, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, assetIntegration: { __typename?: 'LocationIntegration', id: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType> } }> }> | null, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, assetIntegration: { __typename?: 'LocationIntegration', id: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType> } }> }> | null, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, assetIntegration: { __typename?: 'LocationIntegration', id: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType> } }> }> | null, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, assetIntegration: { __typename?: 'LocationIntegration', id: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType> } }> }> | null, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, assetIntegration: { __typename?: 'LocationIntegration', id: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType> } }> }> | null, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, assetIntegration: { __typename?: 'LocationIntegration', id: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType> } }> }> | null, allocations: Array<{ __typename?: 'AssetIntegrationAllocation', id: string, assetIntegration: { __typename?: 'LocationIntegration', id: string, dataQuality?: DataQualityTypes | null, consumptionTypes: Array<ConsumptionType> } }> }> };

export type AddAssetPropertyMutationVariables = Exact<{
  input: AddAssetPropertyInput;
}>;


export type AddAssetPropertyMutation = { __typename?: 'Mutation', addAssetProperty: Array<{ __typename?: 'Property', id: string, name?: string | null }> };

export type UpdateAssetPropertyMutationVariables = Exact<{
  input: UpdateOnePropertyInput;
}>;


export type UpdateAssetPropertyMutation = { __typename?: 'Mutation', updateOneProperty: { __typename?: 'Property', id: string, name?: string | null } };

export type DeleteAssetPropertyMutationVariables = Exact<{
  input: DeleteAssetPropertyInput;
}>;


export type DeleteAssetPropertyMutation = { __typename?: 'Mutation', deleteAssetProperty: string };

export type GetPropertyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPropertyQuery = { __typename?: 'Query', property: { __typename?: 'Property', id: string, identifier?: string | null, name?: string | null, generalPropertyType?: PropertyType | null, crremPropertyCategory?: CrremCategory | null, nationalPropertyType?: string | null, nationalPropertyTypeValue?: string | null, objectType: PropertyObjectType, ownershipType: PropertyOwnershipType, purchaseDate?: any | null, saleDate?: any | null, updatedAt: any, createdAt: any, constructionDate?: any | null, buildingArea?: number | null, address?: any | null, parent?: { __typename?: 'Property', name?: string | null, objectType: PropertyObjectType } | null } };

export type UpdateAssetMasterDataMutationVariables = Exact<{
  input: UpdateOneLocationInput;
}>;


export type UpdateAssetMasterDataMutation = { __typename?: 'Mutation', updateOneLocation: { __typename?: 'Location', name?: string | null, externalId?: string | null, buildingArea?: number | null, ownership?: number | null, propertyType?: PropertyType | null, purchaseDate?: any | null, saleDate?: any | null, legalOwner?: string | null, management?: LocationManagementType | null } };

export type GetAssetEmissionSummaryInventoryQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  aggregation: AssessmentAggregation;
  dataType: AssessmentDataType;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  language: ReportLanguage;
}>;


export type GetAssetEmissionSummaryInventoryQuery = { __typename?: 'Query', simpleAssetInventoryHeaders: Array<{ __typename?: 'AssetSimpleInventoryHeader', key: string, header: string }>, location: { __typename?: 'Location', id: string, emissionSummaryInventory: Array<{ __typename?: 'ReportEmissionSummaryInventoryItem', id: string, nationalBuildingIds: string, addresses: string, assetArea: string, assetAreaUnit: string, assetPercentageOwnership: string, from: string, to: string, activity: string, consumptionType: string, assetConsumption: string, ownedConsumption: string, consumptionUnit: string, consumptionDataSource: string, scope: string, assetEmission: string, ownedEmission: string, emissionUnit: string, emissionFactor: string, emissionFactorUnit: string, emissionDataSource: string, emissionSourceNote: string, assetEnergyConsumption: string, ownedEnergyConsumption: string, energyConversionFactor: string, energyConversionFactorUnit: string, energyConversionSource: string, energyConversionSourceNote: string }> } };

export type OverviewAssessmentFragment = { __typename?: 'Assessment', id: string, from: any, parentId?: string | null, unit?: EmissionUnit | null, ownershipType?: PropertyOwnershipType | null, property?: { __typename?: 'Property', id: string } | null, emissionDataGrams?: { __typename?: 'AssessmentEmission', ownedEmission?: number | null } | null, consumptionData: { __typename?: 'AssessmentConsumption', ownedConsumption: number }, integration?: { __typename?: 'LocationIntegration', type: IntegrationType, ownershipType: PropertyOwnershipType } | null, origin?: { __typename?: 'AssessmentOrigin', assessmentType?: AssessmentDataType | null } | null };

export type GetAllAssessmentsQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreProxy?: InputMaybe<Scalars['Boolean']['input']>;
  verticals?: InputMaybe<Array<AssessmentVertical> | AssessmentVertical>;
  aggregation?: InputMaybe<AssessmentAggregation>;
  assessmentFilter?: InputMaybe<AssessmentQueryFilter>;
  skipAllocation: Scalars['Boolean']['input'];
}>;


export type GetAllAssessmentsQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, saleDate?: any | null, purchaseDate?: any | null, assessmentGroups: Array<{ __typename?: 'AssessmentsCoverage', vertical: AssessmentVertical, assessments: Array<{ __typename?: 'Assessment', id: string, from: any, parentId?: string | null, unit?: EmissionUnit | null, ownershipType?: PropertyOwnershipType | null, property?: { __typename?: 'Property', id: string } | null, emissionDataGrams?: { __typename?: 'AssessmentEmission', ownedEmission?: number | null } | null, consumptionData: { __typename?: 'AssessmentConsumption', ownedConsumption: number }, integration?: { __typename?: 'LocationIntegration', type: IntegrationType, ownershipType: PropertyOwnershipType } | null, origin?: { __typename?: 'AssessmentOrigin', assessmentType?: AssessmentDataType | null } | null }> }>, projectedAssessments: Array<{ __typename?: 'Assessment', from: any, emissionDataGrams?: { __typename?: 'AssessmentEmission', ownedEmission?: number | null } | null }> } };

export type AssetAlertFragment = { __typename?: 'assetAlerts', id: string, to: any, from: any, type: AssetAlertFlag, data?: { __typename?: 'EpcExpiresSoonAlertData', epcExpiryDates: Array<string> } | { __typename?: 'MissingMeterDataAlertData', meterIntegrations: Array<{ __typename?: 'MeterIntegration', type: IntegrationType, lastReading: string }> } | null };

export type GetAssetAddressQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetAssetAddressQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, longAddress?: string | null, displayName?: string | null, ownedArea?: number | null, countryCode?: string | null, assetAlerts: Array<{ __typename?: 'assetAlerts', id: string, to: any, from: any, type: AssetAlertFlag, data?: { __typename?: 'EpcExpiresSoonAlertData', epcExpiryDates: Array<string> } | { __typename?: 'MissingMeterDataAlertData', meterIntegrations: Array<{ __typename?: 'MeterIntegration', type: IntegrationType, lastReading: string }> } | null }> } };

export type CreateSingleLocationMutationVariables = Exact<{
  location: CreateLocationInput;
}>;


export type CreateSingleLocationMutation = { __typename?: 'Mutation', createOneLocation: { __typename?: 'Location', id: string, externalId?: string | null, integrations: Array<{ __typename?: 'LocationIntegration', id: string, type: IntegrationType, originId: string }> } };

export type UpdateSingleLocationMutationVariables = Exact<{
  input: UpdateOneLocationInput;
}>;


export type UpdateSingleLocationMutation = { __typename?: 'Mutation', updateOneLocation: { __typename?: 'Location', name?: string | null, externalId?: string | null, buildingArea?: number | null, ownership?: number | null, propertyType?: PropertyType | null, purchaseDate?: any | null, saleDate?: any | null, legalOwner?: string | null, management?: LocationManagementType | null } };

export type CreateManyIntegrationsMutationVariables = Exact<{
  locationIntegrations: Array<CreateAssetIntegrationInput> | CreateAssetIntegrationInput;
}>;


export type CreateManyIntegrationsMutation = { __typename?: 'Mutation', createManyLocationIntegrations: Array<{ __typename?: 'LocationIntegration', id: string, type: IntegrationType, originId: string, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', id: number, type: string } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData', municipality: string, property: string, building: string } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData' } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData' } | { __typename?: 'IntegrationVitaniLocationIntegrationData' } | { __typename?: 'OriginIntegrationData' } }> };

export type GetOrgDataForOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgDataForOnboardingQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string, locations: { __typename?: 'OrganizationLocationsConnection', edges: Array<{ __typename?: 'LocationEdge', node: { __typename?: 'Location', id: string, externalId?: string | null, displayName?: string | null, name?: string | null, shortAddress?: string | null, internalDescriptor?: string | null, integrations: Array<{ __typename?: 'LocationIntegration', id: string, type: IntegrationType, originId: string, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', type: string, dexmaId: number } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData', municipality: string, property: string, building: string } | { __typename?: 'IntegrationEpcUkLocationIntegrationData', buildingType: string, address1: string, address2?: string | null, address3?: string | null, postcode: string } | { __typename?: 'IntegrationHoforLocationIntegrationData' } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData', propertyId: string } | { __typename?: 'IntegrationVitaniLocationIntegrationData', directoryId: number } | { __typename?: 'OriginIntegrationData' } }> } }> } } | null } };

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, locations: { __typename?: 'OrganizationLocationsConnection', edges: Array<{ __typename?: 'LocationEdge', node: { __typename?: 'Location', externalId?: string | null, id: string, name?: string | null, shortAddress?: string | null, displayName?: string | null, buildings: Array<{ __typename?: 'LocationMetadata', name?: string | null, shortAddress?: string | null }> } }> } } | null } };

export type CreateManyAssessmentsMutationVariables = Exact<{
  input: CreateManyAssessmentsInput;
}>;


export type CreateManyAssessmentsMutation = { __typename?: 'Mutation', createManyAssessments: Array<{ __typename?: 'Assessment', id: string }> };

export type CreateAssessmentOriginMutationVariables = Exact<{
  input: CreateOneAssessmentOriginInput;
}>;


export type CreateAssessmentOriginMutation = { __typename?: 'Mutation', createOneAssessmentOrigin: { __typename?: 'AssessmentOrigin', id: string } };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'File', id: string, name: string, url: string } };

export type UpsertManyLocationMetadataMutationVariables = Exact<{
  input: Array<CreateLocationMetadataInput> | CreateLocationMetadataInput;
}>;


export type UpsertManyLocationMetadataMutation = { __typename?: 'Mutation', upsertManyLocationMetadata: Array<{ __typename?: 'LocationMetadata', locationId?: string | null }> };

export type AddLocationIntegrationMutationVariables = Exact<{
  input: Array<CreateAssetIntegrationInput> | CreateAssetIntegrationInput;
}>;


export type AddLocationIntegrationMutation = { __typename?: 'Mutation', addLocationIntegration: Array<{ __typename?: 'LocationIntegration', id: string }> };

export type DeleteLocationIntegrationMutationVariables = Exact<{
  input: Array<DeleteLocationIntegrationInput> | DeleteLocationIntegrationInput;
}>;


export type DeleteLocationIntegrationMutation = { __typename?: 'Mutation', deleteLocationIntegration?: Array<{ __typename?: 'LocationIntegration', originId: string, assetId: string }> | null };

export type UpdateLocationIntegrationMutationVariables = Exact<{
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type UpdateLocationIntegrationMutation = { __typename?: 'Mutation', updateManyLocationIntegrations: { __typename?: 'UpdateManyResponse', updatedCount: number } };

export type DeleteLocationIntegrationByIdsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteLocationIntegrationByIdsMutation = { __typename?: 'Mutation', deleteManyLocationIntegrations: { __typename?: 'DeleteManyResponse', deletedCount: number } };

export type DexmaMeterLocationFragment = { __typename?: 'DexmaLocationData', id: number, key: string, name: string, activity?: string | null, reference_devices?: Array<{ __typename?: 'ReferenceDeviceData', type: string, device: { __typename?: 'DeviceData', id: number } }> | null };

export type TechemMeterLocationFragment = { __typename?: 'TechemLocationData', property_number: string };

export type VitaniMeterLocationFragment = { __typename?: 'VitaniLocationData', Name: string, DirectoryID: number, BuildingID: string };

export type HoforMeterLocationFragment = { __typename?: 'HoforLocationData', installationNumber: string };

export type EntolabsMeterLocationFragment = { __typename?: 'EntolabsLocationData', entolabsOrganizationId: string, meterId: string, meterName: string, meterType: IntegrationEntolabsMeterType, siteId: string, siteName: string, sourceId: string, address?: string | null };

export type ElectralinkMeterLocationFragment = { __typename?: 'ElectralinkLocation', postCode: string, address: string, hashedMPAN: string, partialMPAN: string };

export type SoftvaerketMeterLocationFragment = { __typename?: 'SoftvaerketMeter', id: string, address: string, identifier: string, supplierId?: string | null, supplierName?: string | null };

export type EloverblikMeterLocationFragment = { __typename?: 'EloverblikMeter', meteringPointId: string, meterNumber: string, address: string, typeOfMP: string, consumerStartDate: string, parentMeteringPointId?: string | null };

export type CustomerLocationFragment = { __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null, shortAddress?: string | null, longAddress?: string | null, zipCode?: string | null, buildings: Array<{ __typename?: 'LocationMetadata', name?: string | null, shortAddress?: string | null, longAddress?: string | null, nationalIdentifier?: string | null, zipCode?: string | null }>, integrations: Array<{ __typename?: 'LocationIntegration', assetId: string, type: IntegrationType, originId: string, startedAt?: any | null, endedAt?: any | null, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', id: number, type: string } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData', installationNumber: string } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData', propertyId: string } | { __typename?: 'IntegrationVitaniLocationIntegrationData', directoryId: number } | { __typename?: 'OriginIntegrationData' } }> };

export type GetIntegrationsTypesForOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationsTypesForOnboardingQuery = { __typename?: 'Query', integrationTypesForOnboarding: Array<SupportedIntegrationForOnboarding> };

export type GetDexmaMeterLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDexmaMeterLocationsQuery = { __typename?: 'Query', locationsForDexmaIntegration: { __typename?: 'LocationsForDexmaIntegrationResponse', meterLocations: Array<{ __typename?: 'DexmaLocationData', id: number, key: string, name: string, activity?: string | null, reference_devices?: Array<{ __typename?: 'ReferenceDeviceData', type: string, device: { __typename?: 'DeviceData', id: number } }> | null }>, initialLocationIntegrationsState?: Array<{ __typename?: 'InitialDexmaLocationIntegrationsStateData', rowIndex: number, customerLocation: { __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null, shortAddress?: string | null, longAddress?: string | null, zipCode?: string | null, buildings: Array<{ __typename?: 'LocationMetadata', name?: string | null, shortAddress?: string | null, longAddress?: string | null, nationalIdentifier?: string | null, zipCode?: string | null }>, integrations: Array<{ __typename?: 'LocationIntegration', assetId: string, type: IntegrationType, originId: string, startedAt?: any | null, endedAt?: any | null, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', id: number, type: string } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData', installationNumber: string } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData', propertyId: string } | { __typename?: 'IntegrationVitaniLocationIntegrationData', directoryId: number } | { __typename?: 'OriginIntegrationData' } }> }, meterLocations: Array<{ __typename?: 'DexmaLocationData', id: number, key: string, name: string, activity?: string | null, reference_devices?: Array<{ __typename?: 'ReferenceDeviceData', type: string, device: { __typename?: 'DeviceData', id: number } }> | null }> }> | null } };

export type GetTechemMeterLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTechemMeterLocationsQuery = { __typename?: 'Query', locationsForTechemIntegration: { __typename?: 'LocationsForTechemIntegrationResponse', meterLocations: Array<{ __typename?: 'TechemLocationData', property_number: string }>, initialLocationIntegrationsState?: Array<{ __typename?: 'InitialTechemLocationIntegrationsStateData', rowIndex: number, customerLocation: { __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null, shortAddress?: string | null, longAddress?: string | null, zipCode?: string | null, buildings: Array<{ __typename?: 'LocationMetadata', name?: string | null, shortAddress?: string | null, longAddress?: string | null, nationalIdentifier?: string | null, zipCode?: string | null }>, integrations: Array<{ __typename?: 'LocationIntegration', assetId: string, type: IntegrationType, originId: string, startedAt?: any | null, endedAt?: any | null, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', id: number, type: string } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData', installationNumber: string } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData', propertyId: string } | { __typename?: 'IntegrationVitaniLocationIntegrationData', directoryId: number } | { __typename?: 'OriginIntegrationData' } }> }, meterLocations: Array<{ __typename?: 'TechemLocationData', property_number: string }> }> | null } };

export type GetVitaniMeterLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVitaniMeterLocationsQuery = { __typename?: 'Query', locationsForVitaniIntegration: { __typename?: 'LocationsForVitaniIntegrationResponse', meterLocations: Array<{ __typename?: 'VitaniLocationData', Name: string, DirectoryID: number, BuildingID: string }>, initialLocationIntegrationsState?: Array<{ __typename?: 'InitialVitaniLocationIntegrationsStateData', rowIndex: number, customerLocation: { __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null, shortAddress?: string | null, longAddress?: string | null, zipCode?: string | null, buildings: Array<{ __typename?: 'LocationMetadata', name?: string | null, shortAddress?: string | null, longAddress?: string | null, nationalIdentifier?: string | null, zipCode?: string | null }>, integrations: Array<{ __typename?: 'LocationIntegration', assetId: string, type: IntegrationType, originId: string, startedAt?: any | null, endedAt?: any | null, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', id: number, type: string } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData', installationNumber: string } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData', propertyId: string } | { __typename?: 'IntegrationVitaniLocationIntegrationData', directoryId: number } | { __typename?: 'OriginIntegrationData' } }> }, meterLocations: Array<{ __typename?: 'VitaniLocationData', Name: string, DirectoryID: number, BuildingID: string }> }> | null } };

export type GetHoforMeterLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHoforMeterLocationsQuery = { __typename?: 'Query', locationsForHoforIntegration: { __typename?: 'LocationsForHoforIntegrationResponse', meterLocations: Array<{ __typename?: 'HoforLocationData', installationNumber: string }>, initialLocationIntegrationsState?: Array<{ __typename?: 'InitialHoforLocationIntegrationsStateData', rowIndex: number, customerLocation: { __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null, shortAddress?: string | null, longAddress?: string | null, zipCode?: string | null, buildings: Array<{ __typename?: 'LocationMetadata', name?: string | null, shortAddress?: string | null, longAddress?: string | null, nationalIdentifier?: string | null, zipCode?: string | null }>, integrations: Array<{ __typename?: 'LocationIntegration', assetId: string, type: IntegrationType, originId: string, startedAt?: any | null, endedAt?: any | null, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', id: number, type: string } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData', installationNumber: string } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData', propertyId: string } | { __typename?: 'IntegrationVitaniLocationIntegrationData', directoryId: number } | { __typename?: 'OriginIntegrationData' } }> }, meterLocations: Array<{ __typename?: 'HoforLocationData', installationNumber: string }> }> | null } };

export type GetEntolabsMeterLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEntolabsMeterLocationsQuery = { __typename?: 'Query', locationsForEntolabsIntegration: { __typename?: 'LocationsForEntolabsIntegrationResponse', meterLocations: Array<{ __typename?: 'EntolabsLocationData', entolabsOrganizationId: string, meterId: string, meterName: string, meterType: IntegrationEntolabsMeterType, siteId: string, siteName: string, sourceId: string, address?: string | null }>, initialLocationIntegrationsState?: Array<{ __typename?: 'InitialEntolabsLocationIntegrationsStateData', rowIndex: number, customerLocation: { __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null, shortAddress?: string | null, longAddress?: string | null, zipCode?: string | null, buildings: Array<{ __typename?: 'LocationMetadata', name?: string | null, shortAddress?: string | null, longAddress?: string | null, nationalIdentifier?: string | null, zipCode?: string | null }>, integrations: Array<{ __typename?: 'LocationIntegration', assetId: string, type: IntegrationType, originId: string, startedAt?: any | null, endedAt?: any | null, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', id: number, type: string } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData', installationNumber: string } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData', propertyId: string } | { __typename?: 'IntegrationVitaniLocationIntegrationData', directoryId: number } | { __typename?: 'OriginIntegrationData' } }> }, meterLocations: Array<{ __typename?: 'EntolabsLocationData', entolabsOrganizationId: string, meterId: string, meterName: string, meterType: IntegrationEntolabsMeterType, siteId: string, siteName: string, sourceId: string, address?: string | null }> }> | null } };

export type GetOisMeterLocationsQueryVariables = Exact<{
  types?: InputMaybe<Array<IntegrationType> | IntegrationType>;
}>;


export type GetOisMeterLocationsQuery = { __typename?: 'Query', me: { __typename?: 'User', organization?: { __typename?: 'Organization', integrations: Array<{ __typename?: 'OrganizationIntegration', type: IntegrationType }>, getLocations?: Array<{ __typename?: 'Location', id: string, name?: string | null, externalId?: string | null, shortAddress?: string | null, longAddress?: string | null, buildings: Array<{ __typename?: 'LocationMetadata', name?: string | null, shortAddress?: string | null, longAddress?: string | null, nationalIdentifier?: string | null }>, integrations: Array<{ __typename?: 'LocationIntegration', assetId: string, type: IntegrationType, originId: string, startedAt?: any | null, endedAt?: any | null, data: { __typename?: 'IntegrationDexmaLocationIntegrationData' } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData' } | { __typename?: 'IntegrationOisLocationIntegrationData', bbr?: string | null } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData' } | { __typename?: 'IntegrationVitaniLocationIntegrationData' } | { __typename?: 'OriginIntegrationData' } }> }> | null } | null } };

export type GetElectralinkMeterLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetElectralinkMeterLocationsQuery = { __typename?: 'Query', locationsForElectralinkIntegration: { __typename?: 'LocationsForElectralinkIntegrationResponse', meterLocations: Array<{ __typename?: 'ElectralinkLocation', postCode: string, address: string, hashedMPAN: string, partialMPAN: string }>, initialLocationIntegrationsState: Array<{ __typename?: 'InitialElectralinkLocationIntegrationsState', rowIndex: number, customerLocation: { __typename?: 'Location', id: string, displayName?: string | null, externalId?: string | null, shortAddress?: string | null, longAddress?: string | null, zipCode?: string | null, buildings: Array<{ __typename?: 'LocationMetadata', name?: string | null, shortAddress?: string | null, longAddress?: string | null, nationalIdentifier?: string | null, zipCode?: string | null }>, integrations: Array<{ __typename?: 'LocationIntegration', assetId: string, type: IntegrationType, originId: string, startedAt?: any | null, endedAt?: any | null, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', id: number, type: string } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData', installationNumber: string } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData', propertyId: string } | { __typename?: 'IntegrationVitaniLocationIntegrationData', directoryId: number } | { __typename?: 'OriginIntegrationData' } }> }, meterLocations: Array<{ __typename?: 'ElectralinkLocation', postCode: string, address: string, hashedMPAN: string, partialMPAN: string }> }> } };

export type GetSoftvaerketMeterLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSoftvaerketMeterLocationsQuery = { __typename?: 'Query', locationsForSoftvaerket: { __typename?: 'LocationsForSoftvaerket', meterLocations: Array<{ __typename?: 'SoftvaerketMeter', id: string, address: string, identifier: string, supplierId?: string | null, supplierName?: string | null }>, initialLocationIntegrationsState: Array<{ __typename?: 'InitialState', rowIndex: number, customerLocation: { __typename?: 'Location', id: string, displayName?: string | null }, meterLocations: Array<{ __typename?: 'SoftvaerketMeter', id: string, address: string, identifier: string, supplierId?: string | null, supplierName?: string | null }> }> } };

export type GetEloverblikMeterLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEloverblikMeterLocationsQuery = { __typename?: 'Query', locationsForEloverblik: { __typename?: 'LocationsForEloverblik', meterLocations: Array<{ __typename?: 'EloverblikMeter', meteringPointId: string, meterNumber: string, address: string, typeOfMP: string, consumerStartDate: string, parentMeteringPointId?: string | null }>, initialLocationIntegrationsState: Array<{ __typename?: 'EloverblikInitialState', rowIndex: number, customerLocation: { __typename?: 'Location', id: string, displayName?: string | null }, meterLocations: Array<{ __typename?: 'EloverblikMeter', meteringPointId: string, meterNumber: string, address: string, typeOfMP: string, consumerStartDate: string, parentMeteringPointId?: string | null }> }> } };

export type AddOrganizationIntegrationWithDataMutationVariables = Exact<{
  integrationData: OrganizationIntegrationData;
}>;


export type AddOrganizationIntegrationWithDataMutation = { __typename?: 'Mutation', addOrganizationIntegrationWithData: { __typename?: 'OrganizationIntegration', id: string } };

export type AddOrganizationIntegrationMutationVariables = Exact<{
  input: CreateOneOrganizationIntegrationInput;
}>;


export type AddOrganizationIntegrationMutation = { __typename?: 'Mutation', createOneOrganizationIntegration: { __typename?: 'OrganizationIntegration', id: string } };

export type GetOrganizationIntegrationQueryVariables = Exact<{
  integrationType: SupportedIntegrationForOnboarding;
}>;


export type GetOrganizationIntegrationQuery = { __typename?: 'Query', getOrganizationIntegration?: { __typename?: 'SimpleOrganizationIntegrationDto', id: string } | null };

export type GetEntolabsOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEntolabsOrganizationsQuery = { __typename?: 'Query', entolabsOrganizations: Array<{ __typename?: 'EntolabsOrganization', id: number, name: string }> };

export type GetLocationIntegrationsQueryVariables = Exact<{
  type: IntegrationType;
}>;


export type GetLocationIntegrationsQuery = { __typename?: 'Query', getAssets: Array<{ __typename?: 'Location', id: string, displayName?: string | null, integrations: Array<{ __typename?: 'LocationIntegration', id: string, originId: string, startedAt?: any | null, endedAt?: any | null, data: { __typename?: 'IntegrationDexmaLocationIntegrationData' } | { __typename?: 'IntegrationElectralinkLocationIntegrationData', postCode: string, partialMpan: string, address: string } | { __typename?: 'IntegrationEloverblikAssetIntegrationData', address: string, meteringPointId: string } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData' } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData', address: string } | { __typename?: 'IntegrationTechemLocationIntegrationData' } | { __typename?: 'IntegrationVitaniLocationIntegrationData' } | { __typename?: 'OriginIntegrationData' } }> }> };

export type GetOrganizationIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationIntegrationsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', integrations: Array<{ __typename?: 'OrganizationIntegration', id: string, type: IntegrationType }> } | null } };

export type CreateOrganizationIntegrationMutationVariables = Exact<{
  type: IntegrationType;
  data?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CreateOrganizationIntegrationMutation = { __typename?: 'Mutation', createOneOrganizationIntegration: { __typename?: 'OrganizationIntegration', id: string } };

export type UpdateOrganizationIntegrationMutationVariables = Exact<{
  input: UpdateOneOrganizationIntegrationInput;
}>;


export type UpdateOrganizationIntegrationMutation = { __typename?: 'Mutation', updateOneOrganizationIntegration: { __typename?: 'OrganizationIntegration', id: string } };

export type GetEloverblikCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEloverblikCustomersQuery = { __typename?: 'Query', getEloverblikCustomers: Array<{ __typename?: 'EloverblikCustomer', customerCVR: string, customerName: string }> };

export type ActiveOrgIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveOrgIntegrationsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, name: string, integrations: Array<{ __typename?: 'OrganizationIntegration', id: string, type: IntegrationType }> } | null } };

export type CreateOrganizationIntegrationsMutationVariables = Exact<{
  createManyOrganizationIntegrations: CreateManyOrganizationIntegrationsInput;
}>;


export type CreateOrganizationIntegrationsMutation = { __typename?: 'Mutation', createManyOrganizationIntegrations: Array<{ __typename: 'OrganizationIntegration', id: string }> };

export type ReportFragmentFragment = { __typename?: 'Report', id: string, from: any, to: any, framework: ReportFramework, segmentName?: string | null, numberOfAssets: number, createdAt: any, note?: string | null, source: AssessmentDataType, createdBy: { __typename?: 'User', name?: string | null } };

export type GetSavedReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedReportsQuery = { __typename?: 'Query', getActiveReports: Array<{ __typename?: 'Report', id: string, from: any, to: any, framework: ReportFramework, segmentName?: string | null, numberOfAssets: number, createdAt: any, note?: string | null, source: AssessmentDataType, createdBy: { __typename?: 'User', name?: string | null } }> };

export type DeleteReportMutationVariables = Exact<{
  input: DeleteReportInput;
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport: { __typename?: 'Report', id: string } };

export type UpdateReportMutationVariables = Exact<{
  input: UpdateOneReportInput;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateOneReport: { __typename?: 'Report', id: string } };

export type CreateReportMutationVariables = Exact<{
  reportInput: CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Report', id: string, from: any, to: any, framework: ReportFramework, segmentName?: string | null, numberOfAssets: number, createdAt: any, note?: string | null, source: AssessmentDataType, createdBy: { __typename?: 'User', name?: string | null } } };

export type GetAssetRiskPreviewQueryVariables = Exact<{
  input: Array<AssetGroupFilterInput> | AssetGroupFilterInput;
  crremCategories: Array<CrremCategory> | CrremCategory;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  projectedFrom: Scalars['DateTime']['input'];
  projectedTo: Scalars['DateTime']['input'];
}>;


export type GetAssetRiskPreviewQuery = { __typename?: 'Query', getAssetGroupPreview: Array<{ __typename?: 'Location', id: string, externalId?: string | null, displayName?: string | null, constructionDate?: any | null, crremPropertyType?: string | null, ownedArea?: number | null, emissionSummaries: Array<{ __typename?: 'EmissionSummary', from: any, ownedEmission?: number | null, ownedEnergy?: number | null }>, projectedEmissionSummaries: Array<{ __typename?: 'ProjectedEmissionSummary', from: any, ownedEmission?: number | null, ownedEnergy?: number | null }> }>, getCrremPathways: Array<{ __typename?: 'CRREMPathway', crremCategory: CrremCategory, color: string, value: number, year: number, unit: string, version: string }> };

export type GetAssetEsgActionPlanQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAssetEsgActionPlanQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, zipCode?: string | null, city?: string | null, buildingArea?: number | null, dgnbCertification?: DgnbCertification | null, epcs: Array<{ __typename?: 'EpcAssessment', to: any, classification?: string | null }> } };

export type GetAssetPropertySizeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetPropertySizeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', buildingAreas?: Array<{ __typename?: 'MetadataBuildingArea', floorAreaType: FloorAreaType, area: { __typename?: 'MetadataBuildingAreaInterval', min: number, max: number } }> | null } | null } };

export type GetLegacyNextAssetBenchmarksQueryVariables = Exact<{
  bfe: Scalars['String']['input'];
}>;


export type GetLegacyNextAssetBenchmarksQuery = { __typename?: 'Query', getLegacyNextAssetBenchmarks?: Array<{ __typename?: 'InsightsAssetBenchmark', segment: string, numberOfBuildings: number, co2BenchmarkMethod1: number, bfe: string, benchmarkType: string, benchmarkId: string }> | null };

export type GetAssetIntensityQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type GetAssetIntensityQuery = { __typename?: 'Query', getIntensity?: { __typename?: 'InsightIntensity', to: string, from: string, value: number, unit: string, area: number, breakdown: Array<{ __typename?: 'InsightIntensityBreakdown', factors: Array<{ __typename?: 'InsightIntensityFactor', unit: string, to: string, supplierName?: string | null, source: string, note: string, id: string, from: string, factor: number }>, consumption: { __typename?: 'InsightIntensityConsumption', value: number, unit: string, type: string } }> } | null };

export type GetAssetIntensityChartDataQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
  categories: Array<CrremCategory> | CrremCategory;
}>;


export type GetAssetIntensityChartDataQuery = { __typename?: 'Query', getIntensityChartData: Array<{ __typename?: 'InsightIntensityChartData', year: number, energyIntensity?: number | null, emissionIntensity?: number | null, projectedEmissionIntensity?: number | null, projectedEnergyIntensity?: number | null }>, getCrremPathways: Array<{ __typename?: 'CRREMPathway', color: string, value: number, year: number, unit: string, version: string, crremCategory: CrremCategory }> };

export type GetLegacyNextAssetMaterialsLifespanQueryVariables = Exact<{
  bfe: Scalars['String']['input'];
}>;


export type GetLegacyNextAssetMaterialsLifespanQuery = { __typename?: 'Query', getLegacyNextAssetMaterialsLifespan?: { __typename?: 'InsightsAssetMaterialLifespan', bfe: string, roofCoverMaterial?: string | null, renovationYear: number, outerWallMaterial?: string | null, heatInstallation?: string | null, constructionYear: number, buildingId: string, outerWallMaterialLifetime: number } | null };

export type GetLegacyNextAssetOwnershipQueryVariables = Exact<{
  bfe: Scalars['String']['input'];
}>;


export type GetLegacyNextAssetOwnershipQuery = { __typename?: 'Query', getLegacyNextAssetOwnership?: { __typename?: 'InsightsAssetOwnership', bfe: string, ownerName: string, administratorName?: string | null } | null };

export type GetLegacyNextAssetSalesPriceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLegacyNextAssetSalesPriceQuery = { __typename?: 'Query', getLegacyNextAssetSalesPrice?: { __typename?: 'InsightsAssetSalesPrice', bfe: string, salesPrice: string, currency: string, salesDate?: string | null } | null };

export type GetLegacyNextAssetWaterSupplierQueryVariables = Exact<{
  bfe: Scalars['String']['input'];
}>;


export type GetLegacyNextAssetWaterSupplierQuery = { __typename?: 'Query', getLegacyNextAssetWaterSupplier?: { __typename?: 'InsightsAssetWaterSupplier', bfe: string, waterSupplier?: string | null } | null };

export type EpcSummariesQueryVariables = Exact<{
  bfes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EpcSummariesQuery = { __typename?: 'Query', getEpcSummaries: Array<{ __typename?: 'EpcSummary', bfe: string, identifier: string, classification?: string | null, street?: string | null, postalCodeAndCity?: string | null, allProposalClassification?: string | null, profitableProposalClassification?: string | null, proposals?: Array<{ __typename?: 'EpcProposal', title: string, category: string, renovationTime: string, profitability: string, investmentLifetime: string, investment: string, description: string, emissionSaving: number, energySaving: number, costSaving: number }> | null }> };

export type GetLegacyNextAssetHeatInstallationQueryVariables = Exact<{
  bfe: Scalars['String']['input'];
}>;


export type GetLegacyNextAssetHeatInstallationQuery = { __typename?: 'Query', getLegacyNextAssetHeatInstallation?: { __typename?: 'InsightsAssetHeatInstallation', bfe: string, heatInstallation?: string | null } | null };

export type BreakdownItemFragment = { __typename?: 'ConsumptionBreakdownItem', ownershipType: PropertyOwnershipType, vertical: AssessmentVertical, emission: number, from: any, to: any };

export type GetConsumptionChartDataQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
  bfe: Scalars['String']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetConsumptionChartDataQuery = { __typename?: 'Query', getConsumptionChartData: Array<{ __typename?: 'YearlyConsumptionChartData', year: string, emission: Array<{ __typename?: 'ConsumptionBreakdownItem', ownershipType: PropertyOwnershipType, vertical: AssessmentVertical, emission: number, from: any, to: any }>, energy: Array<{ __typename?: 'ConsumptionBreakdownItem', ownershipType: PropertyOwnershipType, vertical: AssessmentVertical, emission: number, from: any, to: any }>, projectedEmission: Array<{ __typename?: 'ConsumptionBreakdownItem', ownershipType: PropertyOwnershipType, vertical: AssessmentVertical, emission: number, from: any, to: any }>, projectedEnergy: Array<{ __typename?: 'ConsumptionBreakdownItem', ownershipType: PropertyOwnershipType, vertical: AssessmentVertical, emission: number, from: any, to: any }> }>, getLegacyNextAssetBenchmarks?: Array<{ __typename?: 'InsightsAssetBenchmark', segment: string, co2BenchmarkMethod1: number, kwhMethod1: number, benchmarkType: string, startTs: string }> | null };

export type InsightsPropertyTreeFragment = { __typename?: 'InsightsPropertyTree', id: string, area?: number | null, fullAddress: string, objectType: PropertyObjectType, propertyType?: PropertyType | null, crremPropertyType: CrremCategory, constructionYear: number, nationalPropertyType: string, latitude: number, longitude: number };

export type GetLegacyNextAssetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLegacyNextAssetQuery = { __typename?: 'Query', getLegacyNextAsset?: { __typename?: 'InsightsAsset', id: string, area?: number | null, name?: string | null, externalId: string, properties: Array<{ __typename?: 'InsightsPropertyTree', id: string, area?: number | null, fullAddress: string, objectType: PropertyObjectType, propertyType?: PropertyType | null, crremPropertyType: CrremCategory, constructionYear: number, nationalPropertyType: string, latitude: number, longitude: number, children: Array<{ __typename?: 'InsightsPropertyTree', id: string, area?: number | null, fullAddress: string, objectType: PropertyObjectType, propertyType?: PropertyType | null, crremPropertyType: CrremCategory, constructionYear: number, nationalPropertyType: string, latitude: number, longitude: number, children: Array<{ __typename?: 'InsightsPropertyTree', id: string, area?: number | null, fullAddress: string, objectType: PropertyObjectType, propertyType?: PropertyType | null, crremPropertyType: CrremCategory, constructionYear: number, nationalPropertyType: string, latitude: number, longitude: number, children: Array<{ __typename?: 'InsightsPropertyTree', id: string, area?: number | null, fullAddress: string, objectType: PropertyObjectType, propertyType?: PropertyType | null, crremPropertyType: CrremCategory, constructionYear: number, nationalPropertyType: string, latitude: number, longitude: number, children: Array<{ __typename?: 'InsightsPropertyTree', id: string, area?: number | null, fullAddress: string, objectType: PropertyObjectType, propertyType?: PropertyType | null, crremPropertyType: CrremCategory, constructionYear: number, nationalPropertyType: string, latitude: number, longitude: number }> }> }> }> }> } | null };

export type GetAssetRiskQueryVariables = Exact<{
  propertyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  crremCategories: Array<CrremCategory> | CrremCategory;
}>;


export type GetAssetRiskQuery = { __typename?: 'Query', getAssetRiskChartData: Array<{ __typename?: 'AssetRiskChartData', propertyId: string, summary: Array<{ __typename?: 'InsightIntensityChartData', emissionIntensity?: number | null, energyIntensity?: number | null, projectedEmissionIntensity?: number | null, projectedEnergyIntensity?: number | null, year: number }> }>, getCrremPathways: Array<{ __typename?: 'CRREMPathway', crremCategory: CrremCategory, color: string, value: number, year: number, unit: string, version: string, country: string, target: number }> };

export type GetLegacyNextAssetsQueryVariables = Exact<{
  searchFilters: SearchFiltersInput;
}>;


export type GetLegacyNextAssetsQuery = { __typename?: 'Query', getLegacyNextAssets: Array<{ __typename?: 'InsightsProperty', id: string, objectType: PropertyObjectType, longitude: number, latitude: number, area?: number | null, assetExternalId: string, fullAddress: string, assetId: string, crremPropertyType: CrremCategory, crremPropertyTypes: Array<CrremCategory>, constructionYear: number }> };

export type UpdateMeMutationVariables = Exact<{
  updateMeInput: UpdateUserInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'User', id: string, name?: string | null, email: string, phone?: string | null } };

export type AssetEpcDataFragment = { __typename?: 'Location', id: string, saleDate?: any | null, assessments: Array<{ __typename?: 'Assessment', id: string, to: any, from: any, vertical?: AssessmentVertical | null, unit?: EmissionUnit | null, areaData?: { __typename?: 'AssessmentArea', totalArea?: number | null } | null, consumptionData: { __typename?: 'AssessmentConsumption', totalConsumption: number }, assessmentMetadata: { __typename?: 'AssessmentMetadata', addresses?: Array<string> | null, nationalBuildingIds?: Array<string> | null }, emissionDataGrams?: { __typename?: 'AssessmentEmission', ownedEmission?: number | null } | null, origin?: { __typename?: 'AssessmentOrigin', id: string } | null, integration?: { __typename?: 'LocationIntegration', id: string, type: IntegrationType } | null, data?: { __typename?: 'IntegrationDexmaAssessmentData' } | { __typename?: 'IntegrationElectralinkAssessmentData' } | { __typename?: 'IntegrationEpcAssessmentData', epcIdentifier: string, classification: string, pdfLink: string, originalPdfLink: string } | { __typename?: 'IntegrationEpcUkAssessmentData', lmkKey: string, classification: string, assessmentLink?: string | null } | { __typename?: 'IntegrationHoforAssessmentData' } | { __typename?: 'IntegrationOISAssessmentData' } | { __typename?: 'IntegrationTechemAssessmentData' } | { __typename?: 'IntegrationVitaniAssessmentData' } | { __typename?: 'ManualAssessmentData' } | null }> };

export type GetDataOverviewEpcAssessmentsQueryVariables = Exact<{
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDataOverviewEpcAssessmentsQuery = { __typename?: 'Query', getAssets: Array<{ __typename?: 'Location', id: string, saleDate?: any | null, assessments: Array<{ __typename?: 'Assessment', id: string, to: any, from: any, vertical?: AssessmentVertical | null, unit?: EmissionUnit | null, areaData?: { __typename?: 'AssessmentArea', totalArea?: number | null } | null, consumptionData: { __typename?: 'AssessmentConsumption', totalConsumption: number }, assessmentMetadata: { __typename?: 'AssessmentMetadata', addresses?: Array<string> | null, nationalBuildingIds?: Array<string> | null }, emissionDataGrams?: { __typename?: 'AssessmentEmission', ownedEmission?: number | null } | null, origin?: { __typename?: 'AssessmentOrigin', id: string } | null, integration?: { __typename?: 'LocationIntegration', id: string, type: IntegrationType } | null, data?: { __typename?: 'IntegrationDexmaAssessmentData' } | { __typename?: 'IntegrationElectralinkAssessmentData' } | { __typename?: 'IntegrationEpcAssessmentData', epcIdentifier: string, classification: string, pdfLink: string, originalPdfLink: string } | { __typename?: 'IntegrationEpcUkAssessmentData', lmkKey: string, classification: string, assessmentLink?: string | null } | { __typename?: 'IntegrationHoforAssessmentData' } | { __typename?: 'IntegrationOISAssessmentData' } | { __typename?: 'IntegrationTechemAssessmentData' } | { __typename?: 'IntegrationVitaniAssessmentData' } | { __typename?: 'ManualAssessmentData' } | null }> }> };

export type GetAssetEpcDataQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAssetEpcDataQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, saleDate?: any | null, assessments: Array<{ __typename?: 'Assessment', id: string, to: any, from: any, vertical?: AssessmentVertical | null, unit?: EmissionUnit | null, areaData?: { __typename?: 'AssessmentArea', totalArea?: number | null } | null, consumptionData: { __typename?: 'AssessmentConsumption', totalConsumption: number }, assessmentMetadata: { __typename?: 'AssessmentMetadata', addresses?: Array<string> | null, nationalBuildingIds?: Array<string> | null }, emissionDataGrams?: { __typename?: 'AssessmentEmission', ownedEmission?: number | null } | null, origin?: { __typename?: 'AssessmentOrigin', id: string } | null, integration?: { __typename?: 'LocationIntegration', id: string, type: IntegrationType } | null, data?: { __typename?: 'IntegrationDexmaAssessmentData' } | { __typename?: 'IntegrationElectralinkAssessmentData' } | { __typename?: 'IntegrationEpcAssessmentData', epcIdentifier: string, classification: string, pdfLink: string, originalPdfLink: string } | { __typename?: 'IntegrationEpcUkAssessmentData', lmkKey: string, classification: string, assessmentLink?: string | null } | { __typename?: 'IntegrationHoforAssessmentData' } | { __typename?: 'IntegrationOISAssessmentData' } | { __typename?: 'IntegrationTechemAssessmentData' } | { __typename?: 'IntegrationVitaniAssessmentData' } | { __typename?: 'ManualAssessmentData' } | null }> } };

export type GetAssetIntegrationsQueryVariables = Exact<{
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAssetIntegrationsQuery = { __typename?: 'Query', getAssets: Array<{ __typename?: 'Location', displayName?: string | null, integrations: Array<{ __typename?: 'LocationIntegration', id: string, to?: any | null, from?: any | null, type: IntegrationType, originId: string, consumptionTypes: Array<ConsumptionType>, data: { __typename?: 'IntegrationDexmaLocationIntegrationData', id: number, type: string } | { __typename?: 'IntegrationElectralinkLocationIntegrationData' } | { __typename?: 'IntegrationEloverblikAssetIntegrationData' } | { __typename?: 'IntegrationEntolabsLocationIntegrationData' } | { __typename?: 'IntegrationEpcDkAssetIntegrationData' } | { __typename?: 'IntegrationEpcLocationIntegrationData' } | { __typename?: 'IntegrationEpcUkLocationIntegrationData' } | { __typename?: 'IntegrationHoforLocationIntegrationData' } | { __typename?: 'IntegrationOisLocationIntegrationData' } | { __typename?: 'IntegrationSoftvaerketAssetIntegrationData' } | { __typename?: 'IntegrationTechemLocationIntegrationData' } | { __typename?: 'IntegrationVitaniLocationIntegrationData' } | { __typename?: 'OriginIntegrationData' } }> }> };

export type DeleteAssessmentMutationVariables = Exact<{
  input: DeleteAssessmentInput;
}>;


export type DeleteAssessmentMutation = { __typename?: 'Mutation', deleteAssessment: { __typename?: 'Assessment', id: string } };

export type GetLegacyBenchmarksByAssetIdQueryVariables = Exact<{
  assetId?: InputMaybe<Scalars['ID']['input']>;
  valueType?: InputMaybe<LegacyBenchmarkValueType>;
}>;


export type GetLegacyBenchmarksByAssetIdQuery = { __typename?: 'Query', getLegacyBenchmarksByAssetId: Array<{ __typename?: 'LegacyBenchmark', id: string, internalIdentifier: string, benchmarkType: LegacyBenchmarkType, segment: string, countryCode?: string | null, numberOfBuildings: number, updatedAt: any, values: Array<{ __typename?: 'LegacyBenchmarkValue', id: string, from: any, to: any, category: AssessmentCategory, value: number, unit: BenchmarkValueUnit, type: LegacyBenchmarkValueType }> }> };

export type GetOrganizationBenchmarksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationBenchmarksQuery = { __typename?: 'Query', benchmarks: { __typename?: 'BenchmarkConnection', edges: Array<{ __typename?: 'BenchmarkEdge', node: { __typename?: 'Benchmark', id: string, type: BenchmarkType, countryCode?: string | null, emissionPerArea: { __typename?: 'BenchmarkDetails', bestEffort: { __typename?: 'BenchmarkDataDetails', benchmark?: number | null }, epc: { __typename?: 'BenchmarkDataDetails', benchmark?: number | null }, meter: { __typename?: 'BenchmarkDataDetails', benchmark?: number | null } } } }> } };

export type GetLegacyBenchmarksQueryVariables = Exact<{
  assetGroupId?: InputMaybe<Scalars['ID']['input']>;
  valueType?: InputMaybe<LegacyBenchmarkValueType>;
}>;


export type GetLegacyBenchmarksQuery = { __typename?: 'Query', getLegacyBenchmarks: Array<{ __typename?: 'LegacyBenchmark', id: string, internalIdentifier: string, benchmarkType: LegacyBenchmarkType, segment: string, countryCode?: string | null, numberOfBuildings: number, updatedAt: any, values: Array<{ __typename?: 'LegacyBenchmarkValue', id: string, from: any, to: any, category: AssessmentCategory, value: number, unit: BenchmarkValueUnit, type: LegacyBenchmarkValueType }> }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, name?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, reportingYear?: number | null, baselineYear?: number | null, allLocationsCount: number } | null } };

export const DataQualityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DataQuality"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataQuality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"highQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mediumQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}}]}}]} as unknown as DocumentNode<DataQualityFragment, unknown>;
export const AssetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackOwnedArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Month"}}]},{"kind":"Field","name":{"kind":"Name","value":"emissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Month"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"sourceTypes"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipDataQuality"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataQuality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkPerformances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"benchmarkId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benchmarkId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"between"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lower"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"upper"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipPerformance"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"epcs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromYear"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipClassifications"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classification"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DataQuality"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataQuality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"highQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mediumQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}}]}}]} as unknown as DocumentNode<AssetFragment, unknown>;
export const AssetGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assetsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AssetGroupFragment, unknown>;
export const ChangeLogFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeLogFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"eventPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"oldValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ChangeLogFragmentFragment, unknown>;
export const ChangeLogLabelsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeLogLabels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ChangeLogLabelsFragment, unknown>;
export const OrgEmissionSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgEmissionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"assetCount"}},{"kind":"Field","name":{"kind":"Name","value":"avgEnergyIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergyForArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmissionForArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}}]}}]} as unknown as DocumentNode<OrgEmissionSummaryFragment, unknown>;
export const OrgProjectedEmissionSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgProjectedEmissionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectedEmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergyForArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmissionForArea"}},{"kind":"Field","name":{"kind":"Name","value":"avgEnergyIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"energyBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"emissionBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}}]}}]} as unknown as DocumentNode<OrgProjectedEmissionSummaryFragment, unknown>;
export const BreakdownFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Breakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energyBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"emissionBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"energyForAreaBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"emissionForAreaBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"avgEnergyIntensityBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensityBreakdown"}}]}}]} as unknown as DocumentNode<BreakdownFragment, unknown>;
export const PerformanceLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PerformanceLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"assetAlerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"EPC_EXPIRED_IN_CURRENT_YEAR"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkPerformances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"benchmarkId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benchmarkId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkType"}},{"kind":"Field","name":{"kind":"Name","value":"performance"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}}]}}]} as unknown as DocumentNode<PerformanceLocationFragment, unknown>;
export const DashboardSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"assetCount"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"emissionBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"energyBreakdown"}}]}}]} as unknown as DocumentNode<DashboardSummaryFragment, unknown>;
export const DashboardProjectedSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardProjectedSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectedEmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"assetCount"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"avgEnergyIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensity"}}]}}]} as unknown as DocumentNode<DashboardProjectedSummaryFragment, unknown>;
export const ReportGhgSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportGHGSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportGHGSummaryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"baselineYearUnit"}},{"kind":"Field","name":{"kind":"Name","value":"baselineYearValue"}}]}}]} as unknown as DocumentNode<ReportGhgSummaryFragment, unknown>;
export const ReportEsgSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportESGSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportESGSummaryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]} as unknown as DocumentNode<ReportEsgSummaryFragment, unknown>;
export const ReportCrremSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportCRREMSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportCRREMSummaryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"inclusion"}},{"kind":"Field","name":{"kind":"Name","value":"assetName"}},{"kind":"Field","name":{"kind":"Name","value":"reportingYear"}},{"kind":"Field","name":{"kind":"Name","value":"buildingPercentageOwnership"}},{"kind":"Field","name":{"kind":"Name","value":"startReportingPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"monthsReportingPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"legalOwner"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"crremPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"buildingArea"}},{"kind":"Field","name":{"kind":"Name","value":"buildingDistrictCoolingChilledWaterUsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingDistrictCoolingChilledWaterDataCoverageM2"}},{"kind":"Field","name":{"kind":"Name","value":"buildingGridElectricityUsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingGridElectricityDataCoverageM2"}},{"kind":"Field","name":{"kind":"Name","value":"buildingNaturalGasUsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingNaturalGasDataCoverageM2"}},{"kind":"Field","name":{"kind":"Name","value":"buildingDistrictHeatingSteamUsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingDistrictHeatingSteamDataCoverageM2"}},{"kind":"Field","name":{"kind":"Name","value":"onSiteRenewableElectricityGeneratedAndConsumedOnSite"}},{"kind":"Field","name":{"kind":"Name","value":"buildingOtherEnergyConsumptionType1Type"}},{"kind":"Field","name":{"kind":"Name","value":"buildingOtherEnergyConsumptionType1UsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingOtherEnergyConsumptionType1DataCoverageM2"}}]}}]} as unknown as DocumentNode<ReportCrremSummaryFragment, unknown>;
export const AutomaticSourceAllocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticSourceAllocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetIntegrationAllocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"propertyId"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}}]} as unknown as DocumentNode<AutomaticSourceAllocationFragment, unknown>;
export const AutomaticSourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationIntegration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"allocationNote"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"allocations"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipAllocation"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutomaticSourceAllocation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticSourceAllocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetIntegrationAllocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"propertyId"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}}]} as unknown as DocumentNode<AutomaticSourceFragment, unknown>;
export const PropertyInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Property"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]} as unknown as DocumentNode<PropertyInfoFragmentFragment, unknown>;
export const AssetIntegrationAllocationItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetIntegrationAllocationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetIntegrationAllocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}}]} as unknown as DocumentNode<AssetIntegrationAllocationItemFragment, unknown>;
export const AssetCoverageAssessmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetCoverageAssessment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"bestEffortPriority"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataGrams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumptionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedConsumption"}}]}}]}}]} as unknown as DocumentNode<AssetCoverageAssessmentFragment, unknown>;
export const PropertyAllocationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAllocationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Property"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionTypes"}}]}}]}}]}}]} as unknown as DocumentNode<PropertyAllocationFragmentFragment, unknown>;
export const AssetPropertyTreeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPropertyTreeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Property"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAllocationFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAllocationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Property"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionTypes"}}]}}]}}]}}]} as unknown as DocumentNode<AssetPropertyTreeFragmentFragment, unknown>;
export const OverviewAssessmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OverviewAssessment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipAllocation"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataGrams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumptionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedConsumption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessmentType"}}]}}]}}]} as unknown as DocumentNode<OverviewAssessmentFragment, unknown>;
export const AssetAlertFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAlert"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assetAlerts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EpcExpiresSoonAlertData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epcExpiryDates"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MissingMeterDataAlertData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lastReading"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssetAlertFragment, unknown>;
export const DexmaMeterLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DexmaMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DexmaLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activity"}},{"kind":"Field","name":{"kind":"Name","value":"reference_devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DexmaMeterLocationFragment, unknown>;
export const TechemMeterLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechemMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechemLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_number"}}]}}]} as unknown as DocumentNode<TechemMeterLocationFragment, unknown>;
export const VitaniMeterLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaniMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VitaniLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"DirectoryID"}},{"kind":"Field","name":{"kind":"Name","value":"BuildingID"}}]}}]} as unknown as DocumentNode<VitaniMeterLocationFragment, unknown>;
export const HoforMeterLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HoforMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HoforLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationNumber"}}]}}]} as unknown as DocumentNode<HoforMeterLocationFragment, unknown>;
export const EntolabsMeterLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntolabsMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntolabsLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entolabsOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"meterId"}},{"kind":"Field","name":{"kind":"Name","value":"meterName"}},{"kind":"Field","name":{"kind":"Name","value":"meterType"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"siteName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]} as unknown as DocumentNode<EntolabsMeterLocationFragment, unknown>;
export const ElectralinkMeterLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ElectralinkMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ElectralinkLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"hashedMPAN"}},{"kind":"Field","name":{"kind":"Name","value":"partialMPAN"}}]}}]} as unknown as DocumentNode<ElectralinkMeterLocationFragment, unknown>;
export const SoftvaerketMeterLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SoftvaerketMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SoftvaerketMeter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}}]}}]} as unknown as DocumentNode<SoftvaerketMeterLocationFragment, unknown>;
export const EloverblikMeterLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EloverblikMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EloverblikMeter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meteringPointId"}},{"kind":"Field","name":{"kind":"Name","value":"meterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"meterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"typeOfMP"}},{"kind":"Field","name":{"kind":"Name","value":"consumerStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"parentMeteringPointId"}}]}}]} as unknown as DocumentNode<EloverblikMeterLocationFragment, unknown>;
export const CustomerLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"nationalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationTechemLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationVitaniLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationHoforLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomerLocationFragment, unknown>;
export const ReportFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"framework"}},{"kind":"Field","name":{"kind":"Name","value":"segmentName"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAssets"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ReportFragmentFragment, unknown>;
export const BreakdownItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreakdownItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsumptionBreakdownItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"emission"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]} as unknown as DocumentNode<BreakdownItemFragment, unknown>;
export const InsightsPropertyTreeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InsightsPropertyTree"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InsightsPropertyTree"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"crremPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"constructionYear"}},{"kind":"Field","name":{"kind":"Name","value":"nationalPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]} as unknown as DocumentNode<InsightsPropertyTreeFragment, unknown>;
export const AssetEpcDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetEPCData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"saleDate"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ignoreProxy"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"EnumValue","value":"ESTIMATE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"areaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalArea"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumptionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalConsumption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addresses"}},{"kind":"Field","name":{"kind":"Name","value":"nationalBuildingIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataGrams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcAssessmentData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epcIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"originalPdfLink"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcUkAssessmentData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lmkKey"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssetEpcDataFragment, unknown>;
export const GetAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paging"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CursorPaging"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationSort"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentDataType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benchmarkId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipPerformance"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipDataQuality"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipClassifications"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paging"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paging"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorting"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"sorting"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Asset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DataQuality"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataQuality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"highQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mediumQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackOwnedArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Month"}}]},{"kind":"Field","name":{"kind":"Name","value":"emissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Month"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"sourceTypes"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipDataQuality"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataQuality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkPerformances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"benchmarkId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benchmarkId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"between"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lower"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"upper"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipPerformance"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"epcs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromYear"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipClassifications"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classification"}}]}}]}}]} as unknown as DocumentNode<GetAssetsQuery, GetAssetsQueryVariables>;
export const GetAllAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentDataType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benchmarkId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipPerformance"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipDataQuality"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipClassifications"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Asset"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DataQuality"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataQuality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"highQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mediumQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Asset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackOwnedArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Month"}}]},{"kind":"Field","name":{"kind":"Name","value":"emissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Month"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"sourceTypes"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipDataQuality"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataQuality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkPerformances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"benchmarkId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benchmarkId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"between"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lower"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromLower"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"upper"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUpper"}}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipPerformance"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"epcs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromYear"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipClassifications"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classification"}}]}}]}}]} as unknown as DocumentNode<GetAllAssetsQuery, GetAllAssetsQueryVariables>;
export const GetAssetsGroupCitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetsGroupCities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingCities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetsGroupCitiesQuery, GetAssetsGroupCitiesQueryVariables>;
export const GetAssetGroupLegalOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetGroupLegalOwners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legalOwners"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetGroupLegalOwnersQuery, GetAssetGroupLegalOwnersQueryVariables>;
export const GetAssetsGroupLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetsGroupLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetsGroupLocationsQuery, GetAssetsGroupLocationsQueryVariables>;
export const GetAssetGroupNationalPropertyTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetGroupNationalPropertyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nationalPropertyTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetGroupNationalPropertyTypeQuery, GetAssetGroupNationalPropertyTypeQueryVariables>;
export const GetAssetsGroupPropertySizeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetsGroupPropertySize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"floorAreaType"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetsGroupPropertySizeQuery, GetAssetsGroupPropertySizeQueryVariables>;
export const GetAssetGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paging"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetGroup"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assetsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetGroupsQuery, GetAssetGroupsQueryVariables>;
export const DeleteAssetGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssetGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneAssetGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAssetGroupMutation, DeleteAssetGroupMutationVariables>;
export const CreateAssetGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssetGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneAssetGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneAssetGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assetsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAssetGroupMutation, CreateAssetGroupMutationVariables>;
export const UpdateAssetGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOneAssetGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneAssetGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetGroupMutation, UpdateAssetGroupMutationVariables>;
export const GetAssetGroupsPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetGroupsPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGroupFilterInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssetGroupPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}}]}}]} as unknown as DocumentNode<GetAssetGroupsPreviewQuery, GetAssetGroupsPreviewQueryVariables>;
export const GetAssetGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetGroupQuery, GetAssetGroupQueryVariables>;
export const GetChangeLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChangeLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recordId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeLogEventType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChangeLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recordId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeLogFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeLogLabels"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeLogFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"eventPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"oldValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeLogLabels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetChangeLogsQuery, GetChangeLogsQueryVariables>;
export const UpdateOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOneOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baselineYear"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const GetForecastAssessmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetForecastAssessments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectedFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectedTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentDataType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"targetSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"targetYear"}},{"kind":"Field","name":{"kind":"Name","value":"reduction"}},{"kind":"Field","name":{"kind":"Name","value":"pathwayName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Year"}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectedEmissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectedFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectedTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Year"}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetEmissionSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pathways"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetForecastAssessmentsQuery, GetForecastAssessmentsQueryVariables>;
export const GetDataQualityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDataQuality"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentDataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentDataType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentAggregation"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataQuality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentDataType"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DataQuality"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DataQuality"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataQuality"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"highQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mediumQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentDays"}},{"kind":"Field","name":{"kind":"Name","value":"priorityDistribution"}}]}}]}}]} as unknown as DocumentNode<GetDataQualityQuery, GetDataQualityQueryVariables>;
export const GetOrgEmissionSummariesForYearlyBreakdownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrgEmissionSummariesForYearlyBreakdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentAggregation"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentDataType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}]},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgEmissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgEmissionSummary"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Breakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgProjectedEmissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgProjectedEmissionSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgEmissionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"assetCount"}},{"kind":"Field","name":{"kind":"Name","value":"avgEnergyIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergyForArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmissionForArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Breakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energyBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"emissionBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"energyForAreaBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"emissionForAreaBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"avgEnergyIntensityBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensityBreakdown"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgProjectedEmissionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectedEmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergyForArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmissionForArea"}},{"kind":"Field","name":{"kind":"Name","value":"avgEnergyIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"energyBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"emissionBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}}]}}]} as unknown as DocumentNode<GetOrgEmissionSummariesForYearlyBreakdownQuery, GetOrgEmissionSummariesForYearlyBreakdownQueryVariables>;
export const OutlierAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OutlierAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationSort"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentDataType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lower"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upper"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paging"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorting"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"sorting"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"emissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lower"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upper"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Month"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OutlierAssetsQuery, OutlierAssetsQueryVariables>;
export const GetYearlyPerformanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetYearlyPerformance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentDataType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benchmarkId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PerformanceLocation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PerformanceLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"assetAlerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"EPC_EXPIRED_IN_CURRENT_YEAR"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkPerformances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"benchmarkId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benchmarkId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkType"}},{"kind":"Field","name":{"kind":"Name","value":"performance"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}}]}}]} as unknown as DocumentNode<GetYearlyPerformanceQuery, GetYearlyPerformanceQueryVariables>;
export const GetPortfolioOverviewEmissionSummariesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortfolioOverviewEmissionSummaries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentDataType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgEmissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Year"}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardSummary"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Breakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgProjectedEmissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Year"}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardProjectedSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"assetCount"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"emissionBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"energyBreakdown"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Breakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energyBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"emissionBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"energyForAreaBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"emissionForAreaBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"avgEnergyIntensityBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensityBreakdown"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardProjectedSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectedEmissionSummaryView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"assetCount"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"avgEnergyIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"avgEmissionIntensity"}}]}}]} as unknown as DocumentNode<GetPortfolioOverviewEmissionSummariesQuery, GetPortfolioOverviewEmissionSummariesQueryVariables>;
export const ReportEnergyConversionFactorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportEnergyConversionFactor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportQuery"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportEnergyConversionFactorHeaders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"header"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getReportEnergyConversionFactor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"}},{"kind":"Field","name":{"kind":"Name","value":"ghgCategory"}},{"kind":"Field","name":{"kind":"Name","value":"totalEnergyShare"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionFactor"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionFactorUnit"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionType"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"coveragePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDownloadLink"}},{"kind":"Field","name":{"kind":"Name","value":"externalSourceLink"}}]}}]}}]} as unknown as DocumentNode<ReportEnergyConversionFactorQuery, ReportEnergyConversionFactorQueryVariables>;
export const ReportEmissionFactorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportEmissionFactor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportQuery"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportEmissionFactorHeaders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"header"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getReportEmissionFactor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"}},{"kind":"Field","name":{"kind":"Name","value":"ghgCategory"}},{"kind":"Field","name":{"kind":"Name","value":"totalEmissionShare"}},{"kind":"Field","name":{"kind":"Name","value":"emissionFactor"}},{"kind":"Field","name":{"kind":"Name","value":"emissionFactorUnit"}},{"kind":"Field","name":{"kind":"Name","value":"emissionFactorSourceNote"}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataSource"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionType"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"coveragePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"sourceDownloadLink"}},{"kind":"Field","name":{"kind":"Name","value":"externalSourceLink"}}]}}]}}]} as unknown as DocumentNode<ReportEmissionFactorQuery, ReportEmissionFactorQueryVariables>;
export const ReportSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportQuery"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportSummaryHeader"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"columnStyle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fill"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getReportSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportGHGSummaryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportGHGSummary"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportESGSummaryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportESGSummary"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportCRREMSummaryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportCRREMSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportGHGSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportGHGSummaryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"baselineYearUnit"}},{"kind":"Field","name":{"kind":"Name","value":"baselineYearValue"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportESGSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportESGSummaryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportCRREMSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportCRREMSummaryItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"inclusion"}},{"kind":"Field","name":{"kind":"Name","value":"assetName"}},{"kind":"Field","name":{"kind":"Name","value":"reportingYear"}},{"kind":"Field","name":{"kind":"Name","value":"buildingPercentageOwnership"}},{"kind":"Field","name":{"kind":"Name","value":"startReportingPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"monthsReportingPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"legalOwner"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"crremPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"buildingArea"}},{"kind":"Field","name":{"kind":"Name","value":"buildingDistrictCoolingChilledWaterUsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingDistrictCoolingChilledWaterDataCoverageM2"}},{"kind":"Field","name":{"kind":"Name","value":"buildingGridElectricityUsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingGridElectricityDataCoverageM2"}},{"kind":"Field","name":{"kind":"Name","value":"buildingNaturalGasUsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingNaturalGasDataCoverageM2"}},{"kind":"Field","name":{"kind":"Name","value":"buildingDistrictHeatingSteamUsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingDistrictHeatingSteamDataCoverageM2"}},{"kind":"Field","name":{"kind":"Name","value":"onSiteRenewableElectricityGeneratedAndConsumedOnSite"}},{"kind":"Field","name":{"kind":"Name","value":"buildingOtherEnergyConsumptionType1Type"}},{"kind":"Field","name":{"kind":"Name","value":"buildingOtherEnergyConsumptionType1UsageKWh"}},{"kind":"Field","name":{"kind":"Name","value":"buildingOtherEnergyConsumptionType1DataCoverageM2"}}]}}]} as unknown as DocumentNode<ReportSummaryQuery, ReportSummaryQueryVariables>;
export const ReportInventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportQuery"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReportInventoryHeaders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"header"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getReportInventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"}},{"kind":"Field","name":{"kind":"Name","value":"assetArea"}},{"kind":"Field","name":{"kind":"Name","value":"assetAreaUnit"}},{"kind":"Field","name":{"kind":"Name","value":"assetConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"assetConsumptionUnit"}},{"kind":"Field","name":{"kind":"Name","value":"assetEmission"}},{"kind":"Field","name":{"kind":"Name","value":"assetEmissionUnit"}},{"kind":"Field","name":{"kind":"Name","value":"assetPercentageOwnership"}},{"kind":"Field","name":{"kind":"Name","value":"buildingArea"}},{"kind":"Field","name":{"kind":"Name","value":"buildingAreaUnit"}},{"kind":"Field","name":{"kind":"Name","value":"buildingConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"buildingConsumptionUnit"}},{"kind":"Field","name":{"kind":"Name","value":"buildingEmission"}},{"kind":"Field","name":{"kind":"Name","value":"buildingEmissionUnit"}},{"kind":"Field","name":{"kind":"Name","value":"buildingPercentageOwnership"}},{"kind":"Field","name":{"kind":"Name","value":"ghgCategory"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionDataSource"}},{"kind":"Field","name":{"kind":"Name","value":"dataArea"}},{"kind":"Field","name":{"kind":"Name","value":"dataAreaUnit"}},{"kind":"Field","name":{"kind":"Name","value":"dataGap"}},{"kind":"Field","name":{"kind":"Name","value":"dataPercentageOwnership"}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataSource"}},{"kind":"Field","name":{"kind":"Name","value":"emissionFactor"}},{"kind":"Field","name":{"kind":"Name","value":"emissionFactorUnit"}},{"kind":"Field","name":{"kind":"Name","value":"emissionSourceNote"}},{"kind":"Field","name":{"kind":"Name","value":"epcLink"}},{"kind":"Field","name":{"kind":"Name","value":"epcProxy"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"ghgCategory"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"legalOwner"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"locationName"}},{"kind":"Field","name":{"kind":"Name","value":"locationOwnership"}},{"kind":"Field","name":{"kind":"Name","value":"management"}},{"kind":"Field","name":{"kind":"Name","value":"nationalBuildingIds"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownedAreaUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ownedConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"ownedConsumptionUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmissionUnit"}},{"kind":"Field","name":{"kind":"Name","value":"partialOwnershipPercentDistribution"}},{"kind":"Field","name":{"kind":"Name","value":"percentDistribution"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"totalArea"}},{"kind":"Field","name":{"kind":"Name","value":"totalAreaUnit"}},{"kind":"Field","name":{"kind":"Name","value":"totalEmission"}},{"kind":"Field","name":{"kind":"Name","value":"totalEmissionUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"assetEnergyConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergyConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionFactor"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionFactorUnit"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionSource"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionSourceNote"}}]}}]}}]} as unknown as DocumentNode<ReportInventoryQuery, ReportInventoryQueryVariables>;
export const CreateTargetSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTargetSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneTargetSettingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTargetSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTargetSettingMutation, CreateTargetSettingMutationVariables>;
export const UpdateTargetSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTargetSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOneTargetSettingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTargetSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateTargetSettingMutation, UpdateTargetSettingMutationVariables>;
export const DeleteTargetSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTargetSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOneTargetSettingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTargetSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTargetSettingMutation, DeleteTargetSettingMutationVariables>;
export const GetUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const GetPropertyTreeForAllocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyTreeForAllocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssetPropertyTree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyInfoFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyInfoFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyInfoFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyInfoFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyInfoFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyInfoFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyInfoFragment"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Property"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]} as unknown as DocumentNode<GetPropertyTreeForAllocationQuery, GetPropertyTreeForAllocationQueryVariables>;
export const GetAllAssetIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllAssetIntegrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationIntegrationFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paging"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CursorPaging"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationIntegrationSort"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipAllocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"paging"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paging"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorting"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"sorting"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutomaticSource"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticSourceAllocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetIntegrationAllocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"propertyId"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationIntegration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"allocationNote"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"allocations"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipAllocation"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutomaticSourceAllocation"}}]}}]}}]} as unknown as DocumentNode<GetAllAssetIntegrationsQuery, GetAllAssetIntegrationsQueryVariables>;
export const GetAllAssetAutomaticSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllAssetAutomaticSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipAllocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutomaticSource"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticSourceAllocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetIntegrationAllocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"propertyId"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationIntegration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"allocationNote"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"allocations"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipAllocation"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutomaticSourceAllocation"}}]}}]}}]} as unknown as DocumentNode<GetAllAssetAutomaticSourcesQuery, GetAllAssetAutomaticSourcesQueryVariables>;
export const GetAssetAutomaticSourcesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetAutomaticSourcesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetAssetAutomaticSourcesCountQuery, GetAssetAutomaticSourcesCountQueryVariables>;
export const GetAssetAutomaticSourcesOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetAutomaticSourcesOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationTypes"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionTypes"}}]}}]}}]} as unknown as DocumentNode<GetAssetAutomaticSourcesOptionsQuery, GetAssetAutomaticSourcesOptionsQueryVariables>;
export const UpdateAssetIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssetIntegrationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneLocationIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"allocationNote"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetIntegrationMutation, UpdateAssetIntegrationMutationVariables>;
export const GetAssetIntegrationAllocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetIntegrationAllocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetIntegrationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetIntegrationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetIntegrationAllocationItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetIntegrationAllocationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetIntegrationAllocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}}]} as unknown as DocumentNode<GetAssetIntegrationAllocationsQuery, GetAssetIntegrationAllocationsQueryVariables>;
export const UpdateAssetIntegrationAllocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetIntegrationAllocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integrationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetIntegrationAllocationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssetIntegrationAllocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integrationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allocations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocations"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssetIntegrationAllocationMutation, UpdateAssetIntegrationAllocationMutationVariables>;
export const CreateManualConsumptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateManualConsumptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateManualConsumptionInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManualConsumptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateManualConsumptionsMutation, CreateManualConsumptionsMutationVariables>;
export const UpdateManualConsumptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManualConsumption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManualConsumptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManualConsumption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateManualConsumptionMutation, UpdateManualConsumptionMutationVariables>;
export const GetAssetManualSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetManualSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"manualAssessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionType"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManualAssessmentData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcAssessmentData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcUkAssessmentData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lmkKey"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetManualSourcesQuery, GetAssetManualSourcesQueryVariables>;
export const GetAssetDataCoverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetDataCoverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Month"}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"maxHighPriority"}},{"kind":"Field","name":{"kind":"Name","value":"maxMediumPriority"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetCoverageAssessment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetCoverageAssessment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"bestEffortPriority"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataGrams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumptionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedConsumption"}}]}}]}}]} as unknown as DocumentNode<GetAssetDataCoverageQuery, GetAssetDataCoverageQueryVariables>;
export const GetAllAssetDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllAssetDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeLogEventType"}},"defaultValue":{"kind":"EnumValue","value":"ASSET_UPDATED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeLogsFieldsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recordId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}}}]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionDate"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"propertyCount"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"saleDate"}},{"kind":"Field","name":{"kind":"Name","value":"management"}},{"kind":"Field","name":{"kind":"Name","value":"legalOwner"}},{"kind":"Field","name":{"kind":"Name","value":"buildingArea"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}}]}}]}}]} as unknown as DocumentNode<GetAllAssetDetailsQuery, GetAllAssetDetailsQueryVariables>;
export const GetAssetPropertyAllocationCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetPropertyAllocationCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allocations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"percentage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"IntValue","value":"100"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetAssetPropertyAllocationCountQuery, GetAssetPropertyAllocationCountQueryVariables>;
export const GetAssetPropertyTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetPropertyTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssetPropertyTree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPropertyTreeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPropertyTreeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPropertyTreeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPropertyTreeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPropertyTreeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPropertyTreeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPropertyTreeFragment"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAllocationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Property"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionTypes"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPropertyTreeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Property"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAllocationFragment"}}]}}]} as unknown as DocumentNode<GetAssetPropertyTreeQuery, GetAssetPropertyTreeQueryVariables>;
export const AddAssetPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddAssetProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddAssetPropertyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addAssetProperty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AddAssetPropertyMutation, AddAssetPropertyMutationVariables>;
export const UpdateAssetPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOnePropertyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneProperty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetPropertyMutation, UpdateAssetPropertyMutationVariables>;
export const DeleteAssetPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssetProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAssetPropertyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAssetProperty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteAssetPropertyMutation, DeleteAssetPropertyMutationVariables>;
export const GetPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"generalPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"crremPropertyCategory"}},{"kind":"Field","name":{"kind":"Name","value":"nationalPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"nationalPropertyTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"saleDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"constructionDate"}},{"kind":"Field","name":{"kind":"Name","value":"buildingArea"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyQuery, GetPropertyQueryVariables>;
export const UpdateAssetMasterDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssetMasterData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOneLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"buildingArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"saleDate"}},{"kind":"Field","name":{"kind":"Name","value":"legalOwner"}},{"kind":"Field","name":{"kind":"Name","value":"management"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetMasterDataMutation, UpdateAssetMasterDataMutationVariables>;
export const GetAssetEmissionSummaryInventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetEmissionSummaryInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentAggregation"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentDataType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportLanguage"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"simpleAssetInventoryHeaders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"header"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emissionSummaryInventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nationalBuildingIds"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"}},{"kind":"Field","name":{"kind":"Name","value":"assetArea"}},{"kind":"Field","name":{"kind":"Name","value":"assetAreaUnit"}},{"kind":"Field","name":{"kind":"Name","value":"assetPercentageOwnership"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"activity"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionType"}},{"kind":"Field","name":{"kind":"Name","value":"assetConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"ownedConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionUnit"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionDataSource"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"assetEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"emissionUnit"}},{"kind":"Field","name":{"kind":"Name","value":"emissionFactor"}},{"kind":"Field","name":{"kind":"Name","value":"emissionFactorUnit"}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataSource"}},{"kind":"Field","name":{"kind":"Name","value":"emissionSourceNote"}},{"kind":"Field","name":{"kind":"Name","value":"assetEnergyConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergyConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionFactor"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionFactorUnit"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionSource"}},{"kind":"Field","name":{"kind":"Name","value":"energyConversionSourceNote"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetEmissionSummaryInventoryQuery, GetAssetEmissionSummaryInventoryQueryVariables>;
export const GetAllAssessmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllAssessments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ignoreProxy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verticals"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentVertical"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentAggregation"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentQueryFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipAllocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"saleDate"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}}},{"kind":"Argument","name":{"kind":"Name","value":"verticals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verticals"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"ignoreProxy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ignoreProxy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OverviewAssessment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectedAssessments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregation"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataGrams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OverviewAssessment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipAllocation"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataGrams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumptionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedConsumption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessmentType"}}]}}]}}]} as unknown as DocumentNode<GetAllAssessmentsQuery, GetAllAssessmentsQueryVariables>;
export const GetAssetAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"assetAlerts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetAlert"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetAlert"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assetAlerts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EpcExpiresSoonAlertData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epcExpiryDates"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MissingMeterDataAlertData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lastReading"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetAddressQuery, GetAssetAddressQueryVariables>;
export const CreateSingleLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSingleLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSingleLocationMutation, CreateSingleLocationMutationVariables>;
export const UpdateSingleLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSingleLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOneLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"buildingArea"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"saleDate"}},{"kind":"Field","name":{"kind":"Name","value":"legalOwner"}},{"kind":"Field","name":{"kind":"Name","value":"management"}}]}}]}}]} as unknown as DocumentNode<UpdateSingleLocationMutation, UpdateSingleLocationMutationVariables>;
export const CreateManyIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateManyIntegrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationIntegrations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssetIntegrationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManyLocationIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationIntegrations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationIntegrations"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"municipality"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"building"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateManyIntegrationsMutation, CreateManyIntegrationsMutationVariables>;
export const GetOrgDataForOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrgDataForOnboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"internalDescriptor"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dexmaId"},"name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"municipality"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"building"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationVitaniLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationTechemLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcUkLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingType"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrgDataForOnboardingQuery, GetOrgDataForOnboardingQueryVariables>;
export const GetLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLocationsQuery, GetLocationsQueryVariables>;
export const CreateManyAssessmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateManyAssessments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateManyAssessmentsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManyAssessments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateManyAssessmentsMutation, CreateManyAssessmentsMutationVariables>;
export const CreateAssessmentOriginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssessmentOrigin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneAssessmentOriginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneAssessmentOrigin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAssessmentOriginMutation, CreateAssessmentOriginMutationVariables>;
export const UploadFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<UploadFileMutation, UploadFileMutationVariables>;
export const UpsertManyLocationMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertManyLocationMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLocationMetadataInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertManyLocationMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}}]}}]} as unknown as DocumentNode<UpsertManyLocationMetadataMutation, UpsertManyLocationMetadataMutationVariables>;
export const AddLocationIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddLocationIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssetIntegrationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addLocationIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddLocationIntegrationMutation, AddLocationIntegrationMutationVariables>;
export const DeleteLocationIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLocationIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteLocationIntegrationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLocationIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}}]}}]}}]} as unknown as DocumentNode<DeleteLocationIntegrationMutation, DeleteLocationIntegrationMutationVariables>;
export const UpdateLocationIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocationIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyLocationIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endedAt"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedCount"}}]}}]}}]} as unknown as DocumentNode<UpdateLocationIntegrationMutation, UpdateLocationIntegrationMutationVariables>;
export const DeleteLocationIntegrationByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLocationIntegrationByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyLocationIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}}]}}]}}]} as unknown as DocumentNode<DeleteLocationIntegrationByIdsMutation, DeleteLocationIntegrationByIdsMutationVariables>;
export const GetIntegrationsTypesForOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIntegrationsTypesForOnboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationTypesForOnboarding"}}]}}]} as unknown as DocumentNode<GetIntegrationsTypesForOnboardingQuery, GetIntegrationsTypesForOnboardingQueryVariables>;
export const GetDexmaMeterLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDexmaMeterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForDexmaIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DexmaMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialLocationIntegrationsState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DexmaMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DexmaMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DexmaLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activity"}},{"kind":"Field","name":{"kind":"Name","value":"reference_devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"nationalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationTechemLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationVitaniLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationHoforLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDexmaMeterLocationsQuery, GetDexmaMeterLocationsQueryVariables>;
export const GetTechemMeterLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTechemMeterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForTechemIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechemMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialLocationIntegrationsState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechemMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechemMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TechemLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"nationalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationTechemLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationVitaniLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationHoforLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTechemMeterLocationsQuery, GetTechemMeterLocationsQueryVariables>;
export const GetVitaniMeterLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVitaniMeterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForVitaniIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaniMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialLocationIntegrationsState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaniMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaniMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VitaniLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"DirectoryID"}},{"kind":"Field","name":{"kind":"Name","value":"BuildingID"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"nationalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationTechemLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationVitaniLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationHoforLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVitaniMeterLocationsQuery, GetVitaniMeterLocationsQueryVariables>;
export const GetHoforMeterLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHoforMeterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForHoforIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HoforMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialLocationIntegrationsState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HoforMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HoforMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HoforLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"nationalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationTechemLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationVitaniLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationHoforLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetHoforMeterLocationsQuery, GetHoforMeterLocationsQueryVariables>;
export const GetEntolabsMeterLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEntolabsMeterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForEntolabsIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntolabsMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialLocationIntegrationsState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntolabsMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntolabsMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntolabsLocationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entolabsOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"meterId"}},{"kind":"Field","name":{"kind":"Name","value":"meterName"}},{"kind":"Field","name":{"kind":"Name","value":"meterType"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"siteName"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"nationalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationTechemLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationVitaniLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationHoforLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEntolabsMeterLocationsQuery, GetEntolabsMeterLocationsQueryVariables>;
export const GetOisMeterLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOisMeterLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationType"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"nationalIdentifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationOisLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bbr"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOisMeterLocationsQuery, GetOisMeterLocationsQueryVariables>;
export const GetElectralinkMeterLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetElectralinkMeterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForElectralinkIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ElectralinkMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialLocationIntegrationsState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ElectralinkMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ElectralinkMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ElectralinkLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"hashedMPAN"}},{"kind":"Field","name":{"kind":"Name","value":"partialMPAN"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"buildings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortAddress"}},{"kind":"Field","name":{"kind":"Name","value":"longAddress"}},{"kind":"Field","name":{"kind":"Name","value":"nationalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationTechemLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationVitaniLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directoryId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationHoforLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetElectralinkMeterLocationsQuery, GetElectralinkMeterLocationsQueryVariables>;
export const GetSoftvaerketMeterLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSoftvaerketMeterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForSoftvaerket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SoftvaerketMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialLocationIntegrationsState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SoftvaerketMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SoftvaerketMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SoftvaerketMeter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}}]}}]} as unknown as DocumentNode<GetSoftvaerketMeterLocationsQuery, GetSoftvaerketMeterLocationsQueryVariables>;
export const GetEloverblikMeterLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEloverblikMeterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForEloverblik"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EloverblikMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initialLocationIntegrationsState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meterLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EloverblikMeterLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EloverblikMeterLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EloverblikMeter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meteringPointId"}},{"kind":"Field","name":{"kind":"Name","value":"meterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"meterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"typeOfMP"}},{"kind":"Field","name":{"kind":"Name","value":"consumerStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"parentMeteringPointId"}}]}}]} as unknown as DocumentNode<GetEloverblikMeterLocationsQuery, GetEloverblikMeterLocationsQueryVariables>;
export const AddOrganizationIntegrationWithDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddOrganizationIntegrationWithData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integrationData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationIntegrationData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOrganizationIntegrationWithData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"integrationData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integrationData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddOrganizationIntegrationWithDataMutation, AddOrganizationIntegrationWithDataMutationVariables>;
export const AddOrganizationIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddOrganizationIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOneOrganizationIntegrationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneOrganizationIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddOrganizationIntegrationMutation, AddOrganizationIntegrationMutationVariables>;
export const GetOrganizationIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integrationType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedIntegrationForOnboarding"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrganizationIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"integrationType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integrationType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationIntegrationQuery, GetOrganizationIntegrationQueryVariables>;
export const GetEntolabsOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEntolabsOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entolabsOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetEntolabsOrganizationsQuery, GetEntolabsOrganizationsQueryVariables>;
export const GetLocationIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationIntegrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationElectralinkLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"partialMpan"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationSoftvaerketAssetIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEloverblikAssetIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"meteringPointId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLocationIntegrationsQuery, GetLocationIntegrationsQueryVariables>;
export const GetOrganizationIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationIntegrationsQuery, GetOrganizationIntegrationsQueryVariables>;
export const CreateOrganizationIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganizationIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneOrganizationIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationIntegration"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOrganizationIntegrationMutation, CreateOrganizationIntegrationMutationVariables>;
export const UpdateOrganizationIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOneOrganizationIntegrationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneOrganizationIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationIntegrationMutation, UpdateOrganizationIntegrationMutationVariables>;
export const GetEloverblikCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEloverblikCustomers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEloverblikCustomers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerCVR"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}}]}}]}}]} as unknown as DocumentNode<GetEloverblikCustomersQuery, GetEloverblikCustomersQueryVariables>;
export const ActiveOrgIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveOrgIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActiveOrgIntegrationsQuery, ActiveOrgIntegrationsQueryVariables>;
export const CreateOrganizationIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganizationIntegrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createManyOrganizationIntegrations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateManyOrganizationIntegrationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManyOrganizationIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createManyOrganizationIntegrations"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<CreateOrganizationIntegrationsMutation, CreateOrganizationIntegrationsMutationVariables>;
export const GetSavedReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSavedReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"framework"}},{"kind":"Field","name":{"kind":"Name","value":"segmentName"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAssets"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSavedReportsQuery, GetSavedReportsQueryVariables>;
export const DeleteReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteReportMutation, DeleteReportMutationVariables>;
export const UpdateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOneReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateReportMutation, UpdateReportMutationVariables>;
export const CreateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"framework"}},{"kind":"Field","name":{"kind":"Name","value":"segmentName"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAssets"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateReportMutation, CreateReportMutationVariables>;
export const GetAssetRiskPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetRiskPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetGroupFilterInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crremCategories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrremCategory"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectedFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectedTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssetGroupPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"constructionDate"}},{"kind":"Field","name":{"kind":"Name","value":"crremPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"ownedArea"}},{"kind":"Field","name":{"kind":"Name","value":"emissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Year"}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"EnumValue","value":"COMBINED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectedEmissionSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectedFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectedTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregation"},"value":{"kind":"EnumValue","value":"Year"}},{"kind":"Argument","name":{"kind":"Name","value":"dataType"},"value":{"kind":"EnumValue","value":"COMBINED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}},{"kind":"Field","name":{"kind":"Name","value":"ownedEnergy"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getCrremPathways"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crremCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"countries"},"value":{"kind":"StringValue","value":"DK","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"versions"},"value":{"kind":"StringValue","value":"v203","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crremCategory"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<GetAssetRiskPreviewQuery, GetAssetRiskPreviewQueryVariables>;
export const GetAssetEsgActionPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetEsgActionPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"buildingArea"}},{"kind":"Field","name":{"kind":"Name","value":"dgnbCertification"}},{"kind":"Field","name":{"kind":"Name","value":"epcs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetEsgActionPlanQuery, GetAssetEsgActionPlanQueryVariables>;
export const GetAssetPropertySizeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetPropertySize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildingAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"floorAreaType"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetPropertySizeQuery, GetAssetPropertySizeQueryVariables>;
export const GetLegacyNextAssetBenchmarksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyNextAssetBenchmarks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyNextAssetBenchmarks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bfe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfBuildings"}},{"kind":"Field","name":{"kind":"Name","value":"co2BenchmarkMethod1"}},{"kind":"Field","name":{"kind":"Name","value":"bfe"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkType"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkId"}}]}}]}}]} as unknown as DocumentNode<GetLegacyNextAssetBenchmarksQuery, GetLegacyNextAssetBenchmarksQueryVariables>;
export const GetAssetIntensityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetIntensity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIntensity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"factor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetIntensityQuery, GetAssetIntensityQueryVariables>;
export const GetAssetIntensityChartDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssetIntensityChartData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrremCategory"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIntensityChartData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"energyIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"emissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"projectedEmissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"projectedEnergyIntensity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getCrremPathways"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categories"}}},{"kind":"Argument","name":{"kind":"Name","value":"countries"},"value":{"kind":"StringValue","value":"DK","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"versions"},"value":{"kind":"StringValue","value":"v203","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"crremCategory"}}]}}]}}]} as unknown as DocumentNode<GetAssetIntensityChartDataQuery, GetAssetIntensityChartDataQueryVariables>;
export const GetLegacyNextAssetMaterialsLifespanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyNextAssetMaterialsLifespan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyNextAssetMaterialsLifespan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bfe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bfe"}},{"kind":"Field","name":{"kind":"Name","value":"roofCoverMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"renovationYear"}},{"kind":"Field","name":{"kind":"Name","value":"outerWallMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"heatInstallation"}},{"kind":"Field","name":{"kind":"Name","value":"constructionYear"}},{"kind":"Field","name":{"kind":"Name","value":"buildingId"}},{"kind":"Field","name":{"kind":"Name","value":"outerWallMaterialLifetime"}}]}}]}}]} as unknown as DocumentNode<GetLegacyNextAssetMaterialsLifespanQuery, GetLegacyNextAssetMaterialsLifespanQueryVariables>;
export const GetLegacyNextAssetOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyNextAssetOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyNextAssetOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bfe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bfe"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}},{"kind":"Field","name":{"kind":"Name","value":"administratorName"}}]}}]}}]} as unknown as DocumentNode<GetLegacyNextAssetOwnershipQuery, GetLegacyNextAssetOwnershipQueryVariables>;
export const GetLegacyNextAssetSalesPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyNextAssetSalesPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyNextAssetSalesPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bfe"}},{"kind":"Field","name":{"kind":"Name","value":"salesPrice"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"salesDate"}}]}}]}}]} as unknown as DocumentNode<GetLegacyNextAssetSalesPriceQuery, GetLegacyNextAssetSalesPriceQueryVariables>;
export const GetLegacyNextAssetWaterSupplierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyNextAssetWaterSupplier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyNextAssetWaterSupplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bfe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bfe"}},{"kind":"Field","name":{"kind":"Name","value":"waterSupplier"}}]}}]}}]} as unknown as DocumentNode<GetLegacyNextAssetWaterSupplierQuery, GetLegacyNextAssetWaterSupplierQueryVariables>;
export const EpcSummariesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EpcSummaries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bfes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEpcSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bfes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bfes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bfe"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCodeAndCity"}},{"kind":"Field","name":{"kind":"Name","value":"allProposalClassification"}},{"kind":"Field","name":{"kind":"Name","value":"profitableProposalClassification"}},{"kind":"Field","name":{"kind":"Name","value":"proposals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"renovationTime"}},{"kind":"Field","name":{"kind":"Name","value":"profitability"}},{"kind":"Field","name":{"kind":"Name","value":"investmentLifetime"}},{"kind":"Field","name":{"kind":"Name","value":"investment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"emissionSaving"}},{"kind":"Field","name":{"kind":"Name","value":"energySaving"}},{"kind":"Field","name":{"kind":"Name","value":"costSaving"}}]}}]}}]}}]} as unknown as DocumentNode<EpcSummariesQuery, EpcSummariesQueryVariables>;
export const GetLegacyNextAssetHeatInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyNextAssetHeatInstallation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyNextAssetHeatInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bfe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bfe"}},{"kind":"Field","name":{"kind":"Name","value":"heatInstallation"}}]}}]}}]} as unknown as DocumentNode<GetLegacyNextAssetHeatInstallationQuery, GetLegacyNextAssetHeatInstallationQueryVariables>;
export const GetConsumptionChartDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConsumptionChartData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getConsumptionChartData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreakdownItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"energy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreakdownItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectedEmission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreakdownItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectedEnergy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreakdownItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getLegacyNextAssetBenchmarks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bfe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bfe"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"co2BenchmarkMethod1"}},{"kind":"Field","name":{"kind":"Name","value":"kwhMethod1"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkType"}},{"kind":"Field","name":{"kind":"Name","value":"startTs"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreakdownItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsumptionBreakdownItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"emission"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]} as unknown as DocumentNode<GetConsumptionChartDataQuery, GetConsumptionChartDataQueryVariables>;
export const GetLegacyNextAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyNextAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyNextAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InsightsPropertyTree"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InsightsPropertyTree"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InsightsPropertyTree"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InsightsPropertyTree"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InsightsPropertyTree"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InsightsPropertyTree"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InsightsPropertyTree"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"crremPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"constructionYear"}},{"kind":"Field","name":{"kind":"Name","value":"nationalPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]} as unknown as DocumentNode<GetLegacyNextAssetQuery, GetLegacyNextAssetQueryVariables>;
export const GetAssetRiskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetRisk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crremCategories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrremCategory"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssetRiskChartData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"propertyIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyId"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"energyIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"projectedEmissionIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"projectedEnergyIntensity"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getCrremPathways"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crremCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"countries"},"value":{"kind":"StringValue","value":"DK","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"versions"},"value":{"kind":"StringValue","value":"v203","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crremCategory"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}}]}}]} as unknown as DocumentNode<GetAssetRiskQuery, GetAssetRiskQueryVariables>;
export const GetLegacyNextAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyNextAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchFiltersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyNextAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"assetExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"crremPropertyType"}},{"kind":"Field","name":{"kind":"Name","value":"crremPropertyTypes"}},{"kind":"Field","name":{"kind":"Name","value":"constructionYear"}}]}}]}}]} as unknown as DocumentNode<GetLegacyNextAssetsQuery, GetLegacyNextAssetsQueryVariables>;
export const UpdateMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMe"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateMeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMe"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateMeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<UpdateMeMutation, UpdateMeMutationVariables>;
export const GetDataOverviewEpcAssessmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDataOverviewEPCAssessments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetEPCData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetEPCData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"saleDate"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ignoreProxy"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"EnumValue","value":"ESTIMATE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"areaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalArea"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumptionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalConsumption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addresses"}},{"kind":"Field","name":{"kind":"Name","value":"nationalBuildingIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataGrams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcAssessmentData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epcIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"originalPdfLink"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcUkAssessmentData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lmkKey"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDataOverviewEpcAssessmentsQuery, GetDataOverviewEpcAssessmentsQueryVariables>;
export const GetAssetEpcDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetEPCData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetEPCData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetEPCData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"saleDate"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ignoreProxy"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"EnumValue","value":"ESTIMATE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"vertical"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"areaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalArea"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumptionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalConsumption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addresses"}},{"kind":"Field","name":{"kind":"Name","value":"nationalBuildingIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionDataGrams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedEmission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcAssessmentData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epcIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"originalPdfLink"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationEpcUkAssessmentData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lmkKey"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetEpcDataQuery, GetAssetEpcDataQueryVariables>;
export const GetAssetIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssetIntegrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"EPC"},{"kind":"EnumValue","value":"EPC_UK"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationDexmaLocationIntegrationData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"originId"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionTypes"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetIntegrationsQuery, GetAssetIntegrationsQueryVariables>;
export const DeleteAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAssessmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAssessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>;
export const GetLegacyBenchmarksByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyBenchmarksByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valueType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LegacyBenchmarkValueType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyBenchmarksByAssetId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkType"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfBuildings"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valueType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetLegacyBenchmarksByAssetIdQuery, GetLegacyBenchmarksByAssetIdQueryVariables>;
export const GetOrganizationBenchmarksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationBenchmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benchmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"emissionPerArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bestEffort"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benchmark"}}]}},{"kind":"Field","name":{"kind":"Name","value":"epc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benchmark"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benchmark"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationBenchmarksQuery, GetOrganizationBenchmarksQueryVariables>;
export const GetLegacyBenchmarksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyBenchmarks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valueType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LegacyBenchmarkValueType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLegacyBenchmarks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkType"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfBuildings"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valueType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetLegacyBenchmarksQuery, GetLegacyBenchmarksQueryVariables>;
export const GetMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"reportingYear"}},{"kind":"Field","name":{"kind":"Name","value":"baselineYear"}},{"kind":"Field","name":{"kind":"Name","value":"allLocationsCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>;